<template>
    <div class="container-fluid" id="dvcrud">
		<detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="crotinacortes"></detalhespedido>
		<informacoescliente v-bind:id="idclienteinf" 
			v-bind:nomecliente="nomeclienteinf"
			v-bind:vlcredito="vlcreditoinf">
		</informacoescliente>
        <div id="dvimagens" class="row" style="display: none;">
            <div class="col-md-12">
                <viewer :images="images" rebuild class="viewer">
                    <img v-for="src in images" :key="src" :src="src">
                </viewer>                            
            </div>
        </div>        		
        <div class="row">
			<consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa" v-bind:incmassa="true"></consultaprodutos>
			<consultaclientes></consultaclientes>
			<etiquesvolumespedido v-bind:pedido="pedidomenu"></etiquesvolumespedido>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pidpedido" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Parceiro cliente:</span>
								<select id="cbclientepesq" data-placeholder="Selecione um cliente" v-model="pidcliente" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Vendedor:</span>
								<select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" v-model="pidvendedor" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Rota:</span>
								<select id="cbrotapesq" data-placeholder="Selecione uma rota" v-model="pidrota" data-allow-clear="true" style="width:100%;">
								</select>
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Plano de pgto:</span>
								<select id="cbplanopesq" data-placeholder="Selecione um plano" v-model="pidplano" data-allow-clear="true" style="width:100%;">
								</select>
							</div>														
                            <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                <label for="cbtipopesq">Tipo:</label>
                                <select name="cbtipopesq" class="form-control form-control-sm" id="cbtipopesq" v-model="ptipo" @change="mtdlimpar_listagem()">
                                    <option value="0">Pedidos</option>
                                    <option value="1">Orçamentos</option>
                                    <option value="2">Ordens de serviço</option>
									<option value="3">Cashback</option>
                                    <option value="4">Todos</option>
									<option value="5">Exceto cashback</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="edidentificadorospesq">Identificador:</label>
								<input type="text" class="form-control form-control-sm" id="edidentificadorospesq" 
								style="text-transform: uppercase;"
								v-model="pidentificador" data-bv-group=".group" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edresponsavelpesq">Responsável:</label>
								<input type="text" class="form-control form-control-sm" id="edresponsavelpesq" v-model="presponsavel" data-bv-group=".group" maxlength="20">
							</div>														
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltropor">Por:</label>
								<select class="form-control form-control-sm" id="cbfiltropor" v-model="pfiltropor" v-bind:disabled="hab_desab_periodo">
									<option value="0">Emissão</option>
									<option value="1">Fatura</option>
									<option value="2">Retorno</option>
								</select>
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>							
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Abertos</option>
                                    <option value="1">Faturados</option>
                                    <option value="2">Cancelados</option>
                                    <option value="3">Todos</option>
                                </select>
                            </div>							
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbentregaexternapesq">Extrega:</label>
                                <select name="cbentregaexternapesq" class="form-control form-control-sm" id="cbentregaexternapesq" v-model="pentregaexterna" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <div v-if="parseInt(pentregaexterna) === 1" class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaoentrega">Finalizada:</label>
                                <select name="cbsituacaoentrega" class="form-control form-control-sm" id="cbsituacaoentrega" v-model="psituacaoentrega" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Forma de pgto:</span>
								<select id="cbformapesq" data-placeholder="Selecione uma forma" v-model="pidforma" data-allow-clear="true" style="width:100%;">
								</select>
							</div>							
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbcredito">Pedidos c/ crédito:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbcredito" v-model="pcredito" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>		
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cborigem">Origem:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cborigem" v-model="porigem" @change="mtdlimpar_listagem()">
                                    <option value="0">Web</option>
                                    <option value="5">App</option>
                                    <option value="10">Todos</option>
                                </select>
                            </div>																																	
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbqtdreg">Itens exibidos:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                            <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>
                            <div id="dvlistagempedidos" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table  ref="reflstpedidos"
						
										@on-select-row="mtdprocessaselecionados()"
                                        @on-unselect-row="mtdprocessaselecionados()"
                                        @on-all-select-rows="mtdprocessaselecionados()"
                                        @on-all-unselect-rows="mtdprocessaselecionados()"
                                       
                                        :rows="lstpedidos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->									
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>
                                    </template>
                                    <template slot="slot_detalhes" slot-scope="item">
                                        <i @click.prevent="mtddetalhespedido(item.row.id)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i>
                                    </template>																		
                                    <template slot="id_f" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ mtdformatarzeros(item.row.id, 8) }} </span>
                                        <i v-if="parseInt(item.row.liberarpdv) === 1" class="fa fa-unlock" style="color: #5A956A;" title="Liberado para o PDV"></i>
										<i v-else class="fa fa-lock" style="color: #EEA435;" title="Bloqueado para o PDV"></i>
										<i v-if="parseInt(item.row.origem) === 5" class="fa fa-tablet icone-origem" title="Pedido realizado pelo app"></i>										
										<i v-if="parseInt(item.row.entregaexterna) === 1" class="fa fa-paper-plane-o icone-entrega-lista" title="Logística externa"></i>
										<i v-if="parseInt(item.row.entregaexternafinalizada) === 1" class="fa fa-check icone-entregafinalizada" title="Entrega finalizada"></i>

										<span v-if="parseFloat(item.row.vlcredito) === 0 && parseFloat(item.row.vlcreditoutilizado) === 0"></span>
										<span v-else-if="parseFloat(item.row.vlcredito) > 0 && parseFloat(item.row.vlcreditoutilizado) === 0" class="bdg-credito-disponivel badge badge-pill badge-success" title="Crédito diponível" @click.prevent="mtdmostradetcred(item.row)"><i class="fa fa-dollar"></i></span>
										<span v-else-if="parseFloat(item.row.vlcreditoutilizado) >= parseFloat(item.row.vlcredito)" class="bdg-credito-utilizado badge badge-pill badge-secondary" title="Crédito já utilizado" @click.prevent="mtdmostradetcred(item.row)"><i class="fa fa-dollar"></i></span>										
										<span v-else-if="parseFloat(item.row.vlcredito) > 0 && parseFloat(item.row.vlcreditoutilizado) > 0" class="bdg-credito-saldo badge badge-pill badge-info"  title="Saldo de crédito à utilizar" @click.prevent="mtdmostradetcred(item.row)"><i class="fa fa-dollar"></i></span>

                                        <span v-if="parseInt(item.row.conferido) === 1" title="Conferência finalizada"><i class="fa fa-check-square-o" style="color: #5a956a; font-weight: 600; font-size: 18px; margin-left: 3px;"></i></span>
                                        <span v-else-if="parseInt(item.row.confiniciada) === 1" title="Conferência iniciada"><i class="fa fa-list-ol" style="color: #EEA435; font-size: 18px;  margin-left: 3px;"></i></span>
										
										<span v-if="(parseFloat(item.row.vlcreditodisponivel) < parseFloat(item.row.totalgeral) && parseInt(item.row.tipoplano) === 1) || (parseInt(item.row.atraso) - parseInt(item.row.qtddiasbloqvenda) > 0)" 
											title="Possíveis pendências: - Cliente com limite de crédito insuficiente; - Débitos em atraso.">
											<i class="fa fa-exclamation-circle" style="color: #c91212; font-weight: 600; font-size: 18px; margin-left: 3px;"></i>
											<i v-if="parseInt(item.row.liberarfat) === 1" class="fa fa-check" style="position: relative; color: #0acf97; font-weight: 600; font-size: 18px; top: -4px; left: -10px;" title="Liberado para faturamento"></i>											
										</span>																				
                                    </template>

                                    <template slot="slot_tipo" slot-scope="item">										
                                        <template v-if="parseInt(item.row.tipo) === 0">
											<span class="badge badge-primary badge-pill" style="background-color: #6BA2D0;">PEDIDO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.tipo) === 1">
											<span class="badge badge-primary badge-pill" style="background-color: #EEA435;">ORÇAMENTO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.tipo) === 2">
											<span class="badge badge-primary badge-pill" style="background-color: #A42F11;">O. S.</span>
                                        </template>										
                                        <template v-else>
											<span class="badge badge-primary badge-pill" style="background-color: #74A82A;">CASHBACK</span>
                                        </template>										
                                    </template>

                                    <template slot="slot_stpedido" slot-scope="item">
                                        <template v-if="parseInt(item.row.stpedido) === 0">
											<span class="badge badge-primary badge-pill">ABERTO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.stpedido) === 1">
											<span class="badge badge-secondary badge-pill" style="background-color: #5A956A;">FATURADO</span>
                                        </template>
                                        <template v-else>
											<span class="badge badge-danger badge-pill">CANCELADO</span>
                                        </template>										
                                    </template>
                                    <template slot="slot_dtemissao" slot-scope="item">
                                        <!-- <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtemissao }}</span> -->
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.dtregistro }}</span>
                                    </template>	
                                    <template slot="slot_dtfatura" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtfatura }}</span>
                                    </template>									
									<template slot="slot_cliente" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: 600;"><i @click.prevent="mtdinformacoescliente(item.row.idcliente, item.row.nomecliente, item.row.vlcreditoclli)" class="fa fa-info-circle icon-detalhes" title="Detalhes do cliente" style="color: #4250f2; font-size: 18px;"></i> {{ item.row.idcliente }} - {{ item.row.nomecliente }}</span>
									</template>											
									<template slot="slot_filial" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.fantasia }}</span>
									</template>															
									<template slot="slot_vendedor" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.nomevendedor }}</span>
									</template>
									<template slot="slot_plano" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.descplano }}</span>
									</template>
									<template slot="slot_identificador" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.identificador }}</span>
									</template>																		
									<template slot="slot_serie" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.serie }}</span>
									</template>									
									<template slot="slot_retorno" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.dtretorno }}</span>
									</template>									
									<template slot="slot_totalgeral" slot-scope="item">										
										<span v-if="parseInt(item.row.tipo) !== 3" style="color: #6c757d; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalgeral), 2) }}</span>
										<span v-else style="color: #74A82A; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.vlcredito) - parseFloat(item.row.vlcreditoutilizado), 2) }}</span>
									</template>																						
									<template slot="slot_totalcusto" slot-scope="item">
										<span style="color: #f82b54; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalcusto), 2) }}</span>
									</template>
									<template slot="slot_formas" slot-scope="item">
										<ul class="list-group">
											<li v-for="(forma, indexf) in item.row.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
												<span v-if="parseInt(forma.qtdparcelascartao) > 0" class="lblforma">{{forma.descricao}}({{forma.qtdparcelascartao}})</span>
												<span v-else class="lblforma">{{forma.descricao}}</span>
												<span class="lblforma">{{mtdformatavalordecimal(parseFloat(forma.vlforma) - parseFloat(forma.vltroco), 2)}}</span>
											</li>
										</ul>										
									</template> 
                                    <template slot="slot_desconto" slot-scope="item">
                                        <span v-if="parseFloat(item.row.totaldesconto) > 0" style="color: #5c8f94; font-weight: bold; font-size: 10px;">({{ item.row.percdesconto }}%) {{ mtdformatavalordecimal(parseFloat(item.row.totaldesconto), 2) }}</span>
										<span v-else></span>
                                    </template>																																						
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12" style="margin-bottom: 10px;">
                                <div class="draco-kpi-card draco-kpi-single">
                                    <span class="draco-kpi-label">Itens exibidos carregados</span>
                                    <span class="draco-kpi-value">{{lstpedidos.length}}</span>
                                </div>
                            </div>	
								<div class="col-md-12" v-show="pvisualizartotalizadores && lstpedidos.length > 0">
									<div class="row">
										<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
											<div class="draco-kpi-card">
												<span class="draco-kpi-label">Total aberto ({{ pqa }})</span>
												<span class="draco-kpi-money">{{ mtdformatavalordecimal(ptotalaberto, 2) }}</span>
											</div>
										</div>
										<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
											<div class="draco-kpi-card draco-kpi-success">
												<span class="draco-kpi-label">Total faturado ({{ pqf }})</span>
												<span class="draco-kpi-money">{{ mtdformatavalordecimal(ptotalfaturado, 2) }}</span>
											</div>
										</div>
										<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
											<div class="draco-kpi-card draco-kpi-danger">
												<span class="draco-kpi-label">Total cancelado ({{ pqc }})</span>
												<span class="draco-kpi-money">{{ mtdformatavalordecimal(ptotalcancelado, 2) }}</span>
											</div>
										</div>
										<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
											<div class="draco-kpi-card draco-kpi-cyan">
												<span class="draco-kpi-label">Desconto ({{mtdformatavalordecimal(ptotaldescontoperc, 2)}}%)</span>
												<span class="draco-kpi-money">{{ mtdformatavalordecimal(ptotaldesconto, 2) }}</span>
											</div>
										</div>
										<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
											<div class="draco-kpi-card draco-kpi-lime">
												<span class="draco-kpi-label">Cashback ({{ pqca }})</span>
												<span class="draco-kpi-money">{{ mtdformatavalordecimal(ptotalcreditos, 2) }}</span>
											</div>
										</div>
										<div v-if="pvisualizarcustos" class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
											<div class="draco-kpi-card draco-kpi-rose">
												<span class="draco-kpi-label">Total custo</span>
												<span class="draco-kpi-money">{{ mtdformatavalordecimal(ptotalcusto, 2) }}</span>
											</div>
										</div>																																				
									</div>
								</div>														
                        </div>												
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
							<div class="col-12 col-sm-4 col-md-8 col-lg-8" id="dvpaginacao">
							<v-pagination
									v-model="pagina_atual"
									:page-count="pqtd_paginas"
									:classes="bootstrapPaginationClasses">
							</v-pagination>
							</div>
							<div class="col-12 col-sm-4 col-md-2 col-lg-2">
								<div class="dropdown">
									<button type="button" class="btn btn-secondary btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
										<i class="fa fa-navicon"></i> Outras
									</button>
									<div class="dropdown-menu">
										<a class="dropdown-item" href="#" @click.prevent="mtdimpressao(0)"><i class="fa fa-print"></i> Imprimir</a>
										<a class="dropdown-item" href="#" @click.prevent="mtdimpressao(1)"><i class="fa fa-file-excel-o"></i> Exportar excel</a>
										<a v-if="crotinacortes" class="dropdown-item" href="#" @click.prevent="mtdanalisecortes()"><i class="fa fa-leanpub"></i> Rotina de cortes</a>
										<a v-if="crotinacortes" class="dropdown-item" href="#" @click.prevent="mtditenscortados()"><i class="fa fa-print"></i> Imprimir itens cortados</a>
										<a class="dropdown-item" href="#" @click.prevent="mtdcreditoavulso()"><i class="fa fa-dollar"></i> Crédito avulso</a>		
										<a v-if="vpedidosselecionados.length > 0" class="dropdown-item" href="#" @click.prevent="mtddimprimeguia()"><i class="fa fa-clone"></i> Imprimir guias de separação</a>																	
									</div>
								</div>								
							</div>							
								
	                        </div>
	                    </div>					
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <label for="edid">Nr. Pedido:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="cbtipo">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipo" v-model="vtipo" v-bind:disabled="ativadesativa">
									<option value="0">Pedido</option>
									<option value="1">Orçamento</option>
									<option value="2">Ordem de serviço</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtemissao">*Data Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-6 col-lg-3">
								<span class="lblselect2">*Vendedor:</span>
								<select id="cbvendedor" data-placeholder="Selecione um vendedor" v-model="vidvendedor" v-bind:disabled="ativadesativavendedor" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcliente">*Parceiro cliente:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edcliente" v-model="vidcliente" v-bind:disabled="ativadesativa" maxlength="11" v-on:blur="mtdlocalizarcliente(vidcliente)">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarcliente()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
								<label for="ednomecliente">Nome do cliente:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="ednomecliente" v-model="vnomecliente"
										data-bv-group=".group" maxlength="50" disabled style="font-weight: bold;"/>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdinformacoescliente(vidcliente, vnomecliente, vvlcreditoclidet)" title="Detalhes do cliente"><i class="fa fa-info-circle" style="padding-top: 3px;"></i></a>
									</div>										
								</div>	
							</div>							
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">                            
                                <div class="custom-control custom-switch border rounded" style="margin-top: 20px;padding: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbentregaexterna" v-model="ventregaexterna" v-bind:disabled="ativadesativa">
                                    <label class="custom-control-label" for="cbentregaexterna" id="lblentregar" style="margin-left: 40px;">Logística externa<i class="fa fa-paper-plane-o" id="icone-entregar"></i></label>
                                </div>
                            </div> 														
								<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3" id="dvplano">
									<div class="card card-plano-pedido">
										<div class="card-body">
											<label for="cbplano" class="mb-1"><strong>*Plano financeiro:</strong></label>
											<select id="cbplano" class="form-control form-control-sm"
												v-model="vidplano"
												v-bind:disabled="ativadesativa || vidcliente === '' || lstplanos.length === 0"
												@change="mtdalteraplano(vidplano)">
												<option :value="null" disabled>Selecione um plano</option>
												<option v-for="(plano, idxpl) in lstplanos" v-bind:key="idxpl" :value="parseInt(plano.id)">{{ mtdformatarzeros(plano.id, 2) }} - {{ plano.descricao }}</option>
											</select>
											<small class="text-muted d-block mt-1" v-if="vdescplano !== ''">Selecionado: {{ vdescplano }}</small>
											<button type="button" class="btn btn-outline-secondary btn-sm btn-block mt-2"
												v-bind:disabled="ativadesativa || vidcliente === '' || lstplanos.length === 0"
												@click.prevent="mtdselecionarplano()">
												<i class="fa fa-list"></i> Ver lista completa
											</button>
										</div>
									</div>
								</div>
                        </div>
						<div class="row" id="dvnav-tabs" style="margin-top: 15px;">
							<div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link nav-link-ped active" data-toggle="tab" href="#dvprodutos">Produtos</a>
                                    </li>
                                    <li v-if="parseInt(vtipo) > 0" class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvservicos">Serviços</a>
                                    </li>									
                                    <li v-if="parseInt(vtipo) === 2" class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvinformacoesos">Informações da O.S</a>
                                    </li>
									<li class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvobservacoes">Anotações</a>
                                    </li>									
								    <li v-if="parseInt(vtipo) === 2" class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvimagensped">Imagens</a>
                                    </li>																											
                                </ul>								
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
									<div id="dvprodutos" class="container-fluid tab-pane active">
										<div class="row">
											<div class="col-sm-12 col-md-2 col-lg-4 col-xl-6">
											</div>				
											<div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2" style="margin-bottom: 10px;">
												<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadcionaritem()"><i class="fa fa-plus"></i> Adicionar ítem</button>
											</div>											
											<div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2" style="margin-bottom: 10px;">
												<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdaplicardesconto()"><i class="fa fa-percent"></i> Aplicar Desconto <i class="fa fa-dollar"></i></button>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-bottom: 10px;">                            
												<div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
													<input type="checkbox" class="custom-control-input" id="cbreservar" v-model="vreservar" v-bind:disabled="ativadesativa">
													<label class="custom-control-label" for="cbreservar" id="lblreservar" style="margin-left: 40px;">Reservar itens</label>
												</div>
											</div> 																																								
											<div class="col-md-12">
												<vue-bootstrap4-table
														:rows="lstitens"
														:columns="columnsi"
														:config="config"
														:classes="classes">														
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem itens no pedido</div>
													</template>
													<!-- ícones de ordenação da table -->
													<template slot="sort-asc-icon">
														<i class="fa-icones-ordenacao fa fa-sort-asc"></i>
													</template>
													<template slot="sort-desc-icon">
														<i class="fa-icones-ordenacao fa fa-sort-desc"></i>
													</template>
													<template slot="no-sort-icon">
														<i class="fa-icones-ordenacao fa fa-unsorted"></i>
													</template>                                    
													<!--  -->													
													<template slot="opcoesi" slot-scope="item">
														<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-edit"></i></button>
														<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row.item)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
													</template>													
													<template slot="slot_item" slot-scope="item">
														{{ mtdformatarzeros(item.row.item, 3) }}
													</template>													
													<template slot="id_fi" slot-scope="item">
														{{ item.row.coddig }}
													</template>
													<template slot="slot_qtditem" slot-scope="item">
														{{ mtdformatavalordecimal(parseFloat(item.row.qtditem), 4) }}
													</template>
													<template slot="slot_qtdlevar" slot-scope="item">
														<span>{{ mtdformatavalordecimal(parseFloat(item.row.qtditem) - parseFloat(item.row.qtdentregar), 4) }}</span>
														<i v-if="parseFloat(item.row.qtdentregar) !== parseFloat(item.row.qtditem)" @click.prevent="mtdalterarqtdlevar(item.row)" class="fa fa-shopping-basket" style="color: #0acf97; margin-left: 5px; cursor: pointer;" title="Quantidade que o cliente vai levar. Clique para alterar!"></i>
														<i v-else @click.prevent="mtdalterarqtdlevar(item.row)" class="fa fa-shopping-basket text-black-50" style="margin-left: 5px; cursor: pointer;" title="Quantidade que o cliente vai levar. Clique para alterar!"></i>
													</template>													
													<template slot="slot_unditem" slot-scope="item">
														{{ item.row.unditem }}
													</template>
													<template slot="slot_vlunitarioitem" slot-scope="item">
														{{ mtdformatavalordecimal(parseFloat(item.row.vlunitario), 2) }}
													</template>
													<template slot="slot_valordescacres" slot-scope="item">
														<template v-if="parseFloat(item.row.valordescacres) > 0">
															<template v-if="parseInt(item.row.descacres) === 0">
																<template v-if="parseInt(item.row.tipodescacres) === 0">
																	- {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} (%)
																</template>
																<template v-else>
																	- {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} ($)
																</template>	
															</template>														
															<template v-else>
																<template v-if="parseInt(item.row.tipodescacres) === 0">
																	+ {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} (%)
																</template>
																<template v-else>
																	+ {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} ($)
																</template>															
															</template>
														</template>
													</template>
													<template slot="slot_vltotalitem" slot-scope="item">
														<i v-show="parseFloat(item.row.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.row.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
														<strong style="color: #6c757d;">
															{{ mtdformatavalordecimal(parseFloat(item.row.vltotal), 2) }}
														</strong>
													</template>													
												</vue-bootstrap4-table>
											</div>											
												<div v-show="parseInt(vtipo) > 0" class="col-md-12">
													<div class="draco-inline-total">
														<span class="draco-inline-total-label">Itens lançados</span>
														<span class="draco-inline-total-meta">{{mtdformatarzeros(lstitens.length, 3)}}</span>
														<span class="draco-inline-total-value">{{mtdformatavalordecimal(parseFloat(vtotalprodutos), 2)}}</span>
													</div>
												</div>											
											</div>
										</div>
										<div v-if="parseInt(vtipo) > 0" id="dvservicos" class="container-fluid tab-pane">
										<div v-show="parseInt(opcrud) < 3" class="row">
											<div  class="col-sm-12 col-md-7 col-lg-7">
												<span class="lblselect2">Serviço:</span>
												<select id="cbservico" data-placeholder="Selecione um serviço" v-model="vidservicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-5 col-lg-5">
												<span class="lblselect2">Técnico:</span>
												<select id="cbtecnico" data-placeholder="Selecione um técnico" v-model="vidtecnicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edqtdservedicao">Qtd:</label>
												<input type="number" class="form-control form-control-sm" id="edqtdservedicao" v-model="vqtdservicoedicao" v-bind="calculatotalserv" v-bind:disabled="ativadesativa" min="1" maxlength="11"/>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="cbtipodescontoservicoedicao">Tp. Descto.:</label>
												<select class="form-control form-control-sm" id="cbtipodescontoservicoedicao" v-model="vtipodescontoservicoedicao" v-bind:disabled="ativadesativa" v-bind="calculatotalserv">
													<option value="0">Percentual</option>
													<option value="1" >Valor</option>
												</select>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvalordescontoservicoedicao">{{ vtitdescserv }}</label>
												<money type="text" class="form-control form-control-sm" id="edvalordescontoservicoedicao" v-model="vvalordescontoservicoedicao" v-bind="[calculatotalserv, money]" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvlservicoedicao">Valor Unitário:</label>
												<money type="text" class="form-control form-control-sm" id="edvlservicoedicao" v-model="vvlservicoedicao" v-bind="money" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2">
												<label for="edvltotalservicoedicao">Total:</label>
												<money type="text" class="form-control form-control-sm" id="edvltotalservicoedicao" v-model="vvltotalservicoedicao" v-bind="[calculatotalserv, money]" readonly style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2" style="padding-top: 22px;">
												<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionarservico()" style="width: 100%;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12" style="margin-top: 10px;">
												<vue-bootstrap4-table
														:rows="lstservicos"
														:columns="columnss"
														:config="config"
														:classes="classes">
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem dados para visualização</div>
													</template>
													<template slot="id_f" slot-scope="item">
														{{ item.row.idservico }}
													</template>
													<template slot="slot_vlunitarioservico" slot-scope="item">
														{{ mtdformatavalordecimal(parseFloat(item.row.vlservico), 2) }}
													</template>
													<template slot="slot_valordescacres" slot-scope="item">
														<template v-if="parseFloat(item.row.valordesconto) > 0">
															<template v-if="parseInt(item.row.tipodesconto) === 0">
																{{ mtdformatavalordecimal(parseFloat(item.row.valordesconto), 2) }} (%)
															</template>
															<template v-else>
																{{ mtdformatavalordecimal(parseFloat(item.row.valordesconto), 2) }} ($)
															</template>																												
														</template>
													</template>
													<template slot="slot_qtditemserv" slot-scope="item">
														{{ item.row.qtdservico }}
													</template>
													<template slot="slot_vltotalservico" slot-scope="item">
														<strong style="color: #6c757d;">{{ mtdformatavalordecimal(parseFloat(item.row.vltotal), 2) }}</strong>
													</template>																																					
													<template slot="opcoes" slot-scope="item">
														<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluirservico(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
													</template>
												</vue-bootstrap4-table>
											</div>
												<div class="col-md-12">
													<div class="draco-inline-total">
														<span class="draco-inline-total-label">Serviços lançados</span>
														<span class="draco-inline-total-meta">{{mtdformatarzeros(lstservicos.length, 3)}}</span>
														<span class="draco-inline-total-value">{{mtdformatavalordecimal(parseFloat(vtotalservicos), 2)}}</span>
													</div>
												</div>											
											</div>
										</div>
										<div v-if="parseInt(vtipo) === 2" id="dvinformacoesos" class="container-fluid tab-pane">
										<div class="row">
											<div class="col-12 col-sm-12 col-md-12 col-lg-9">
												<div class="row">
													<!-- <div class="col-sm-12 col-md-3 col-lg-3">
														<label for="edresponsavelos">Responsável:</label>
														<input type="text" class="form-control form-control-sm" id="edresponsavelos" v-model="vresponsavel" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-2 col-lg-2">
														<label for="edfone">Fone:</label>
														<input type="text" v-model="vfone" v-bind:disabled="ativadesativa"
															class="form-control form-control-sm" id="edfone" 
															v-mask="['(##) ####-####', '(##) #####-####']">
													</div>											 -->
													<div class="col-sm-12 col-md-5 col-lg-5">
														<label for="edobjetoos">Objeto:</label>
														<input type="text" class="form-control form-control-sm" id="edobjetoos" v-model="vobjeto" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>																						
													<div class="col-sm-12 col-md-3 col-lg-3">
														<label for="edidentificadoros">Identificador:</label>
														<input type="text" class="form-control form-control-sm" id="edidentificadoros" v-model="videntificador" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>											
													<div class="col-sm-12 col-md-3 col-lg-3">
														<label for="edmarcacaoos">Marcação:</label>
														<input type="text" class="form-control form-control-sm" id="edmarcacaoos" v-model="vmarcacao" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-3 col-lg-3">
														<label for="ednrserieos">Número de série:</label>
														<input type="text" class="form-control form-control-sm" id="ednrserieos" v-model="vnrserie" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-4 col-lg-4">
														<label for="edmarcaos">Marca:</label>
														<input type="text" class="form-control form-control-sm" id="edmarcaos" v-model="vmarca" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-5 col-lg-5">
														<label for="edmodeloos">Modelo:</label>
														<input type="text" class="form-control form-control-sm" id="edmodeloos" v-model="vmodelo" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-12 col-lg-12">
														<label for="eddefeitoapresentadoos">Defeito apresentado:</label>
														<input type="text" class="form-control form-control-sm" id="eddefeitoapresentadoos" v-model="vdefeitoapresentado" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="100">
													</div>
													<div class="col-sm-12 col-md-12 col-lg-12">
														<label for="edacessoriosos">Acessórios:</label>
														<input type="text" class="form-control form-control-sm" id="edacessoriosos" v-model="vacessorios" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="100">
													</div>
													<div class="col-sm-12 col-md-12 col-lg-12">
														<label for="edoutrasinformacoesos">Outras informações:</label>
														<input type="text" class="form-control form-control-sm" id="edoutrasinformacoesos" v-model="voutrasinformacoes" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="100">
													</div>
												</div>
											</div>
											<div class="col-12 col-sm-12 col-md-12 col-lg-3">
												<div class="row">
													<div class="col-md-12" style="margin-top: 15px;">
														<ul class="list-group">
															<li class="list-group-item text-center text-black-50" style="padding: 5px;">
																<span style="font-size: 16px; font-weight: 600;">CHECKLIST</span>
																<i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodaschecklist" @click.prevent="mtdmarcartodaschecklist()" data-toggle="tooltip" title="Marcar/Desmarcar todas"></i>
															</li>
															<div style="height: 228px; overflow-y: auto;">
																<li v-for="(checkitem, index) in lstchecklist" @click.prevent="mtdhabilitachecklist(index)" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 10px 15px 10px 15px;">
																	<span class="menuprincipal">{{ checkitem.descricao }}</span>
																	<span v-if="parseInt(checkitem.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
																	<span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
																</li>
															</div>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>								
									<div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>
									</div>
										<div v-if="parseInt(vtipo) === 2" id="dvimagensped" class="container-fluid tab-pane">
										<div class="row" style="padding-left: 15px; padding-right: 15px;">
                                            <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                                <div v-if="lstImagens.length > 0" class="row">
													<div v-for="(imagem, index) in lstImagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">                                            
														<button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgproduto" @click.prevent="mtdexcluirimgpedido(imagem.patharquivo)"><i class="fa fa-trash"></i></button>
														<img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">                                                  
													</div>
                                                </div>
                                                <div v-else class="row">
                                                    <div class="col-md-12 text-center">
                                                        <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="parseInt(opcrud) < 3" class="col-md-12 text-center" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="ipselecionarimg"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem" 
                                                    style="display: none;"
                                                    ref="if_imgpedido">
                                                <button type="button" @click="$refs.if_imgpedido.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar imagem</button>
                                            </div>																	
										</div>
									</div>																	
								</div>									
							</div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8" id="dvmais" style="margin-top: 5px;">
								<div class="row">
									<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
										<label for="edresponsavelos">Responsável:</label>
										<input type="text" class="form-control form-control-sm" id="edresponsavelos" v-model="vresponsavel" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
									</div>
									<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
										<label for="edfone">Fone:</label>
										<input type="text" v-model="vfone" v-bind:disabled="ativadesativa"
											class="form-control form-control-sm" id="edfone" 
											v-mask="['(##) ####-####', '(##) #####-####']">
									</div>
									<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
										<label for="eddtretorno">Data Retorno:</label>
										<div class="input-group">
											<date-picker id="eddtretorno" v-model="vdtretorno" :config="options"
												class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
											<div class="input-group-append">
												<span class="input-group-text"><i class="fa fa-calendar"></i></span>
											</div>										
										</div>
									</div>																							
								</div>									
							</div>							
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" style="margin-top: 15px;">
									<div class="draco-kpi-card draco-kpi-success">
										<span class="draco-kpi-label">Total consolidado do pedido</span>
										<span class="draco-kpi-money">{{mtdformatavalordecimal(parseFloat(vtotalgeral), 2)}}</span>
									</div>
								</div>							
						</div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-6 col-md-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-3 col-md-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                </button>
                            </div>
                            <div class="col-sm-3 col-md-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
				<div id="pnentregaexterna" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">{{ itensbc.item2.titulo }}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<label for="ednrpedidoentrega">Nr. Pedido:</label>
								<input type="text" class="form-control form-control-sm font-weight-bold" id="ednrpedidoentrega" v-bind:value="pedidoentrega.id"
									data-bv-group=".group" maxlength="50" disabled/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<label for="edfilialentrega">Filial:</label>
								<input type="text" class="form-control form-control-sm" id="edfilialentrega" v-bind:value="pedidoentrega.idfilial + ' - ' + pedidoentrega.fantasia"
									data-bv-group=".group" disabled/>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<label for="edclienteentrega">Parceiro cliente:</label>
								<input type="text" class="form-control form-control-sm" id="edclienteentrega" v-bind:value="pedidoentrega.idcliente + ' - ' + pedidoentrega.nomecliente"
									data-bv-group=".group" disabled/>
							</div>											
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<label for="eddtemissaoentrega">Data Emissão:</label>
								<input type="text" class="form-control form-control-sm text-right font-weight-bold" id="eddtemissaoentrega" v-bind:value="pedidoentrega.dtemissao"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<label for="edvendedorentrega">Vendedor:</label>
								<input type="text" class="form-control form-control-sm" id="edvendedorentrega" v-bind:value="pedidoentrega.idvendedor + ' - ' + pedidoentrega.nomevendedor"
									data-bv-group=".group" disabled/>
							</div>																	
							<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<label for="edplanoentrega">Plano:</label>
								<input type="text" class="form-control form-control-sm" id="edplanoentrega" v-bind:value="pedidoentrega.idplano + ' - ' + pedidoentrega.descplano"
									data-bv-group=".group" disabled/>
							</div>
                            <div class="col-sm-4 col-md-4">
                            </div>
                            <div class="col-sm-2 col-md-2">
                                <button id="btentregartodos" type="button" @click.prevent="mtdentregartodositens()"
                                        class="btn btn-primary btn-green btn-sm" style="width:100%; margin-top:20px;">
										<i class="fa fa-refresh"></i> Entregar todos
                                </button>
                            </div>							
							<div class="col-md-12" style="margin-top: 15px;">
								<vue-bootstrap4-table
										:rows="pedidoentrega.itens"
										:columns="columnsientrega"
										:config="config"
										:classes="classes">														
									<template slot="empty-results">
										<div class="col-md-12 text-center">Sem itens para visualização</div>
									</template>			
									<template slot="slot_item" slot-scope="item">
										{{ mtdformatarzeros(item.row.item, 3) }}
									</template>													
									<template slot="id_fi" slot-scope="item">
										{{ item.row.coddig }}
									</template>
									<template slot="slot_qtditem" slot-scope="item">
										<span class="font-weight-bold text-black-50">{{ mtdformatavalordecimal(parseFloat(item.row.qtditem), 4) }}</span>
									</template>
									<template slot="slot_qtdlevou" slot-scope="item">
										<span class="font-weight-bold text-black-50">{{ mtdformatavalordecimal(parseFloat(item.row.qtditem) - parseFloat(item.row.qtdentregar), 4) }}</span>
									</template>									
									<template slot="slot_qtdlevar" slot-scope="item">
										<span class="font-weight-bold" style="color: #4250f2;">{{ mtdformatavalordecimal(parseFloat(item.row.qtdentregar), 4) }}</span>
									</template>	
									<template slot="slot_qtdentregue" slot-scope="item">										
										<span class="font-weight-bold" style="color: #0acf97; padding-right: 5px;">{{ mtdformatavalordecimal(parseFloat(item.row.qtdentregue), 4) }}</span>
										<button type="button" class="btn btn-info btn-sm btn-editaitementrega ajt-btn" @click.prevent="mtddefinirqtdentregue(item.row)"><i class="fa fa-edit"></i></button>
									</template>																						
									<template slot="slot_unditem" slot-scope="item">
										{{ item.row.unditem }}
									</template>	
								</vue-bootstrap4-table>
							</div>
							<div class="col-sm-12">
								<label for="txtobservacoesentrega">Anotações</label>
								<textarea class="form-control center" rows="3" id="txtobservacoesentrega" v-bind:value="pedidoentrega.observacoes" disabled></textarea>
							</div>																																						
						</div>
					</div>					
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-6 col-md-6">
                            </div>
                            <div class="col-sm-2 col-md-2">
                                <button id="btgravar" type="button" @click.prevent="mtdfinalizarentregaexterna()"
                                        class="btn btn-primary btn-green btn-sm" style="width:100%; margin-bottom:10px;">
										<i class="fa fa-check"></i> Finalizar entrega
                                </button>
                            </div>
                            <div class="col-sm-2 col-md-2">
                                <button type="button" @click.prevent="mtdsalvarentrega()" class="btn btn-info btn-sm" style="width:100%">
                                    <i class="fa fa-edit"></i> Salvar
                                </button>
                            </div>							
                            <div class="col-sm-2 col-md-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>										
				</div>
				<div id="pnconferencia" class="card" style="display: none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelarconf()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <span v-if="!vachouPro" class="badge badge-info badge-pill text-center bdg-alerta" style="width: 100% !important;">{{vmsgPro}}</span>
                        <span v-else class="badge badge-info badge-pill text-center bdg-success" style="width: 100% !important;">{{vmsgPro}}</span>
                        <span v-if="vfinalizado" class="badge badge-info badge-pill text-center bdg-finalizado" style="width: 100% !important;">CONFERÊNCIA FINALIZADA</span>

                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvicodpro">Item:</label>
								<div class="input-group mb-3">
									<input type="text" class="form-control form-control-sm" id="edvicodpro" title="F2 pesquisar produto" v-on:keyup.13="submitProd()"
										v-model="vicodpro" placeholder="Pesquisar..." v-bind:disabled="ativadesativacod" autocomplete="off">
								</div>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="eddescpro">Descrição do produto:</label>
                                <input type="text" v-model="videscpro" class="form-control form-control-sm" id="eddescpro" disabled
                                    style="text-transform: uppercase; font-weight: bold;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdfalta">Qtd. Falta:</label>
                                <input type="text" v-model="vqtdfalta" class="form-control form-control-sm" id="edqtdfalta" disabled
                                    style="text-transform: uppercase; font-weight: bold; text-align: center;">
                            </div>							                               
                        </div>
                    </div>

                    <div class="col-md-12" style="margin-top: 10px;">
                        <vue-bootstrap4-table
                            :rows="lstitensconf"
                            :columns="columnsconf"
                            :config="config"
                            :classes="classes">

                            <template slot="empty-results">
                                <div class="col-md-12 text-center">Sem dados para visualização</div>
                            </template>
                            <template slot="status_s" slot-scope="item">
                                <span v-if="item.row.situacao === 1" title="Status"><i class="fa fa-check-square-o" style="color: rgb(90, 149, 106); font-weight: 600; font-size: 18px;"></i></span>
                                <span v-else title="Status" style="color: rgb(248, 43, 84); font-weight: 600; font-size: 18px;"><i class="fa fa-check-circle-o"></i></span>
                            </template>
                        </vue-bootstrap4-table>
                    </div>

                    <div class="col-md-12" style="margin-bottom: 15px;">
                        <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                            Total de itens                            
                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 182px !important;">{{lstitensconf.length}}</span>
                        </li>
                        </ul>
                    </div>

					<div class="card-footer" style="padding: 10px;">
						<div class="row">
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelarconf()"><i class="fa fa-close"></i> Fechar</button>
							</div>               
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" id="btngravar" class="btn btn-success btn-sm btn-block" v-bind:disabled="temItens" @click.prevent="mtdgravarconf()"><i class="fa fa-file"></i> Salvar</button>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
		<div class="modal fade" id="mdmenupedido">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(pedidomenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(pedidomenu)"><i class="fa fa-edit"></i> EDITAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(pedidomenu)"><i class="fa fa-trash"></i> REMOVER</li>
								<li v-if="parseInt(pedidomenu.conferido) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconferencia(pedidomenu)" data-dismiss="modal"><i class="fa fa-list-ol"></i> CONFERÊNCIA</li>
								<li v-if="parseInt(pedidomenu.liberarpdv) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinapdv(pedidomenu.id)"><i class="fa fa-unlock"></i> LIBERAR PDV</li>
								<li v-else class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinapdv(pedidomenu.id)"><i class="fa fa-lock"></i> BLOQUEAR PDV</li>

								<li v-if="(parseInt(pedidomenu.liberarfat) === 0) && (parseFloat(pedidomenu.vlcreditodisponivel) < parseFloat(pedidomenu.totalgeral) && parseInt(pedidomenu.tipoplano) === 1) || (parseInt(pedidomenu.atraso) - parseInt(pedidomenu.qtddiasbloqvenda) > 0)" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdliberarpedido(pedidomenu.id)"><i class="fa fa-check"></i> LIBERAR FATURAMENTO</li>

								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdfaturarpedido(pedidomenu.id)"><i class="fa fa-money"></i> FATURAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdetiquetasvolumes()" data-dismiss="modal"><i class="fa fa-tags"></i> ETIQUETAS DE VOLUMES</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdcancelarpedido(pedidomenu.id)"><i class="fa fa-close"></i> FECHAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(pedidomenu)"><i class="fa fa-clone"></i> CLONAR</li>
								<li v-show="parseInt(pedidomenu.stpedido) === 1" class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefnf" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">
											<i class="fa fa-qrcode"></i> NOTA FISCAL
										</div>
										<div id="dvdefnf" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div v-if="parseInt(pedidomenu.idnotafiscal) === 0" class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtddefinirfilialemissaonf(pedidomenu, 55)">NF-e</button>
														</div>
														<div v-if="parseInt(pedidomenu.idnotafiscal) === 0" class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtddefinirfilialemissaonf(pedidomenu, 65)">NFC-e</button>
														</div>
														<div v-if="parseInt(pedidomenu.idnotafiscal) > 0" class="col-md-12">
															<button type="button" class="btn btn-info btn-block" @click.prevent="mtdimprimirdanfe(pedidomenu)"><i class="fa fa-print"></i> Imprimir DANFE</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</li>							
								<li class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefimpressao" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">									
											<i class="fa fa-print"></i> IMPRIMIR
										</div>
										<div id="dvdefimpressao" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 0)"><i class="fa fa-file-text-o"></i> Padrão</button>
														</div>
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 1)"><i class="fa fa-wpforms"></i> Cupom</button>
														</div>
														<div v-show="parseInt(pedidomenu.stpedido) === 1" class="col-12" style="margin-top: 10px;">
															<button type="button" class="btn btn-primary btn-block" data-dismiss="modal" @click.prevent="mtdrotinarecibopedido(pedidomenu)"><i class="fa fa-sticky-note-o"></i> Recibo</button>
														</div>														
													</div>
												</div>
											</div>
										</div>
									</div>										
								</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefguiaseparacao" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">									
											<i class="fa fa-print"></i> GUIA SEPARAÇÃO
										</div>
										<div id="dvdefguiaseparacao" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirguiaseparacao(pedidomenu.id, 0)"><i class="fa fa-file-text-o"></i> Padrão</button>
														</div>
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirguiaseparacao(pedidomenu.id, 1)"><i class="fa fa-wpforms"></i> Cupom</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>										
								</li>								
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarimagens(pedidomenu)" data-dismiss="modal"><i class="fa fa-picture-o"></i> IMAGENS</li>								
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtddevolucao(pedidomenu)" data-dismiss="modal"><i class="fa fa-undo"></i> DEVOLUÇÃO</li>																
								<div id="dventregaexternamenu">
									<li v-show="parseInt(pedidomenu.stpedido) === 1 && parseInt(pedidomenu.entregaexterna) === 1" class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefentrega" style="color: #6c757d;">
										<div class="row">
											<div class="col-md-12">									
												<i class="fa fa-paper-plane-o"></i> ENTREGA EXTERNA
											</div>
										</div>																																		
									</li>
									<div id="dvdefentrega" class="col-md-12 collapse" style="margin-top: 15px;">
										<div class="card" style="margin-left: -15px; margin-right: -15px;">
											<div class="card-body" style="padding: 15px;">
												<div class="row">
													<div class="col-12 col-sm-12 col-md-12">
														<button type="button" class="btn btn-primary btm-sm btn-block" @click.prevent="mtdentregaexterna(pedidomenu)" data-dismiss="modal"><i class="fa fa-edit"></i> Gerenciar</button>
													</div>
													<div class="col-12 col-sm-12 col-md-12" style="margin-top: 15px;">
														<div class="row">
															<div class="card" style="margin-left: 15px; margin-right: 15px;">
																<div class="card-header text-center font-weight-bold" style="padding: 5px;">IMPRESSÃO</div>
																<div class="card-body" style="padding: 15px;">
																	<div class="row">
																		<div class="col-md-12">
																			<input type="radio" id="one" value="0" v-model="eopimpentrega">
																			<label for="one" style="margin-left: 5px;">Itens pendentes</label>																	
																		</div>
																		<div class="col-md-12" style="margin-top: 15px; margin-bottom: 15px;">
																			<input type="radio" id="two" value="1" v-model="eopimpentrega">
																			<label for="two" style="margin-left: 5px;">Todos os itens</label>																	
																		</div>
																		<div class="col-6 col-sm-6 col-md-6">
																			<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirentrega(pedidomenu.id, 0, eopimpentrega)" data-dismiss="modal"><i class="fa fa-file-text-o"></i> Padrão</button>
																		</div>
																		<div class="col-6 col-sm-6 col-md-6">
																			<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirentrega(pedidomenu.id, 1, eopimpentrega)" data-dismiss="modal"><i class="fa fa-wpforms"></i> Cupom</button>
																		</div>																																					
																	</div>
																</div>
															</div>		
														</div>															
													</div>
												</div>
											</div>
										</div>
									</div>								
								</div>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>		
		<!-- Modal de edição do ítem do pedido -->
		<div class="modal fade" id="mdedicaoitem" tabindex="-1">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Inclusão)</h4>
						<h4 v-else class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Alteração) - {{ mtdformatarzeros(vitemalteracao, 3) }}</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edidprodutoedicao">*Item:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-bind:disabled="parseInt(vopitem) === 2" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-8 col-lg-7">
								<label for="eddescricaoprodutoedicao">Descrição do produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" v-bind:disabled="vedicaodescpro" v-on:blur="mtddesabilitaedicaodescpro()">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdhabilitaedicaodescpro()" title="Editar descrição"><i class="fa fa-edit" style="padding-top: 3px;"></i></a>
									</div>
								</div>									
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edundprodutoedicao">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edqtditemedicao">*Quantidade:</label>
								<div class="input-group" style="z-index: 1;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidade(2)"><i class="fa fa-minus"></i></a>
									</div>									
									<money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidade(1)"><i class="fa fa-plus"></i></a>
									</div>									
								</div>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="cbmanipulavaledicao">Manipular valor:</label>
								<select class="form-control form-control-sm" id="cbmanipulavaledicao" v-model="vmanipulavaledicao" v-bind:disabled="pmanipularvaloritem">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="cbdescacresedicao">Atribuir:</label>
								<select class="form-control form-control-sm" id="cbdescacresedicao" v-model="vdescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
									<option value="0">Desconto</option>
									<option value="1">Acréscimo</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="cbtipodescacresedicao">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodescacresedicao" v-model="vtipodescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">								
								<label for="edvaldescacresedicao">{{ vtitdesc }}</label>
								<div class="input-group" style="z-index: 1;">
									<money type="text" class="form-control form-control-sm" id="edvaldescacresedicao" v-model="vvalordescacresedicao" v-bind="[calculatotalitem, money]" v-bind:disabled="manipulaval ? false : true" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
									<div class="input-group-append" style="height: 31px;">
										<span v-if="parseInt(vtipodescacresedicao) === 0" class="input-group-text font-weight-bold">%</span>	
										<span v-else class="input-group-text font-weight-bold">$</span>	
									</div>									
								</div>
							</div>
							<div class="col-sm-12" v-bind:class="parseFloat(vvltotalimpostoitemedicao) <= 0 ? 'col-md-4 col-lg-3' : 'col-md-3 col-lg-2'">
								<label for="edvlunitarioedicao">*Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vvlunitarioedicao" v-bind:disabled="manipulaval" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div v-show="parseFloat(vvltotalimpostoitemedicao) > 0" class="col-sm-12 col-md-3 col-lg-2">
								<label for="edimpostoitemedicao">Imposto(R$):</label>
								<input type="text" class="form-control form-control-sm text-right text-warning" id="edimpostoitemedicao" v-bind:value="mtdformatavalordecimal(parseFloat(vvltotalimpostoitemedicao), 2)" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>								
							</div>							
							<div class="col-sm-12" v-bind:class="parseFloat(vvltotalimpostoitemedicao) <= 0 ? 'col-md-4 col-lg-3' : 'col-md-3 col-lg-2'">
								<label for="edvltotaledicao">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotaledicao" v-model="vvltotaledicao" v-bind="[calculatotalitem, money]" readonly style="font-weight: bold; text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-3">
								<span class="lblselect2">*Estoque:</span>
								<select id="cbestoqueedicao" data-placeholder="Selecione um estoque" v-model="videstoqueedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
								</select>
							</div>																																																		
							<div class="col-sm-12 col-md-2 col-lg-3">
								<span class="lblselect2">Solicitante:</span>
								<select id="cbtecnicosolicitaedicao" data-placeholder="Selecione o técnico/solicitante" v-model="vidtecnicosolicitaedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
								</select>
							</div>																
						</div>
						<div class="row">
							<div class="col-sm-12">
								<label for="txtinfadprod">Informações adicionais do item:</label>
								<textarea class="form-control center" rows="3" id="txtinfadprod" v-model="vinfadprod" maxlength="500"></textarea>
							</div>
							<div class="col-md-12 text-right">
								<span class="text-black-50" style="font-size: 12px; font-weight: 600;">{{ vinfadprod.length }} caracteres de 500</span>
							</div>						
						</div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravaritem()" id="btnsalvaritem"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para faturamento do pedido -->
		<div class="modal fade" id="mdfaturarpedido">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">      
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-money"></i> Faturar pedido</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12 col-md-4 col-lg-2">
							<label>Nr. Pedido:</label>
							<input type="text" class="form-control form-control-sm" v-bind:value="mtdformatarzeros(pedidofaturar.id, 8)" disabled style="font-weight: bold; text-align: center;">
						</div>						
						<div class="col-sm-12 col-md-8 col-lg-4">
							<label>Parceiro cliente:</label>
							<input type="text" class="form-control form-control-sm" v-model="pedidofaturar.nomecliente" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="edvlfaturar">Valor à faturar:</label>
							<money type="text" class="form-control form-control-sm" id="edvlfaturar" v-model="pedidofaturar.totalgeral" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="edvlcreditodisponivelcli">Créd. Disponível:</label>
							<money type="text" class="form-control form-control-sm" id="edvlcreditodisponivelcli" v-model="pedidofaturar.vlcreditodisponivel" disabled v-bind="money" data-bv-group=".group" style="color: #727cf5; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="eddtemissao">Data Fatura:</label>
							<div class="input-group">
								<date-picker id="eddtfatura" v-model="vdtfatura" :config="options" class="form-control form-control-sm" v-bind:disabled="palterardatafatura"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>												
						<div  class="col-sm-12 col-md-4 col-lg-3">
							<span class="lblselect2">Forma de pagamento:</span>
							<select id="cbformapagamento" data-placeholder="Selecione uma forma" v-model="vidformapagamento" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div class="col-sm-12 col-md-4 col-lg-3">
							<label for="edvlforma">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvlforma" v-model="vvlforma" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
						<div class="col-sm-12 col-md-2 col-lg-2">
							<label for="ednrvendaforma">Nr. Venda:</label>
							<input type="text" class="form-control form-control-sm" id="ednrvendaforma" v-model="vnrvendaforma" maxlength="11" style="font-weight: bold;" v-mask="'###########'" v-bind:disabled="parseInt(vabatecredito) === 0">									
						</div>
						<div class="col-sm-12 col-md-12 col-lg-1">
							<button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdincluirforma()"><i class="fa fa-plus"></i></button>
						</div>																														
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-light">
									<tr>
										<th width="35px" style="text-align: center;"></th>
										<th width="300">Forma de pagamento:</th>
										<th width="100">Valor:</th>										
										<th width="100">Perfil fluxo:</th>
									</tr>
									</thead>
									<tbody>
										<tr v-for="(forma, index) in lstformasfaturar" v-bind:key="index">
											<td width="35px" class="center" style="text-align: center;">
												<a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
												v-bind:disabled="ativadesativa"
												@click.prevent="mtddeletarforma(index)"><i class="fa fa-trash"></i></a>
											</td>												
											<td width="300px">{{ forma.descforma }}</td>
											<td width="100px" style="text-align: right;">
												<strong>{{ mtdformatavalordecimal(forma.vlforma, 2) }}</strong>
											</td>
											<td><i class="fa fa-edit icon-editar-perfil" title="Editar perfil do fluxo" @click.prevent="mtdalterarperfilfluxo(forma, index)"></i>{{ forma.descperfilfluxo }}</td>                                                       
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Soma das formas</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #0acf97;">{{mtdformatavalordecimal(parseFloat(vtotalformas), 2)}}</span>
									</li>
								</ul>
							</div>							
							<div v-show="vdiferenca > 0" class="col-md-12" style="padding-left: 0px; padding-right: 0px;margin-top: 10px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Diferença</span>
										<span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #f82b54;">{{mtdformatavalordecimal(parseFloat(vdiferenca), 2)}}</span>
									</li>
								</ul>
							</div>														
						</div>

						<div v-show="lsttitulosfaturar.length > 0" class="col-lg-12">
							<div class="table-responsive">
								<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-light">
									<tr>
										<th width="35px" style="text-align: center;"></th>
										<th width="80">Nr. título:</th>
										<th width="80">Vencimento:</th>
										<th width="100">Tipo de cobrança:</th>
										<th width="80">Valor:</th>															
									</tr>
									</thead>
									<tbody>
										<tr v-for="(titulo, index) in lsttitulosfaturar" v-bind:key="index">
											<td width="35px" class="center" style="text-align: center;">
												<a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
												v-bind:disabled="ativadesativa"
												@click.prevent="mtdalterartitulo(titulo)"><i class="fa fa-edit"></i></a>
											</td>												
											<td width="80px">{{ titulo.codtit }}</td>
											<td width="80px">{{ titulo.dtventit }}</td>
											<td width="100px">{{ titulo.descricaocob }}</td>
											<td width="80px" style="text-align: right;">
												<strong>{{ mtdformatavalordecimal(titulo.vltit, 2) }}</strong>
											</td>                                                       												
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Soma do títulos</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotaltitulos), 2)}}</span>
									</li>
								</ul>
							</div>							
						</div>						                                   
					</div>						
				</div>       
				<div class="modal-footer">
					<div class="container-fluid" style="padding: 0px;">
						<div class="row">
							<div class="col-md-8 text-center">
								<div class="alert alert-success alerta-cashback" v-show="parseFloat(vltotalcashback) > 0">
									<strong>CASHBACK R$ {{ mtdformatavalordecimal(vltotalcashback, 2) }}!</strong> Disponível {{ pedidofaturar.fatorcreditoutilizar }}% p/ esta venda: R$ {{  mtdformatavalordecimal(vlcashbackdisponivelvenda, 2)  }}.
								</div>
							</div>
							<div class="col-md-2">
								<button type="button" style="margin-top: 10px;" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdconfirmarfatura()"><i class="fa fa-check"></i> Confirmar</button>
							</div>
							<div class="col-md-2">
								<button type="button" style="margin-top: 10px;" class="btn btn-secondary btn-sm btn-block" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>
					</div>	
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para seleção do plano de pagamento -->
		<div class="modal fade" id="mdselecionarplano">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="list-group">								
								<a v-for="(plano, index) in lstplanos" href="#" v-bind:class="parseInt(plano.id) === parseInt(vidplano) ? 'active': ''" v-bind:key="index" class="list-group-item list-group-item-action font-weight-bold" @click.prevent="mtddefineplano(plano)">{{ mtdformatarzeros(plano.id, 2) }} - {{ plano.descricao }}</a>
							</div>							
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
		<!-- Modal para alteração da parcela -->
		<div class="modal fade" id="mdalterartitulo">
			<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do título</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				 
				<div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<label>Nr. título:</label>
							<input type="text" class="form-control form-control-sm" v-model="tacodtit" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="eddtventit">Data Vencimento:</label>
							<div class="input-group">
								<date-picker id="eddtventit" v-model="tadtventit" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edvltit">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvltit" v-model="tavltit" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
						<div  class="col-sm-12 col-md-12 col-lg-12">
							<span class="lblselect2">Tipo de cobrança:</span>
							<select id="cbtipocobranca" data-placeholder="Selecione um tipo de cobrança" v-model="taidtipocobranca" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div v-show="parseInt(tatipocobranca) === 1" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
							<div class="card">
								<div class="card-header card-in text-center" style="padding: 5px;">DADOS DO CHEQUE</div>
								<div class="card-body" style="padding: 10px;">
									<div class="row">
										<div class="col-md-4">
											<label>Nr. Cheque:</label>
											<input type="text" id="ednumerocheque" class="form-control form-control-sm" v-model="tanumerocheque">
										</div>
										<div  class="col-sm-12 col-md-8 col-lg-8">
											<span class="lblselect2">Banco:</span>
											<select id="cbbanco" data-placeholder="Selecione um banco" v-model="taidbanco" data-allow-clear="true" style="width:100%;">
											</select>
										</div>
										<div class="col-md-4">
											<label>Agência:</label>
											<input type="text" id="edagencia" class="form-control form-control-sm" v-model="taagencia">
										</div>
										<div class="col-md-4">
											<label>Conta:</label>
											<input type="text" id="edconta" class="form-control form-control-sm" v-model="taconta">
										</div>
										<div class="col-md-4">
											<label>Praça:</label>
											<input type="text" id="edpraca" class="form-control form-control-sm" v-model="tapraca">
										</div>
										<div class="col-md-12">
											<label>Emitente:</label>
											<input type="text" id="edemitente" class="form-control form-control-sm" v-model="taemitente">
										</div>
										<div class="col-md-5">
											<label for="edfone1">CNPJ/CPF:</label>
											<input type="text" v-model="tacnpjcpf"
												class="form-control form-control-sm" id="edcnpjcpf" 
												v-mask="['###.###.###-##', '##.###.###/####-##']">
										</div>
										<div  class="col-md-7">
											<span class="lblselect2">Situação do cheque:</span>
											<select id="cbsituacaocheque" data-placeholder="Selecione uma situação" v-model="taidsituacaocheque" data-allow-clear="true" style="width:100%;">
											</select>
										</div>																																																	
									</div>
								</div>
							</div>
						</div>																														
					</div>
				</div>        
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmaralteracaotitulo()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para cancelamento do pedido -->
		<div class="modal fade" id="mdcancelarpedido">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">      
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-close"></i> Cancelamento</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
							<label>Nr. Docto.:</label>
							<input type="text" class="form-control form-control-sm" v-bind:value="mtdformatarzeros(pedidocancelar.id, 8)" disabled style="font-weight: bold; text-align: center;">
						</div>						
						<div class="col-12 col-sm-12 col-md-8 col-lg-4 col-xl-4">
							<label>Parceiro cliente:</label>
							<input type="text" class="form-control form-control-sm" v-model="pedidocancelar.nomecliente" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<label for="edvlcancelar">Valor:</label>
							<money v-if="parseInt(pedidocancelar.tipo) !== 3" type="text" class="form-control form-control-sm" id="edvlcancelar" v-model="pedidocancelar.totalgeral" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
							<money v-else type="text" class="form-control form-control-sm" id="edvlcancelar" v-bind:value="parseFloat(pedidocancelar.vlcredito) - parseFloat(pedidocancelar.vlcreditoutilizado)" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<label for="eddtcancelamento">Data Cancelamento:</label>
							<div class="input-group">
								<date-picker id="eddtcancelamento" v-model="cdtcancelamento" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>
						<div class="col-sm-12">
							<label for="txtmotivocancelamento">Motivo do cancelamento:</label>
							<textarea class="form-control center" rows="3" id="txtmotivocancelamento" v-model="cmotivocancelamento"></textarea>
						</div>
					</div>						
				</div>       
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmarcancelamento()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para aplicação do desconto nos itens -->
		<div class="modal fade" id="mdaplicardesconto">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Aplicar desconto</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">							
							<div class="col-md-12">
								<label for="edtotalitenssemdesconto">Total dos itens SEM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenssemdesconto" v-model="vtotalsemdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
							<div class="col-md-12">
								<label for="cbtipodesctotal">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodesctotal" v-model="vtipodesctotal" style="font-size: 18px; font-weight: bold;">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Percentual do desconto</label>
								<label v-else for="edfatordescontototal">Valor do desconto</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vfatordescontototal" v-bind="[calculadescontototalitens, money]" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;"></money>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Desconto(R$)</label>
								<label v-else for="edfatordescontototal">Desconto(%)</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vresdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;" disabled></money>
							</div>														
							<div class="col-md-12">
								<label for="edtotalitenscomdesconto">Total dos itens COM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenscomdesconto" v-model="vtotalcomdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnconfirmadesconto" @click.prevent="mtdconfirmaaplicacaodesconto()"><i class="fa fa-check"></i> Aplicar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
        <!-- Modal para alteração da quantidade que o cliente vai levar -->
        <div class="modal fade" id="mdalteracaoqtdlevar">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-shopping-basket"></i> Definir à levar - {{mtdformatarzeros(litemlevar.item, 3)}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{litemlevar.idproduto}} - {{litemlevar.descproduto}}</span>
                                </div>                                                                
                            </div>                            
                            <div class="col-md-12">
								<label for="edqtdlevar">Levar:</label>
								<money type="text" class="form-control form-control-sm" id="edqtdlevar" v-model="lqtdlevar" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaraltercaoqtdlevar()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Fechar</button>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Modal para definição da quantidade entregue -->
        <div class="modal fade" id="mddefinirqtdentregue">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 18px;"><i class="fa fa-paper-plane-o"></i> Quantidade entregue - {{mtdformatarzeros(eitementregar.item, 3)}}</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{eitementregar.idproduto}} - {{eitementregar.descproduto}}</span>
                                </div>                                                                
                            </div>                            
                            <div class="col-md-12">
								<label for="edqtdlevarentrega">Entregue:</label>
								<money type="text" class="form-control form-control-sm" id="edqtdlevarentrega" v-model="eqtdentregue" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaraltercaoqtdentregue()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Fechar</button>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Modal para visualização do credito da venda -->
        <div class="modal fade" id="mddetalhescredito" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-dollar"></i> Crédito/Cashback: {{mtdformatarzeros(detcredito.idpedido, 8)}}</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row">
							<div class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Valor do crédito</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.vlcredito, 2) }}</span>
									</li>
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Valor utilizado</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.vlcreditoutilizado, 2) }}</span>
									</li>
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Valor disponível</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.vlcreditodisponivel, 2) }}</span>
									</li>
								</ul>								
							</div>
							<div v-show="detcredito.lsthistorico.length > 0 || detcredito.lsthistoricoreccredito.length > 0" class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item text-center" style="padding: 2px; background: #e9ecef;">
										<span style="font-weight: bold;">UTILIZAÇÕES</span>
									</li>
								</ul>								
							</div>							
							<div v-show="detcredito.lsthistorico.length > 0 || detcredito.lsthistoricoreccredito.length > 0" class="col-md-12">
								<div class="table-responsive" style="font-size: 12px;">
									<table class="table table-bordered table-sm table-hover">
										<thead class="thead-light">
										<tr>
											<th>Forma de pagamento:</th>
											<th>Valor:</th>
											<th>Data Utilização:</th>
											<th>Nr. Venda:</th>
											<th>Parceiro cliente:</th>
											<th style="text-align: center;">Origem:</th>
										</tr>
										</thead>
										<tbody>
											<tr v-for="(credito, index) in detcredito.lsthistorico" v-bind:key="index">
												<td>{{ credito.descricao }}</td>
												<td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(credito.vlforma), 2) }}
												</td>
												<td style="text-align: right;">{{ credito.dtfatura }}
												</td>
												<td>{{ mtdformatarzeros(credito.idpedido, 8) }}
												</td>
												<td>{{ credito.nome }}</td>
												<td style="text-align: center; font-weight: bold; cursor: pointer;" title="Venda">VND</td>
											</tr>
											<tr v-for="(credito, index) in detcredito.lsthistoricoreccredito" v-bind:key="index">
												<td>{{ credito.descforma }}</td>
												<td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(credito.valor), 2) }}
												</td>
												<td style="text-align: right;">{{ credito.dthrecebimento }}
												</td>
												<td></td>
												<td>{{ credito.nomecliente }}</td>
												<td style="text-align: center; font-weight: bold; cursor: pointer;" title="Recebimento de título(s)">REC</td>
											</tr>																						
										</tbody>
									</table>
								</div>								
							</div>
							<div v-show="detcredito.detalhecashback.lista.length > 0" class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item text-center" style="padding: 2px; background: #e9ecef;">
										<span style="font-weight: bold;">CASHBACK</span>
									</li>
								</ul>								
							</div>							
							<div v-show="detcredito.detalhecashback.lista.length > 0" class="col-md-12">
								<div class="table-responsive" style="font-size: 12px;">
									<table class="table table-bordered table-sm table-hover">
										<thead class="thead-light">
										<tr>
											<th>Nr. venda:</th>
											<th>Valor:</th>
											<th>Data:</th>
											<th>Validade:</th>
											<th>St:</th>
										</tr>
										</thead>
										<tbody>
											<tr v-for="(cashback, index) in detcredito.detalhecashback.lista" v-bind:key="index">
												<td>{{ cashback.idpedido }}</td>
												<td style="text-align: right;  font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(cashback.cashbackacumulado), 2) }}</td>
												<td style="text-align: right;">{{ cashback.dtfatura }}</td>
												<td style="text-align: right;  font-weight: bold; cursor: pointer;" v-bind:class="cashback.stcashback === 'V' ? 'texto-perigo' : 'texto-sucesso'" v-bind:title="cashback.stcashback === 'V' ? 'Vencido' : 'Disponível'">{{ cashback.dtvalidadecashback }}</td>
												<td style="text-align: center; font-weight: bold; cursor: pointer;" v-bind:class="cashback.stcashback === 'V' ? 'texto-perigo' : 'texto-sucesso'" v-bind:title="cashback.stcashback === 'V' ? 'Vencido' : 'Disponível'">{{ cashback.stcashback }}</td>													
											</tr>
										</tbody>
									</table>
								</div>								
							</div>
							<!-- <div v-show="detcredito.detalhecashback.lista.length > 0" class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Disponível</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.detalhecashback.disponiveis, 2) }}</span>
									</li>
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Vencido</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.detalhecashback.vencidos, 2) }}</span>
									</li>
								</ul>								
							</div>														 -->
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px 10px 5px 10px;">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>                    
                </div>
            </div>
        </div>

		<!-- Modal para edição do perfil do fluxo -->
        <div class="modal fade" id="mdlalterarperfilfluxofinal">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" style="font-size: 14px;">Alteração de perfil do fluxo...</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="lblselect2">Perfil do fluxo:</span>
                            <select id="cbperfilfluxofinal" v-model="aidperfilfluxo" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmarperfilfluxo()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                </div>                
            </div>
            </div>
        </div>	
		
		<!-- Modal pra edicao do recibo do pedido -->
		<div class="modal fade" id="mdrecibopedido">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-sticky-note-o"></i> Emissão de recibo do pedido</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-2">
							<label for="edpridpedido">Nr. Pedido:</label>
							<input type="text" class="form-control form-control-sm" id="edpridpedido" v-model="pedidorecibo.id" disabled/>
						</div>
						<div class="col-6">
							<label for="edprcliente">Parceiro cliente:</label>
							<input type="text" class="form-control form-control-sm" id="edprcliente" v-model="pedidorecibo.nomecliente" disabled/>
						</div>						
						<div class="col-2">
							<label for="edprvendedor">Vendedor:</label>
							<input type="text" class="form-control form-control-sm" id="edprvendedor" v-model="pedidorecibo.nomevendedor" disabled/>
						</div>						
						<div class="col-2">
							<label for="edprdtemissao">Emissão:</label>
							<input type="text" class="form-control form-control-sm" id="edprdtemissao" v-model="pedidorecibo.dtemissao" disabled/>
						</div>						
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table id="tblistaitensrecibopedido" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-dark">
									<tr>
										<th width="30">Item:</th>
										<th width="100">Codigo:</th>
										<th width="300">Nome de referência:</th>
										<th width="100">Vl. Unitário:</th>
										<th width="50">Qtd:</th>   
										<th width="30">Und:</th>                                         
										<th width="100">Vl. Descto:</th>
										<th width="100">Vl. Total:</th>										
									</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in pedidorecibo.itens" v-bind:key="index" style="font-size: 12px;">
											<td class="text-center">{{item.item}}</td>
											<td>{{item.coddig}}</td>
											<td>{{item.descproduto}}</td>
											<td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
											<td style="text-align: right;">{{item.qtditem}}</td>
											<td class="text-center">{{item.unditem}}</td>											
											<td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>
											<td style="text-align: right; font-weight: 600;">{{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}</td> 
										</tr>
									</tbody>                                        
								</table>
							</div>
						</div>
						<div class="col-12" style="margin-bottom: 5px;">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
									<span style="color: #666666; font-weight: bold;">Total do pedido:</span>
									<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{mtdformatavalordecimal(parseFloat(pedidorecibo.totalgeral), 2)}}</span>
								</li>
							</ul>							
						</div>						
					</div>
					<div class="row">
						<div class="col-12">
							<label for="edprformapagamento">Forma de pagamento:</label>
							<!-- <input type="text" class="form-control form-control-sm" id="edprformapagamento" v-model="prformapagamento"/> -->
							<textarea class="form-control center" rows="3" id="edprformapagamento" v-model="prformapagamento"></textarea>
						</div>
						<div class="col-10">
							<label for="edprtransportadora">Transportadora:</label>
							<input type="text" class="form-control form-control-sm" id="edprtransportadora" v-model="prtrasportadora"/>
						</div>						
						<div class="col-2">
							<label for="edprnnf">Nr. NF:</label>
							<input type="text" class="form-control form-control-sm" id="edprformapagamento" v-model="prnnf"/>
						</div>
						<div class="col-8">
							<label for="edprindicacao">Indicação:</label>
							<input type="text" class="form-control form-control-sm" id="edprindicacao" v-model="prindicacao"/>
						</div>												
						<div class="col-4">
							<label for="edpratividade">Atividade:</label>
							<input type="text" class="form-control form-control-sm" id="edpratividade" v-model="pratividade"/>
						</div>						
						<div class="col-12">
							<label for="txtprobservacoes">Anotações:</label>
							<textarea class="form-control center" rows="3" id="txtprobservacoes" v-model="probservacoes"></textarea>
						</div>						
					</div>
				</div>
				<div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmarecibopedido()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
				</div>				
			</div>
			</div>
		</div>
		
		<!-- Modal para analise de cortes -->
		<div class="modal fade" id="mdanalisecortes">
			<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Análise de cortes</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edcdtini">De:</label>
							<div class="input-group">
								<date-picker id="edcdtini" v-model="cdtini" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>								
							</div>
						</div>
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edcdtfim">até:</label>
							<div class="input-group">
								<date-picker id="edcdtfim" v-model="cdtfim" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>																			
							</div>
						</div>
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbctipo">Tipo:</label>
                                <select name="cbctipo" class="form-control form-control-sm" id="cbctipo" v-model="ctipo">
                                    <option value="0">Pedidos</option>
                                    <option value="1">Orçamentos</option>
                                    <option value="2">Ordens de serviço</option>
                                    <option value="3">Todos</option>
                                </select>
                        </div>
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbcdiferenca">Diferença:</label>
                                <select name="cbcdiferenca" class="form-control form-control-sm" id="cbcdiferenca" v-model="cdiferenca">
                                    <option value="0">Negativa</option>
                                    <option value="1">Positiva</option>
                                    <option value="2">Todas</option>
                                </select>
                        </div>												
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
							<button type="button" style="margin-top: 20px;" id="btclistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistarcortes(0)"><i class="fa fa-search"></i> Consultar cortes</button>
						</div>						
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-dark">
									<tr>
										<th width="30"></th>
										<th width="100">ID interno:</th>
										<th width="300">Nome de referência:</th>
										<th width="100">Referência:</th>
										<th width="40">Und:</th>
										<th width="100">Marca:</th>
										<th width="100">Estoque:</th>
										<th width="50">Venda:</th>                                            
										<th width="50">Estoque:</th>
										<th width="50">Corte:</th>
										<th width="50">Pedidos:</th>										
									</tr>
									</thead>
									<tbody>
										<template v-for="(item, index) in lstitenscorte">
											<tr style="font-size: 12px;" :key="index">
												<td class="text-center">
													<span v-if="parseFloat(item.expandir) === 0" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandirpedidos(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
													<span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandirpedidos(index)"></i></span>													
												</td>
												<td>{{item.idproduto}}</td>
												<td>{{item.descricao}}</td>
												<td>{{item.referencia}}</td>
												<td>{{item.und}}</td>
												<td>{{item.descmarca}}</td>
												<td>{{item.descestoque}}</td>
												<td style="text-align: right;">{{item.qtditem}}</td>
												<td style="text-align: right;">{{item.qtdestoque}}</td>
												<td style="text-align: right;">
													<span v-if="parseFloat(item.diferenca) >= 0" class="font-weight-bolder" style="color: #0acf97; font-size: 14px; cursor: pointer;">{{item.diferenca}}</span>
													<span v-else class="font-weight-bolder" style="color: #f82b54; font-size: 14px; cursor: pointer;">{{item.diferenca * (-1)}}</span>
												</td>
												<td style="text-align: right;">{{item.qtdpedidos}}</td>																						
											</tr>
											<tr v-bind:key="index">
												<td colspan="11" v-show="parseInt(item.expandir) === 1">
													<table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
														<thead class="thead-light">
															<tr>
																<th width="60">Nr. Pedido</th>
																<th width="20"></th>
																<th width="250">Parceiro cliente:</th>
																<th width="100">Vendedor:</th>
																<th width="100" >Município:</th>
																<th width="100">Rota:</th>
																<th width="100">Plano pgto.:</th>
																<th width="50" >Venda:</th>
																<th width="20"></th>                                            
																<th width="50">Total:</th>										
															</tr>																								
														</thead>
														<tbody>
															<tr v-for="(pedido, indexp) in item.pedidos" style="font-size: 12px;" :key="indexp">
																<td>{{mtdformatarzeros(pedido.idpedido, 8)}}</td>
																<td class="text-center"><i @click.prevent="mtddetalhespedido(pedido.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i></td>
																<td>{{pedido.idcliente}} - {{pedido.nomecliente}}</td>
																<td>{{pedido.nomevendedor}}</td>
																<td>{{pedido.descmunicipiocli}}</td>
																<td>{{pedido.descrotacli}}</td>
																<td>{{pedido.descplano}}</td>
																<td style="text-align: right;">{{pedido.qtditem}}</td>
																<td class="text-center">
																	<button type="button" class="btn btn-danger btn-sm btncortaritem" @click.prevent="mtdrotinacorteitem(index, indexp)" title="Cortar item"><i class="fa fa-scissors"></i></button>
																</td>																
																<td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(pedido.vltotal, 2)}}</td>
															</tr>	
														</tbody>
													</table>													
												</td>
											</tr>
										</template>
									</tbody>                                        
								</table>
							</div>
						</div>
						<div class="col-md-12">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
									<span class="text-primary"><strong>Total à cortar ({{cqtditenscorte}})</strong></span>									
									<span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(ctotalcortes), 2)}}</span>
								</li>
							</ul>
                        </div>													
					</div>						
				</div>
				<div class="modal-footer">
					<button type="button" style='width: 150px;' class="btn btn-sm btn-primary" @click.prevent="mtdimprimirlistagemcortes()"><i class="fa fa-print"></i> Imprimir</button>
                    <button type="button" style='width: 150px;' class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Sair</button>
				</div>				
			</div>
			</div>
		</div>
		
		<!-- Modal para corte do item -->
		<div class="modal fade" id="mdcorteitem">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Corte do item</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<label for="editemcorte">Item:</label>
							<input type="text" style="font-size: 10px; font-weight: bold;" class="form-control form-control-sm" id="editemcorte" :value="itemcortar.idproduto +' - '+itemcortar.descricao" data-bv-group=".group" disabled>
						</div>	
						<div class="col-12">
							<label for="edpedidocorte">Pedido:</label>
							<input type="text" class="form-control form-control-sm" id="edpedidocorte" :value="mtdformatarzeros(pedidocortar.idpedido, 8)" data-bv-group=".group" style="text-align:center; font-weight: bold;" disabled>
						</div>																	
						<div class="col-12">
							<label for="edqtditemcortar">*Qtd. corte:</label>
							<money type="text" class="form-control form-control-sm" id="edqtditemcortar" v-model="qtditemcortar" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
						</div>						
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmarcorteitem()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
				</div>				        
			</div>
			</div>
		</div>				

		<!-- Modal para impressão dos itens cortados -->
		<div class="modal fade" id="mditenscortados">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-print"></i> Itens cortados</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<label for="edlcdtini">De:</label>
							<div class="input-group">
								<date-picker id="edlcdtini" v-model="lcdtini" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>								
							</div>
						</div>
						<div class="col-12">
							<label for="edlcdtfim">até:</label>
							<div class="input-group">
								<date-picker id="edlcdtfim" v-model="lcdtfim" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>																			
							</div>
						</div>
						<div class="col-12">
							<span class="lblselect2">Vendedor:</span>
							<select id="cblcvendedor" data-placeholder="Selecione um vendedor" v-model="lcidvendedor" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdimprimiritenscortados()"><i class="fa fa-print"></i> Imprimir</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
				</div>				        
			</div>
			</div>
		</div>

		<!-- Modal para crédito avulso -->
		<div class="modal fade" id="mdcreditoavulso">
			<div class="modal-dialog modal-md modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-dollar"></i> Crédito avulso</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>				
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilialca" data-placeholder="Selecione uma filial" v-model="vidfilialca" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">*Parceiro cliente:</span>
								<select id="cbclienteca" data-placeholder="Selecione um cliente" v-model="vidclienteca" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12">
								<label for="txtobservacoesva">Anotações:</label>
								<textarea class="form-control center" rows="3" id="txtobservacoesva" v-model="vobservacoesca" maxlength="500"></textarea>
							</div>						
							<div class="col-sm-12 col-md-8 col-lg-8">
							</div>						
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edvlcreditoavulso">*Valor do crédito:</label>
								<money type="text" class="form-control form-control-sm" id="edvlcreditoavulso" v-model="vvalorcreditoavulso" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>																		
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmarcreditoavulso()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
					</div>				        
				</div>
			</div>
		</div>
		
		<!-- Modal para devolução -->
		<div class="modal fade" id="mddevolucao">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-undo"></i> Devolução</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>				
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label for="edclientepeddev">Parceiro cliente:</label>
								<input type="text" class="form-control form-control-sm text-uppercase" id="edclientepeddev" v-bind:value="pedidodevolucao.idcliente+' - '+pedidodevolucao.nomecliente"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label for="edfilialdev">Filial:</label>
								<input type="text" class="form-control form-control-sm" id="edfilialdev" v-bind:value="pedidodevolucao.idfilial+' - '+pedidodevolucao.fantasia"
									data-bv-group=".group" disabled/>
							</div>							
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="ednrpeddev">Nr. Pedido:</label>
								<input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="ednrpeddev" v-bind:value="mtdformatarzeros(pedidodevolucao.id, 8)"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="eddtfaturadev">Data Fatura:</label>
								<input type="text" class="form-control form-control-sm text-right" id="eddtfaturadev" v-model="pedidodevolucao.dtfatura"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label for="edplanodev">Plano de pagamento:</label>
								<input type="text" class="form-control form-control-sm text-uppercase" id="edplanodev" v-model="pedidodevolucao.descplano"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="edtotalpedidodev">Total pedido:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edtotalpedidodev" 
									v-model="pedidodevolucao.totalgeral" v-bind="money"
									data-bv-group=".group" style="text-align:right;" disabled>
								</money>                                
							</div>

							<div class="col-sm-12 col-md-12 col-lg-2">
								<label for="eddtdevolucao">*Data devolução:</label>
								<div class="input-group">
									<date-picker id="eddtdevolucao" v-model="dtemissaodevolucao" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>							
						</div>
						<div class="row">
							<div class="col-lg-12">
								<div class="table-responsive">
									<table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
										<thead class="thead-dark">
										<tr>
											<th width="30">Item:</th>
											<th width="100">Codigo:</th>
											<th width="300">Nome de referência:</th>
											<th width="100">Referência:</th>
											<th width="40">Und:</th>
											<th width="40">Marca:</th>
											<th width="100">Vl. Unitário:</th>
											<th width="50">Qtd:</th>     
											<th width="50">Qtd. Devolução:</th>
											<th width="100">Vl. Descto:</th>
											<th width="100">Vl. Total:</th>
											<th width="100">Local.:</th>
											<th width="100">Estoque:</th>                                                
										</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in pedidodevolucao.itens" v-bind:key="index" style="font-size: 12px;">
												<td class="text-center">{{item.item}}</td>
												<td>{{item.coddig}}</td>
												<td>{{item.descproduto}}</td>
												<td>{{item.referencia}}</td>
												<td>{{item.unditem}}</td>
												<td>{{item.descmarca}}</td>
												<td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
												<td style="text-align: right;">{{item.qtditem}}</td>
												<td style="text-align: right;">
													<money type="text" class="form-control form-control-sm" v-model="item.qtddevolucao" 
														@blur.native="mtdcalculatotaldevolucao()" data-bv-group=".group" maxlength="20" 														
														style="text-align:right; font-weight: bold;">
													</money>														
												</td>
												<template v-if="parseInt(item.descacres) === 0">
													<td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
													<td v-else style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>                                                
												</template>
												<template v-else>
													<td></td>
												</template>
												<td style="text-align: right; font-weight: 500;">
													<i v-show="parseFloat(item.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
													{{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
												</td>
												<td>{{item.localizacao}}</td>
												<td>{{item.descestoque}}</td>
											</tr>
										</tbody>                                        
									</table>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<label for="txtobservacoesdevolucao">Anotações:</label>
								<textarea class="form-control center" rows="3" id="txtobservacoesdevolucao" v-model="observacoesdevolucao"></textarea>
							</div>											
						</div>						
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-10 col-xl-10 text-right">								
								<button type="button" class="btn btn-info btn-sm" style="margin-top: 20px; width: 150px;" @click.prevent="mtddevolvertodos()"><i class="fa fa-list-ul"></i> Devolver todos</button>								
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="edtotaldevolucao">Total devolução:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edtotaldevolucao" 
									v-model="totaldevolucao" v-bind="money"									
									data-bv-group=".group" style="text-align:right;" disabled>
								</money>                                
							</div>			
						</div>									
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmardevolucao()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
					</div>				        
				</div>
			</div>
		</div>		
		
		<!-- Modal para para definição da filial da emissão da NF -->
		<div class="modal fade" id="mddefinefilialnf">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-qrcode"></i> Geração de NF - Modelo {{ vmodelonf }}</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<span class="lblselect2">*Filial:</span>
							<select id="cbfilialnf" data-placeholder="Selecione uma filial" v-model="vidfilialnf" data-allow-clear="true" style="width:100%;" v-bind:disabled="!alterafilialnf">
							</select>
						</div>		
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 150px;" @click.prevent="mtdgerarenviarnf(true)" v-bind:disabled="habbtnf"><i class="fa fa-check"></i> Apenas gerar</button>
					<button type="button" class="btn btn-success btn-sm" style="width: 150px;" @click.prevent="mtdgerarenviarnf(false)" v-bind:disabled="habbtnf"><i class="fa fa-check"></i> Gerar e enviar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
				</div>				        
			</div>
			</div>
		</div>				

		<!-- Modal para edição do crédito avulso -->
		<div class="modal fade" id="mdedicaocreditoavulso">
			<div class="modal-dialog modal-md modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-dollar"></i>Alteração de crédito</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>				
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12">
								<h6 style="color: rgb(255, 128, 0)">Importante: essa operação irá abater apenas o crédito cedido!</h6>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edtotadd">Adquirido:</label>
								<money type="text" class="form-control form-control-sm" id="edtotadd"  v-model="vvlcredadquirido" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;" disabled></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edtotavulso">Cedido:</label>
								<money type="text" class="form-control form-control-sm" id="edtotavulso"  v-model="vlegcredavulso" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;" disabled></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edtotatual">Valor atual:</label>
								<money type="text" class="form-control form-control-sm" id="edtotatual"  v-model="vlcreditotot" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;" disabled></money>
							</div>	
							<div class="col-md-12">
								<label for="edfilialedicaocreditoavulso">Filial:</label>
								<input type="text" class="form-control form-control-sm" id="edfilialedicaocreditoavulso" v-bind:value="ecreditoavulso.idfilial+' - '+ecreditoavulso.fantasia" data-bv-group=".group" disabled>
							</div>
							<div class="col-md-12">
								<label for="edclienteedicaocreditoavulso">Parceiro cliente:</label>
								<input type="text" class="form-control form-control-sm" id="edclienteedicaocreditoavulso" v-bind:value="ecreditoavulso.idcliente+' - '+ecreditoavulso.nomecliente" data-bv-group=".group" disabled>
							</div>
							<div class="col-12">
								<label for="txteobsalteracaocredito">Motivo da alteração:</label>
								<textarea class="form-control center" rows="3" id="txteobsalteracaocredito" v-model="eobsalteracaocredito"></textarea>
							</div>								
										
							<div class="col-sm-12 col-md-7 col-lg-7">
								<label for="cbdefsubs">Definir:</label>
								<select class="form-control form-control-sm" id="cbdefsubs" v-model="defsubs" >
									<option value="0">Subtrair</option>
									<option value="1">Somar</option>
								</select>
							</div>		
							<div class="col-sm-12 col-md-5 col-lg-5">
								<label for="ededicaovlcreditoavulso">*Valor do crédito:</label>
								<money type="text" class="form-control form-control-sm" id="ededicaovlcreditoavulso"  v-model="evledicaocreditoavulso" v-bind="money" data-bv-group=".group" maxlength="20" :style="vstyle"></money>
							</div>														
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmaredicaocreditoavulso()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
					</div>				        
				</div>
			</div>
		</div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
	import vPagination from 'vue-plain-pagination'
	import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
	import ConsultarClientes from '../components/cmpconsultarclientes.vue'
	import EtiquetasVolumesPedido from '../components/cmpetiquetasvolumespedido.vue'
	import util from '../utilitarios/util.js'
	import GraficoPie from '../components/cmpgraficopie.vue'	
    import { useSound } from '@vueuse/sound'
    import conferenciaSfx from '@/assets/conferencia.mp3'
	import DetalhesPedido from '../components/cmpdetalhespedido.vue'	
	import InformacoesCliente from '../components/cmpinformacoescliente.vue'		

    export default {
        name: 'cadpedidos',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' 			: BreadCrumb,
			'consultaprodutos'  	: ConsultarProdutos,
			'consultaclientes'  	: ConsultarClientes,
			'etiquesvolumespedido'	: EtiquetasVolumesPedido,
			'graficopie'			: GraficoPie,
			'detalhespedido'  		: DetalhesPedido,
			'informacoescliente'	: InformacoesCliente
        },
        data: function() {
            return {
				//variável para detalhes do pedido
				vidpedidodet : '',
				/////////////////////
				utodasfiliais 		: this.$store.state.usuario.todasfiliais,
				vshowprtabela		: true,
				tipopropesquisa     : '0, 2',
				lstpedidos   		: [],
				pidfilial	 		: null,
				pidpedido    		: '',
				pidcliente	 		: null,
				pidplano			: null,
				pidvendedor  		: null,
				pidrota				: null,
				ptipo				: 4,
				pidentificador		: '',
				presponsavel		: '',				
				pfiltroperiodo      : 1,
				pfiltropor			: 0,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				
				psituacao	 		: 0,
				pentregaexterna		: 2,
				psituacaoentrega    : 2,
                pqtdregistros		: 10,
                pqtd_paginas 		: 1,
                pagina_atual 		: 1,
				pqtd_total_registros: 0,
				ptotalaberto		: 0,
				ptotalfaturado		: 0,
				ptotalcusto			: 0,
				ptotalcancelado		: 0,
				ptotaldesconto		: 0,
				ptotaldescontoperc  : 0,
				ptotalcreditos		: 0,
				pqa					: 0,
				pqf					: 0,
				pqc					: 0,
				pqca				: 0,
				pvisualizartotalizadores : 0,
				pvisualizargraficos		 : 0,
				pvisualizarcustos		 : 0,
				pcredito				 : 2,
				porigem					 : 10,
				pidforma				 : null,	
				vermelho				 : false,	

                //variáveis do crud
				opcrud              :  0,
                vid                 : '',
				vidfilial           : null,
				vidcliente			: '',
				vnomecliente		: '',
				vvlcreditoclidet    : 0,
				vidvendedor			: null,
				vtipo				: 0,
				vdtemissao			: util.DataAtual(),

				vidplano			: null,
				vtipoplano			: 0,
				vdescplano			: '',
				vidtabela			: null,//carrega a tabela vinculada ao plano de pagamento
				vpercentrada		: 0,
				vpermitedesconto	: 0,

				vtotalprodutos		: 0,
				vtotalservicos		: 0,
				videntificador		: '',
				vobjeto				: '',
				vmarcacao			: '',
				vnrserie			: '',
				vmarca				: '',
				vmodelo				: '',
				vresponsavel		: '',
				vfone				: '',
				vdtretorno			: '',
				vdefeitoapresentado	: '',
				vacessorios			: '',
				voutrasinformacoes	: '',
				vobservacoes		: '',
				//vtotalimpostos		: 0,				
				vtotalgeral			: 0,
				vstpedido			: 0,
				vdtfatura			: '',
				vreservar			: false,
				ventregaexterna		: false,
				vorigem				: 0,
				vpathimagens        : '',
				lstitens			: [],
				lstservicos			: [],
				lstplanos			: [],
				lstchecklist		: [],

                //rotina imagens
                arqimgselecionado    : null,
                lstImagens           : [],

                //pega o path do diretorio padrão das imagens
                pathimgview          : this.$store.state.configpaths.pathimagens,				

				//Filial para geração da NF
				alterafilialnf			: false,//carrega do perfil do usuário
				habbtnf					: false,
				vidfilialnf				: null,
				vnomefilianf			: '',
				vmodelonf				: 55,
				vpedidonf				: [],

				//Variável de edição dos itens do pedido
				vvltotal_old_edicao		: 0,//somente para a alteração
				//vtotalimpostos_old_edicao: 0,
				alteraentra           	: false,
				vedicaodescpro			: true,
				vitem					: 0,
				vitemalteracao			: 0,
				vtitdesc              	: '%',
				vopitem					: 0,							
				vidprodutoedicao    	: '',
				vcoddigedicao			: '',
				vdescricaoprodutoedicao : '',
				vundprodutoedicao		: '',
				vqtditemedicao			: 1,
				vvltabelaitemedicao		: 0,
				vvlunitarioedicao		: 0,
				vdescacresedicao		: 0,
				vtipodescacresedicao	: 0,
				vvalordescacresedicao	: 0,
				vmanipulavaledicao		: 0,
				vvltotaledicao			: 0,
				vvltotalimpostoitemedicao: 0,
				videstoqueedicao		: null,
				vfracionadoedicao		: 0,
				vinfadprod				: '',
				vidtecnicosolicitaedicao: null,	
				vdadosclasseitem		: [],
				vldescmostrar 			: 0,		

				//variáveis de edição dos serviços
				opserv                		: 0,
				vprecoservicoedicao			: [],
				vtitdescserv          		: 'Descto.(%)',				
				vidservicoedicao			: null,
				vidtecnicoedicao			: null,
				vqtdservicoedicao			: 1,
				vvlservicoedicao			: 0,
				vtipodescontoservicoedicao	: 0,
				vvalordescontoservicoedicao	: 0,
				vvltotalservicoedicao		: 0,				

                //variável para habilitação dos campos
				ativadesativa       		: true,
				ativadesativavendedor		: true,

				pedidomenu					: [], //para geração do menu do pedido no modal

				//variáveis aplicação do desconto no total dos itens
				vtotalsemdesconto	: 0,
				vtotalcomdesconto   : 0,
				vtipodesctotal		: 0,	
				vfatordescontototal	: 0,
				vresdesconto		: 0,	

				//variaveis do faturamento
				lstformasfaturar	: [],
				lsttitulosfaturar	: [],
				pedidofaturar		: [],
				vdtfatura			: util.DataAtual(),
				vidformapagamento	: null,
				vvlforma			: 0,
				vtipoforma			: 0,
				vespecieforma		: 0,
				vabatecredito		: 0,
				vnrvendaforma		: '',				
				vtotaltitulos		: 0,
				vtotalformas		: 0,
				vdiferenca			: 0,
				//mostrar o cashback disponivel quando houver
				vltotalcashback		: 0,
				vlcashbackdisponivelvenda: 0,
				//variáveis da alteração do título
				tacodtit 			: '',
				tadtventit			: '',
				tavltit				: 0,
				taidtipocobranca	: null,
				tatipocobranca		: 0,// 0 - Normal 1 - Cheque
				tadescricaocob		: '',
				tanumerocheque		: '',
				taidbanco			: null,
				tadescbanco			: '',
				taagencia			: '',
				taconta				: '',
				tapraca				: '',
				taemitente			: '',
				tacnpjcpf			: '',						
				taidsituacaocheque	: null,
				tadescsituacaocheque: '',
				
				//variáveis para o cancelamento
				pedidocancelar		: [],
				cmotivocancelamento : '',
				cdtcancelamento		: util.DataAtual(),

				//variaveis de perfil
				pmanipularvaloritem : false,
				pdefinirestoque		: false,
				palterardatafatura	: false,
				palterarvendedor	: false,

				//variaveis da edicao da quantidade de quanto o cliente vai levar
				litemlevar			: [],
				lqtdlevar			: 0,
				lfracionado			: 0,

				//variáveis do gerenciamento da entrega externa
				pedidoentrega		: [],
				eitementregar		: [],
				eqtdentregue		: 1,
				eopimpentrega		: 0,

				//variáveis para visualização das imagens do pedido
				images              : [],

				//perfil fo fluxo
				vidperfilfluxoforma   	 : null,
				vdescperfilfluxoforma 	 : '',  				
				
                //alteração perfil fluxo
                aindiceperfilfluxo      : 0,
                aidperfilfluxo          : 0,
                adescperfilfluxo        : '',
				clonar					: false,

				//variáveis da conferência do pedido
                cfidpedido 				: 0,
				lstitensconf			: [],
				lstcodigosconf    		: [],

                ativadesativacod        : true,
                vicodpro                : null,
                videscpro               : '',
                vqtdfalta               : 0,
                vachouPro               : false,
                vmsgPro                 : '',
                vfaltaitens             : true,
                vfinalizado             : false, 
				
				//variáveis do recibo do pedido
				pedidorecibo			: [],
				prformapagamento		: '',
				prtrasportadora			: '',
				prnnf					: '',
				prindicacao				: '',
				pratividade				: '',
				probservacoes			: '',

				detpedido               : [],

				//variáveis do corte
				crotinacortes		: false,//variável para permissão do usuário
				cdtini       		: util.DataAtual(true),
				cdtfim       		: util.DataAtual(true),
				ctipo				: 0,
				cdiferenca			: 2,
				lstitenscorte		: [],
				cqtditenscorte		: 0,
				ctotalcortes		: 0,
				//variáis do item a ser cortado
				itemcortar			: [],
				pedidocortar		: [],
				qtditemcortar		: 1,
				//variáveis da listagem dos itens cortados
				lcdtini       		: util.DataAtual(true),
				lcdtfim       		: util.DataAtual(true),
				lcidvendedor		: null,

				//variáveis de informações do cliente
				idclienteinf			: 0,
				nomeclienteinf			: '',
				vlcreditoinf 			: 0,

				//variáveis do crédito avulso
				vidfilialca				: null,
				vidclienteca			: null,
				vvalorcreditoavulso		: 0,
				vobservacoesca			: '',
				

				//variáveis da devolução
				pedidodevolucao			: [],
				dtemissaodevolucao		: util.DataAtual(true),
				totaldevolucao			: 0,
				observacoesdevolucao	: '',


				//variaveis da impressao de guia - guga
				vpedidosselecionados    : [],

				//variáveis para edição do crédito avulso
				ecreditoavulso			: [],
				eobsalteracaocredito	: '',
				evledicaocreditoavulso  : 0,
				defsubs					: 0,
				vlegcredavulso          : 0,
				vvlcredcedido           : 0,
				vvlcredadquirido        : 0,
			    vlcreditotot            : 0,
				vlegcredanterior        : 0,
				qtddef                  : 0,
				vstyle                  : 'text-align:right; font-weight: bold; background: honeydew; color: green;',

				detcredito : 		{
					idpedido 			: 0,
					vlcredito			: 0,
					vlcreditoutilizado  : 0,
					vlcreditodisponivel	: 0,
					lsthistorico		: [],
					lsthistoricoreccredito	: [],
					detalhecashback			: {
						lista		: [],
						disponiveis : 0,
						vencidos	: 0
					}
				},
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
				columnsconf: [
					{
						label: "Código",
						name: "coddig",
						sort: true,
						slot_name: "id_f",
						row_classes: "def-col-cod",
					},          						
					{
						label: "Descrição",
						name: "descricao",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left"
                    },
					{
						label: "Marca",
						name: "descmarca",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left",
						row_classes: "def-col-marca"
                    },
					{
						label: "Unidade",
						name: "und",
						initial_sort : false,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-center",
						column_text_alignment: "text-center",
                        row_classes: "def-col-und"
                    },
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_p",
                        column_classes: "def-col-qtd"
                    },           
                    {
                        label: "Qtd. Conf.",
                        name: "qtdconf",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_c",
                        column_classes: "def-col-qtdconf"
                    },
                    {
                        label: "Qtd. Falta",
                        name: "qtdfalta",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_f",
                        column_classes: "def-col-qtdfalta"
                    },
                    {
                        label: "Status",
                        name: "situacao",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "status_s",
                        column_classes: "def-col-status"
                    },                              
                ],				
                itensbc : {
                    item1 : {
                        titulo : 'GESTÃO DE PEDIDOS DE VENDA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes_ped",
						sort: false						
                    },
                    {
                        label: "",
                        name: "stpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "Nr.Pedido",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
						row_text_alignment: "text-center",
						column_text_alignment: "text-left",
						row_classes: "def-col-nrpedido",
					},
                    {
                        label: "Tipo",
                        name: "tipo",
                        sort: true,
                        slot_name: "slot_tipo",
                        row_classes: "def-col-tipo",
					},					
                    {
                        label: "Situação",
                        name: "stpedido",
                        sort: true,
                        slot_name: "slot_stpedido",
                        row_classes: "def-col-stpedido",
					},														
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
						sort: true,
						slot_name: "slot_dtemissao",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },														
                    {
                        label: "DataFatura",
                        name: "dtfatura",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
						sort: true,
						slot_name: "slot_dtfatura",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
						row_classes: "def-col-cliente"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_filial",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vendedor",
                        name: "nomevendedor",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_vendedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Plano",
                        name: "descplano",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_plano",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    // {
                    //     label: "Identificador",
                    //     name: "identificador",
                    //     initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                    //     initial_sort_order: 'asc',
                    //     sort: true,
					// 	slot_name: "slot_identificador",
                    //     row_text_alignment: "text-left",
                    //     column_text_alignment: "text-left"
                    // },
                    // {
                    //     label: "Nr.Série",
                    //     name: "nrserie",
                    //     initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                    //     initial_sort_order: 'asc',
                    //     sort: true,
					// 	slot_name: "slot_serie",
                    //     row_text_alignment: "text-left",
                    //     column_text_alignment: "text-left"
                    // },
                    {
                        label: "Retorno",
                        name: "dtretorno",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_retorno",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Valor",
                        name: "totalgeral",
                        sort: true,
                        slot_name: "slot_totalgeral",
						column_classes: "def-col-totalgeral",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
					{
                        label: "Descto",
                        name: "totaldesconto",
                        sort: true,
                        slot_name: "slot_desconto",
						column_classes: "def-col-totalgeral",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
						},
	                    {
	                        label					: "Total Custo",
	                        name					: "totalcusto",
                        sort					: true,
                        slot_name				: "slot_totalcusto",
						column_classes			: "def-col-totalcusto",
                        row_text_alignment		: "text-right",
						column_text_alignment	: "text-left",
						visibility				: true						
					},										
                    {
                        label					: "Formas",
                        name					: "formas",
                        sort					: false,
                        slot_name				: "slot_formas",
						column_classes			: "def-col-formas",
                        row_text_alignment		: "text-left",
						column_text_alignment	: "text-left"						
					}
				],
                columnsi: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        column_classes: "def-col-opcoes",
						sort: false,
						slot_name: "opcoesi"
					},
                    {
                        label: "Ítem",
						name: "item",
						slot_name: "slot_item",
						sort: true,
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado                        
						initial_sort_order: 'asc',
						column_classes: "def-col-item",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },					
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "id_fi",
						column_classes: "def-col-coddig",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},				
                    {
                        label: "Und.",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
						column_classes: "def-col-unditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Vl. Unitário",
                        name: "vlunitario",
                        sort: true,
                        slot_name: "slot_vlunitarioitem",
						column_classes: "def-col-qtdvlunitarioitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Desc/Acres",
                        name: "valordescacres",
                        sort: true,
                        slot_name: "slot_valordescacres",
						column_classes: "def-col-valordescacres",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Levar",
                        name: "qtdlevar",
                        sort: true,
                        slot_name: "slot_qtdlevar",
						column_classes: "def-col-qtdlevar",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left",						
						visibility:	false
					},					
                    {
                        label: "Total",
                        name: "vltotal",
                        sort: true,
                        slot_name: "slot_vltotalitem",
						column_classes: "def-col-vltotalitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Solicitante",
                        name: "nometecnicosolicita",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					}
				],
                columnss: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "idservico",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descservico",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Técnico",
                        name: "nometecnico",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vl. Unitário",
                        name: "vlservico",
                        sort: true,
                        slot_name: "slot_vlunitarioservico",
						column_classes: "def-col-qtdvlunitarioitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Descto.",
                        name: "valordesconto",
                        sort: true,
                        slot_name: "slot_valordescacres",
						column_classes: "def-col-valordescacres",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtdservico",
                        sort: true,
                        slot_name: "slot_qtditemserv",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Total",
                        name: "vltotal",
                        sort: true,
                        slot_name: "slot_vltotalservico",
						column_classes: "def-col-vltotalitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
				],
				columnsientrega: [
                    {
                        label: "Ítem",
						name: "item",
						slot_name: "slot_item",
						sort: true,
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado                        
						initial_sort_order: 'asc',
						column_classes: "def-col-item",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },					
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "id_fi",
						column_classes: "def-col-coddig",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},				
                    {
                        label: "Und.",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
						column_classes: "def-col-unditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Levou",
                        name: "qtdentregar",
                        sort: true,
                        slot_name: "slot_qtdlevou",
						column_classes: "def-col-qtdlevou",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left"
					},										
                    {
                        label: "À entregar",
                        name: "qtdentregar",
                        sort: true,
                        slot_name: "slot_qtdlevar",
						column_classes: "def-col-qtdlevar",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left"
					},										
                    {
                        label: "Entregue",
                        name: "qtdentregue",
                        sort: true,
                        slot_name: "slot_qtdentregue",
						column_classes: "def-col-qtdentregue",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left"
					},					
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					}					
				],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
				}
            }
        },
        methods:{	
			calculatotalind(){
				let valdescacres 			= 0;
				let totaledicaosemimposto 	= 0;
				this.vldescmostrar			= 0;

				switch (parseInt(this.vtipodescacresedicao)) {
					case 0://Percentual
						valdescacres 		= this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						this.vldescmostrar 	= valdescacres;
						break;
					case 1://Valor
						valdescacres 		= this.vvalordescacresedicao;
						this.vldescmostrar 	= (valdescacres / (this.vqtditemedicao * this.vvlunitarioedicao) * 100).toFixed(2);
						break;
				}
				
				let ret = util.itemcomimposto(this.vdadosclasseitem, this.vvlunitarioedicao, this.vqtditemedicao, this.vdescacresedicao, valdescacres);								

				this.vvltotalimpostoitemedicao = ret.totalimpostoitem;
				this.vvltotaledicao 		   = ret.vltotalitem;
				this.mtdtpdescacres(this.vtipodescacresedicao);
			},
			processaprodutos(items){
				for (let index = 0; index < items.length; index++) {

					let ret = util.itemcomimposto(this.mtdclasseitem(items[index].prod.classes), items[index].prod.prtabela, items[index].qtd, 0, 0);
					   
						if(util.findValInArray(this.lstitens, 'idproduto', items[index].id)){ ///se ja existir na listagem
							let ind = util.getArrayIndexForKey(this.lstitens, 'idproduto', items[index].id);

							let retalt = util.itemcomimposto(this.mtdclasseitem(items[index].prod.classes), items[index].prod.prtabela, items[index].qtd, 0, 0);
							
							this.lstitens[ind].qtditem        = this.lstitens[ind].qtditem + items[index].qtd;
							this.lstitens[ind].vltotal        = this.lstitens[ind].vltotal + retalt.vltotalitem
							this.lstitens[ind].vltotalimposto = this.lstitens[ind].vltotalimposto + retalt.totalimpostoitem
						}else{
							let itemtmp = {
								idproduto		    : items[index].id,
								descproduto		    : items[index].prod.descricao, //trazer do payload
								coddig			    : items[index].id,
								item			    : this.lstitens.length + 1,
								qtditem			    : items[index].qtd, //trazer do payload,
								unditem			    : items[index].prod.und, //trazer do payload,
								vlunitario		    : items[index].prod.prtabela, //trazer do payload,
								descacres		    : 0,
								tipodescacres	    : 0, 
								valordescacres	    : 0,
								manipulaval		    : 0,
								vltotal			    : ret.vltotalitem, //trazer do payload, 
								vltotalimposto      : ret.totalimpostoitem, //trazer do payload,
								idestoque		    : this.$store.state.filialpadrao.idestoque,
								descestoque		    : this.$store.state.filialpadrao.descestoque, //não sei como, mas vou dar um jeito de trazer do payload tambem,
								infadprod		    : '',
								qtdentregar		    :  0, //trazer do payload, 
								idtecnicosolicita   :  0,
								nometecnicosolicita : ''						
							};	
							this.lstitens.push(itemtmp);
						}
				}
				this.mtdrecalcularprecos();
			},
			mtdclcula() {
				if (this.vlegcredanterior !== this.evledicaocreditoavulso) {
					if (parseInt(this.defsubs) === 1) {
						this.vvlcredcedido += this.evledicaocreditoavulso;
					}else {
						this.vvlcredcedido -= this.evledicaocreditoavulso;
					}
					this.vlegcredanterior = this.evledicaocreditoavulso;
				}
				this.vlcreditotot = this.vvlcredcedido + this.vvlcredadquirido;
			},
			mtdprocessaselecionados(){
				let vself = this;
				setTimeout(() => {
					vself.vpedidosselecionados = vself.$refs.reflstpedidos.selected_items
				}, 300);
			},
			mtddimprimeguia(){
				let vself 			= this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Deseja imprimir a guia?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'cancelar',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						normal: {
							text: '<u>N</u>ormal',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								vself.mtdimprimisep(1)//normal
							},
						},
						sint: {
							text: '<u>S</u>intetizada',
							keys: ['s', 'S'],
							btnClass: 'btn-success',
							action: function () {
								vself.mtdimprimisep(2)//sintetizada
							},
						},
						cancelar: {
							text: '<u>C</u>ancelar',
							keys: ['n', 'N'],
							action: function () {
							

							}
						}
					}
				});
			},
			mtdimprimisep(tipo){
				let lstpedidosimp = '';
				for (var i = 0; i < this.$refs.reflstpedidos.selected_items.length; i++) {
					lstpedidosimp = lstpedidosimp+', '+this.$refs.reflstpedidos.selected_items[i].id; 
				}

				if(tipo == 1){  //1 - normal 2 - sintetizada
					window.open(this.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+'&op=imprimirguiaseparacaorota'+
								'&idu='+
								 this.$store.state.usuario.id+
								'&pedidos='+lstpedidosimp.substring(2), '_blank');
				}
				if(tipo == 2){
					window.open(this.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+'&op=imprimirguiaseparacaosintetizada'+
								'&idu='+
								 this.$store.state.usuario.id+
								'&pedidos='+lstpedidosimp.substring(2), '_blank');
				}
			},
			mtdchecklist(){
				var vself       = this;
				let loader      = this.$loading.show();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : ''},
					{parametro: 'limit',        valor : '99999999999'},
					{parametro: 'offset',       valor : '0'},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadchecklist.php');
				retorno.then(function (response) {
					vself.lstchecklist = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lstchecklist = [];
					loader.hide();
				});
			},
			mtdquantidade(op){
				if (parseInt(op) === 1){
					this.vqtditemedicao++;
				}else{
					if (parseFloat(this.vqtditemedicao) > 1){
						this.vqtditemedicao--;
					}
				}
			},			
            mtdselecionarimagem(event){
                let vself               = this;
                vself.arqimgselecionado = event.target.files[0];
                let loader              = vself.$loading.show();
                let localsalvar         = vself.$store.state.configpaths.pathimgpedidos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name},
                    {parametro: 'nomediferente',    valor  : 1},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = response.data.arquivos;
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimg').val('');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdexcluirimgpedido(patharquivo){
                let vself        = this;
                let loader       = vself.$loading.show();
                let localarquivo = vself.$store.state.configpaths.pathimgpedidos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = response.data.arquivos;
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                  
            },			
			mtdmostradetcred(pedido){
				this.detcredito.idpedido 			    = pedido.id;
				this.detcredito.vlcredito			    = pedido.vlcredito;
				this.detcredito.vlcreditoutilizado  	= pedido.vlcreditoutilizado;
				this.detcredito.vlcreditodisponivel 	= this.detcredito.vlcredito - this.detcredito.vlcreditoutilizado;
				this.detcredito.lsthistorico			= pedido.historicocredito;
				this.detcredito.lsthistoricoreccredito  = pedido.historicoreccredito;
				
				if (pedido.detcashback.length > 0){
					this.detcredito.detalhecashback 	= pedido.detcashback
				}else{	
					this.detcredito.detalhecashback.disponiveis = 0;
					this.detcredito.detalhecashback.vencidos 	= 0;
					this.detcredito.detalhecashback.lista		= [];
				}

				$('#mddetalhescredito').modal('show');
			},
			mtdatzvariaveisperfil(){
				this.pmanipularvaloritem = util.opcaousuario('020Z.010Z.070Z', this.$store.state.perfilusuario) === false ? true : false;
				this.pdefinirestoque 	 = util.opcaousuario('020Z.010Z.080Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterardatafatura  = util.opcaousuario('020Z.010Z.100Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterarvendedor	 = util.opcaousuario('020Z.010Z.120Z', this.$store.state.perfilusuario);
			},
			mtdimprimirpedido(idpedido, tp){				
				$('#mdmenupedido').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
			mtdimprimirguiaseparacao(idpedido, tp){	
				if (parseInt(this.pedidomenu.tipo) === 3){
					this.$toastr.i('Guia de separação somente para pedidos!', 'Informação!');
					return;
				}
				if (parseFloat(this.pedidomenu.totalgeral) <= 0){
					this.$toastr.w('Guia de separação somente para pedidos!', 'Atenção!');
					return;
				}											
				$('#mdmenupedido').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirguiaseparacao.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},			
			mtdimprimirdanfe(pedido){
				$('#mdmenupedido').modal('hide');
				if (parseInt(pedido.situacaonota) === 2){
					window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+
								'&idnf='+pedido.idnotafiscal+'&docimp=danfe', '_blank');
				}else{
					this.$toastr.i('Nota não liberada para impressão!', 'Atenção!');
				}			
			},
			mtdmostrarmenu(pedido){				
				this.pedidomenu = pedido;
				$('#mdmenupedido').modal('show');
			},
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
            mtdconsultarcliente(){
				if (parseInt(this.opcrud) < 3){
					this.vidcliente 	= '';
					this.vnomecliente 	= '';
					this.lstplanos		= [];
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_CLIENTE_CHANGE',payload);
					let payloadx = {
						idcliente    : null			
					};
					this.$store.commit('CLIENTE_RETORNO_CHANGE',payloadx);                
				}
			},	
            mtdlocalizarcliente(idcliente){
				if (idcliente !== '' && idcliente !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and c.ativo=0 and c.id='+idcliente},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let cliente = response.data[0];							
							vself.vidcliente  			    = cliente.id;
							vself.vnomecliente 				= cliente.nome;
							vself.vvlcreditoclidet			= cliente.vlcredito;
							vself.vidplano 					= null;
							vself.vtipoplano				= 0;
							vself.vdescplano				= '';
							vself.vidtabela					= null;												
							vself.vpercentrada				= 0;
							vself.vpermitedesconto			= 0;
							vself.mtdlocalizarplanos();
							vself.$nextTick(function () {
								$('#cbplano').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidcliente 	= '';
							vself.vnomecliente 	= '';
							vself.vidplano 		= null;
							vself.vtipoplano	= 0;
							vself.vpercentrada	= 0;
							vself.vpermitedesconto = 0;
							vself.vdescplano	= '';
							vself.vidtabela		= null;								
							vself.lstplanos		= [];
							$('#edcliente').focus();
						}
					}).catch(function (response) {
						vself.lstplanos = [];
						loader.hide();
					});
				}else{
					this.vidcliente 	= '';
					this.vnomecliente 	= '';
					this.vidplano 		= null;
					this.vtipoplano		= 0;
					this.vdescplano		= '';
					this.vidtabela		= null;
					this.vpercentrada   = 0;					
					this.vpermitedesconto = 0;
					this.lstplanos		= [];
				}
            },
			mtdclasseitem(classes){
				let vself = this;
				if (classes.length > 0){
					let indc = util.getArrayIndexForKey(classes, 'idfilial', vself.vidfilial);
					if (indc > -1){
						return classes[indc];
					}else{
						return [];
					}
				}else{
					return [];
				}
			},					
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ' and p.tipo in (0, 2)'},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id; //
							vself.vdescricaoprodutoedicao 	= produto.descricao; //
							vself.vundprodutoedicao			= produto.und; //
							vself.vfracionadoedicao			= produto.fracionado;//
							vself.vvltabelaitemedicao		= util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela);
							vself.vvltabelaitemedicao 		= parseFloat(vself.vvltabelaitemedicao).toFixed(2);//acrescentei essa linha pra arredondar o valor
							vself.vvlunitarioedicao			= vself.vvltabelaitemedicao;
							vself.vdadosclasseitem			= vself.mtdclasseitem(produto.classes);

							let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);

							//carrega o desconto promocional
							vself.vldescpromocionalitemedicao= produto.tabelas[it].vldescpromocional

							if (parseFloat(produto.tabelas[it].vldescpromocional) > 0){
								vself.alteraentra = true;
								vself.vdescacresedicao		= 0;
								vself.vtipodescacresedicao  = 0;
								vself.vvalordescacresedicao = parseFloat(produto.tabelas[it].vldescpromocional);						
							}
							vself.$nextTick(function () {
								$('#edqtditemedicao').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.mtdlimparedicaoitem();
				}
            },			
            mtdconsultarproduto(){
				if (parseInt(this.vopitem) === 1){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
			mtdselect2_servico_def(){
				let vself = this;
				$("#cbservico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbservicos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidservicoedicao = $("#cbservico").val();
					if (vself.vidservicoedicao !== null){
						let loader      = vself.$loading.show();
						let filtro      = ' and id='+vself.vidservicoedicao;
						let parametros  = [
							{parametro: 'op',           valor : 'listagem'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',       valor : filtro},
							{parametro: 'limit',        valor : 1},
							{parametro: 'offset',       valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadservicos.php');
						retorno.then(function (response) {
							loader.hide();
							let servico = [];
							servico     = response.data[0];
							vself.vprecoservicoedicao = [];
							vself.vprecoservicoedicao = util.mtdcarregaprecoservicofilial(servico.precos, vself.vidfilial);
							vself.vvlservicoedicao 	  = vself.vprecoservicoedicao.vlservico;						
						}).catch(function (response) {
							loader.hide();
						});	
					}				
				});
			},
            mtdselect2_def(){
				let vself = this;
				$('#mdedicaoitem').on('show.bs.modal', function (e) {
				});				
				$('#mdedicaoitem').on('shown.bs.modal', function (e) {
					if (parseInt(vself.vopitem) === 1){
						$('#edidprodutoedicao').focus();
					}else{
						$('#edqtditemedicao').focus();
					}
				});
				$('#mdaplicardesconto').on('shown.bs.modal', function (e) {
					$('#cbtipodesctotal').focus();
				});

				$('#mdrecibopedido').on('shown.bs.modal', function (e) {
					$('#edprformapagamento').focus();
				});
				$('#mdanalisecortes').on('show.bs.modal', function (e) {
					vself.ctipo 		= 0;
					vself.cdiferenca	= 2;
					vself.cdtini       	= util.DataAtual(true);
					vself.cdtfim       	= util.DataAtual(true);					
					vself.cqtditenscorte= 0;
					vself.ctotalcortes	= 0;
					vself.lstitenscorte = [];
				});
				$('#mdanalisecortes').on('shown.bs.modal', function (e) {
					vself.ctipo 		= 0;
					vself.lstitenscorte = [];
					$('#edcdtini').focus();
				});

				$('#mdcorteitem').on('shown.bs.modal', function (e) {
					$('#edqtditemcortar').focus();
				});				
							
				$('#mditenscortados').on('shown.bs.modal', function (e) {
					$('#edlcdtini').focus();
				});				

				$('#mdmenupedido').on('show.bs.modal', function (e) {
					vself.eopimpentrega = 0;
					$('#dvdefnf').collapse('hide');
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
					$('#dvdefentrega').collapse('hide');
				});	
				
				$('#dvdefimpressao').on('shown.bs.collapse', function () {
					$('#dvdefnf').collapse('hide');
					$('#dvdefentrega').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
				});
				$('#dvdefguiaseparacao').on('shown.bs.collapse', function () {
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefnf').collapse('hide');
					$('#dvdefentrega').collapse('hide');
				});				

				$('#dvdefnf').on('shown.bs.collapse', function () {
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefentrega').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
				});				

				$('#dvdefentrega').on('shown.bs.collapse', function () {
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefnf').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
				});	


				$('#mdcreditoavulso').on('shown.bs.modal', function (e) {
					vself.vidfilialca			= null;
					vself.vidclienteca			= null;
					vself.vvalorcreditoavulso	= 0;
					vself.vobservacoesca		= '';
					
					var deffilial  				= new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
					$('#cbfilialca').append(deffilial).trigger('change');

					$("#cbclienteca").val(null).trigger('change');					

					$("#cbfilialca").select2("open");
				});

				$('#mddevolucao').on('shown.bs.modal', function (e) {
					$('#eddtdevolucao').focus();
				});

				$('#mddefinefilialnf').on('shown.bs.modal', function (e) {
					vself.habbtnf 				= false;
					var deffilial  				= new Option(vself.vnomefilianf, vself.vidfilialnf, true, true);
					$('#cbfilialnf').append(deffilial).trigger('change');					
					//$('#cbfilialnf').select2('open');
				});								


				$('#mdedicaocreditoavulso').on('shown.bs.modal', function (e) {
					$('#txteobsalteracaocredito').focus();
				});

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';			

				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				}); 
				$("#cbestoqueedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueedicao = $("#cbestoqueedicao").val();
				});
				$("#cbtecnico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtecnicoedicao = $("#cbtecnico").val();
				});				

				$("#cbtecnicosolicitaedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtecnicosolicitaedicao = $("#cbtecnicosolicitaedicao").val();
				});				


				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
					vself.mtdlocalizarplanos();
					vself.mtdselect2_servico_def();
				});


				$("#cbfilialnf").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialnf = $("#cbfilialnf").val();
				});				
				
				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcliente = $("#cbclientepesq").val();
				});
				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidvendedor = $("#cbvendedorpesq").val();
				});
				$("#cbplanopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbplanospagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidplano = $("#cbplanopesq").val();
				});
				$("#cbrotapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidrota = $("#cbrotapesq").val();
				});
				
				$("#cbformapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidforma     = $("#cbformapesq").val();
				});				
				//campos para faturamento
				$('#mdalterartitulo').on('shown.bs.modal', function (e) {
					$('#eddtventit').focus();
				});				
				$("#cbformapagamento").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformapagamento     = $("#cbformapagamento").val();
                    if (vself.vidformapagamento != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and f.id='+vself.vidformapagamento},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                        retorno.then(function (response) {
                            vself.vtipoforma = parseFloat(response.data[0].tipo); 
							vself.vespecieforma = parseFloat(response.data[0].especie);
							vself.vabatecredito = parseInt(response.data[0].abatecredito); 
							vself.vnrvendaforma = '';					
							vself.vidperfilfluxoforma   = 0;                
							vself.vdescperfilfluxoforma = ''; 																			
                            loader.hide();

							if (parseInt(vself.vabatecredito) === 1){//localiza o crédito quando houver
								let loader      = vself.$loading.show();
								let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.pedidofaturar.idcliente;
								let parametros  = [
									{parametro: 'op',           	valor : 'listagem'},
									{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
									{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'filtro',       	valor : filtro},
									{parametro: 'limit',        	valor : 1},
									{parametro: 'offset',       	valor : 0},
								];
								let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if (response.data.pedidos.length > 0){
										let vllimitecreditoabater = util.arredondaValores( parseFloat(vself.pedidofaturar.fatorcreditoutilizar) * parseFloat(vself.pedidofaturar.totalgeral) / 100, 2, 'round');				
										let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
										if (parseInt(parseFloat(vlcreditodisp) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
											vself.vvlforma = vllimitecreditoabater;
										}else{
											vself.vvlforma = vlcreditodisp;
										}
										//vself.vvlforma = util.arredondaValores(parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado) * parseFloat(response.data.pedidos[0].fatorcreditoutilizar) / 100, 2, 'round');
										vself.vnrvendaforma = response.data.pedidos[0].id;
									}
								}).catch(function (response) {
									console.log(response);
									vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
									$('#cbformapagamento').focus();
									loader.hide();
								});
							}
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vtipoforma = 0;
						vself.vespecieforma = 0;
						vself.vabatecredito = 0;
						vself.vnrvendaforma = '';
                        vself.vidperfilfluxoforma   = 0;                
                        vself.vdescperfilfluxoforma = ''; 												
                    }										
				});

				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.taidtipocobranca != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.taidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.tatipocobranca = parseFloat(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.tatipocobranca = 0;
                    }					
				});

				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidbanco = $("#cbbanco").val();
				});

				$("#cbsituacaocheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidsituacaocheque = $("#cbsituacaocheque").val();
				});

				//cancelamento
				$('#mdcancelarpedido').on('shown.bs.modal', function (e) {
					$('#txtmotivocancelamento').focus();
				});
				
				$('#mdalteracaoqtdlevar').on('shown.bs.modal', function (e) {
					$('#edqtdlevar').focus();
				});	
				
				$('#mddefinirqtdentregue').on('shown.bs.modal', function (e) {
					$('#edqtdlevarentrega').focus();
				});	
				
                $("#cbperfilfluxofinal").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aidperfilfluxo = $("#cbperfilfluxofinal").val();
                });

				$("#mdlalterarperfilfluxofinal").on('show.bs.modal', function(){
					$('#cbperfilfluxofinal').select2('open');
				});	
				
				//itens cortados
				$("#cblcvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidvendedor = $("#cblcvendedor").val();
				});	
				
				//crédito avulso
				$("#cbfilialca").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialca = $("#cbfilialca").val();
				});

				$("#cbclienteca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidclienteca = $("#cbclienteca").val();
				});

			},
			mtdlocalizarplanos(){
				let vself = this;
				if (vself.vidfilial !== null && vself.vidcliente !== ''){	
					vself.vidplano  	= null;
					vself.vtipoplano	= 0;
					vself.vidtabela		= null;												
					vself.vpercentrada 	= 0;				
					vself.vpermitedesconto = 0;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',           valor : 'planospedido'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idfilial',     valor : vself.vidfilial},
						{parametro: 'idcliente',    valor : vself.vidcliente}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						loader.hide();
						vself.lstplanos  = response.data;
					}).catch(function (response) {
						vself.lstplanos  = [];
						loader.hide();
					});				
				}else{
					vself.vidplano   	= null;
					vself.vtipoplano 	= 0;
					vself.vidtabela		= null;												
					vself.vpercentrada 	= 0;
					vself.vpermitedesconto = 0;
					vself.lstplanos  	= [];					
				}
			},
			mtdidtabelaplano(idplano){
				this.vidtabela = util.getValInArray(this.lstplanos, 'id', idplano, 'idtabela');
			},	
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (this.pidpedido !== ''){
                    rfiltro = ' and p.id='+this.pidpedido;
				}
                if (parseInt(this.psituacao) < 3){
                    rfiltro = rfiltro + ' and p.stpedido='+this.psituacao;
				}	
				if (this.pidfilial !== null){
					rfiltro = rfiltro + ' and p.idfilial='+this.pidfilial;
				}
				if (this.pidcliente !== null){
					rfiltro = rfiltro + ' and p.idcliente='+this.pidcliente;
				}
				if (this.pidvendedor !== null){
					rfiltro = rfiltro + ' and p.idvendedor='+this.pidvendedor;
				}
				if (this.pidrota !== null){
					rfiltro = rfiltro + ' and c.idrota='+this.pidrota;
				}				
				if (this.pidplano !== null){
					rfiltro = rfiltro + ' and p.idplano='+this.pidplano;
				}
				if (this.pidforma !== null){
					rfiltro = rfiltro + ' and fpp.idforma='+this.pidforma;
				}
				
				if (parseInt(this.pfiltroperiodo) === 1){
					if (parseInt(this.pfiltropor) === 0){
						rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
					}else if (parseInt(this.pfiltropor) === 1){
						rfiltro = rfiltro + ' and p.dtfatura between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
					}else{
						rfiltro = rfiltro + ' and p.dtretorno is not null and p.dtretorno between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
					}
				}				

				if (parseInt(this.ptipo) < 4){
					rfiltro = rfiltro + ' and p.tipo='+this.ptipo;
				}else if(parseInt(this.ptipo) === 5){
					rfiltro = rfiltro + ' and p.tipo <> 3';
				}
				if (this.pidentificador !== ''){
					rfiltro = rfiltro + ' and upper(p.identificador) like upper("'+this.pidentificador+'%")';
				}
				if (this.presponsavel !== ''){
					rfiltro = rfiltro + ' and upper(p.responsavel) like upper ("'+this.presponsavel+'%")';
				}
                if (parseInt(this.pentregaexterna) < 2){
                    rfiltro = rfiltro + ' and p.entregaexterna='+this.pentregaexterna;
				}
                if (parseInt(this.pentregaexterna) < 2){
                    rfiltro = rfiltro + ' and p.entregaexterna='+this.pentregaexterna;

					if (parseInt(this.psituacaoentrega) < 2){
						rfiltro = rfiltro + ' and p.entregaexternafinalizada='+this.psituacaoentrega;
					}
				}
					if (parseInt(this.pcredito) < 2){
					if (parseInt(this.pcredito) === 0){
						rfiltro = rfiltro + ' and p.vlcredito = 0';
					}else{
						rfiltro = rfiltro + ' and p.vlcredito > 0';
					}
				}
				if (parseInt(this.porigem) < 10){
					rfiltro = rfiltro + ' and p.origem='+this.porigem;
				}
                return rfiltro;
            },
            mtdexecutapesquisa(){
				let vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}				
				let filtro          = vself.mtdfiltropesquisa();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}					
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
					vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregapedidos(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});				
            },
            mtdcarregapedidos(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				let filtro      = vself.mtdfiltropesquisa();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'infcredito',   valor : 1},					
					{parametro: 'limit',        valor : vself.pqtdregistros},
					{parametro: 'idforma',      valor : vself.pidforma},
					{parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					vself.lstpedidos = response.data.pedidos;
					//totalizadores
					vself.ptotalaberto		= response.data.totalaberto;
					vself.ptotalfaturado	= response.data.totalfaturado;
					vself.ptotalcusto		= response.data.totalcusto;
					vself.ptotalcancelado	= response.data.totalcancelado;
					vself.ptotaldesconto	= response.data.totaldesconto;
					vself.ptotaldescontoperc= parseFloat(response.data.totaldesconto) > 0 ? util.arredondaValores(parseFloat(response.data.totaldesconto) / (response.data.totalaberto + response.data.totalfaturado + response.data.totaldesconto) * 100, 2, 'round') : 0;
					vself.ptotalcreditos    = response.data.totalcreditos;
					vself.pqa				= response.data.qa;
					vself.pqf				= response.data.qf;
					vself.pqc				= response.data.qc;
					vself.pqca				= response.data.qca;
					loader.hide();											
				}).catch(function (response) {
					vself.lstpedidos = [];
					loader.hide();
				});
            },
            resetarDados(callback) {
                util.toTop();
                this.vid                = '';
				this.vidfilial          = this.$store.state.filialpadrao.codfil;
				this.vidcliente			= '';
				this.vnomecliente		= '';
				this.vidvendedor		= this.$store.state.usuario.idvendedor;
				this.vtipo				= 0;
				this.vdtemissao			= util.DataAtual();
				this.vidplano			= null;
				this.vtipoplano			= 0;
				this.vidtabela			= null;												
				this.vpercentrada		= 0;
				this.vpermitedesconto   = 0;
				this.vtotalprodutos		= 0;
				this.vtotalservicos		= 0;
				this.videntificador		= '';
				this.vobjeto			= '';
				this.vmarcacao			= '';
				this.vnrserie			= '';
				this.vmarca				= '';
				this.vmodelo			= '';
				this.vresponsavel		= '';
				this.vfone				= '';
				this.vdtretorno			= '',
				this.vdefeitoapresentado= '';
				this.vacessorios		= '';
				this.voutrasinformacoes	= '';
				this.vobservacoes		= '';
				this.sringaleatoria     = '';
				//this.vtotalimpostos		= 0;
				this.vtotalgeral		= 0;
				this.vstpedido			= 0;
				this.vdtfatura			= '';
				this.vreservar			= false;
				this.ventregaexterna	= false;
				this.vorigem			= 0;
				this.vpathimagens       = '';
				this.lstitens			= [];
				this.lstservicos		= [];
				this.lstplanos			= [];
				this.lstImagens			= [];
				this.lstchecklist		= [];
				
				this.vitem				= 0;//contador dos itens

				$("#cbservico").val(null).trigger('change');
				$("#cbtecnico").val(null).trigger('change');

				if (parseInt(this.opcrud) === 1){
					var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
					$('#cbfilial').append(deffilial).trigger('change');	
					this.vidcliente			= this.$store.state.filialpadrao.idclientepadrao;
					this.vnomecliente		= this.$store.state.filialpadrao.nomecliente;
					this.mtdlocalizarplanos();
					this.vidplano 			= this.$store.state.filialpadrao.idplano;					
					this.vdescplano			= this.$store.state.filialpadrao.descplano;
					this.vtipoplano			= this.$store.state.filialpadrao.tipoplano;
					this.vidtabela			= this.$store.state.filialpadrao.idtabela;									
					this.vpercentrada		= this.$store.state.filialpadrao.percentrada;
					this.vpermitedesconto	= this.$store.state.filialpadrao.permitedesconto;
					var defvendedor  		= new Option(this.$store.state.usuario.nomevendedor, this.vidvendedor, true, true);
					$('#cbvendedor').append(defvendedor).trigger('change');					
				}
				callback;
            },
            mtddefault(){
				let vself = this;
				$('#pnlista').hide();
				vself.resetarDados(vself.mtdchecklist());
				$('#pncadastro').fadeIn(700);
				setTimeout(function(){
                    if (parseInt(vself.opcrud) < 3) {
						$('#cbfilial').focus();					
                    } else {
						$('#btgravar').focus();						
                    }
				},200);
            },
            mtdpreparacrud(op) {
                let vself    	= this;
				vself.opcrud 	= op;
                $('.nav-tabs a[href="#dvprodutos"]').tab('show');
                vself.mtddefault();
				vself.sringaleatoria = util.GerarStringAleatoria()
				

            },
            mtdnovo(){
				if (!util.opcaousuario('020Z.010Z.010Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo 	= 'INCLUSÃO - GESTÃO DE PEDIDOS DE VENDA';
					this.itensbc.item1.ativo 	= true;
					this.itensbc.item2.ativo 	= true;
					this.ativadesativa 			= false;
					this.ativadesativavendedor 	= false;
					this.mtdpreparacrud(1);
					this.vpathimagens = util.GerarStringAleatoria();
				}
            },
            mtdcancelaredicao(){
				this.opcrud = 0;
				this.pedidoentrega		= [];
				this.eitementregar		= [];
				this.eqtdentregue		= 1;
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
				$('#pnentregaexterna').hide();
				$('#pnconferencia').hide();				
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
				// $( '#dvlistagempedidos .table-responsive' ).css('height', 'auto');
				let vself = this;
                vself.lstpedidos 	= [];
                vself.pagina_atual 	= 1;
                vself.filtro 		= '';
                vself.pqtd_total_registros 	= 0;
				vself.pqtd_paginas 			= 0;

				///variaveis listagem
				vself.$refs.reflstpedidos.selected_items = [];
				vself.$refs.reflstpedidos.unSelectAllItems();

				//totalizadores
				vself.ptotalaberto		= 0;
				vself.ptotalfaturado	= 0;
				vself.ptotalcusto		= 0;
				vself.ptotalcancelado	= 0;
				vself.ptotaldesconto	= 0;
				vself.ptotaldescontoperc= 0;
				vself.ptotalcreditos    = 0;
				vself.pqa				= 0;
				vself.pqf				= 0;
				vself.pqc				= 0;
				vself.pqca				= 0;							
            },
            mtdgravar(){
				let vself 			= this;
				let temprecozerado = false;
				for (let item of vself.lstitens) {
					if (parseFloat(item.vlunitario) <= 0){
						temprecozerado = true;
						break;
					}
				}
				if (temprecozerado){
					vself.$toastr.w('Existe(m) algum(ns) ítem(ns) com preço menou ou igual a zero. Verifique e tente novamente!', 'Atenção!');
					return;
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdregistro();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
					loader.hide();
					if (!vself.clonar){	
						if (parseInt(response.data.pedidos[0].origem) === 4){
							vself.$toastr.i('Operação não permitida para pedidos de origem externa!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}

						if (parseInt(response.data.pedidos[0].stpedido) !== 0){
							vself.$toastr.i('Para EDITAR ou REMOVER o pedido, a situação do mesmo deve estar em aberto!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}

						if (parseInt(response.data.pedidos[0].liberarpdv) === 1){
							vself.$toastr.i('Para EDITAR ou REMOVER o pedido, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}	
					}else{
						vself.clonar = false;
					}				

                    vself.mtdigualarcampos(response.data.pedidos[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
					}					
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
				$('#mdmenupedido').modal('hide');
				if (parseInt(item.tipo) !== 3){
					if (!util.opcaousuario('020Z.010Z.020Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {						
						this.itensbc.item2.titulo 	= 'ALTERAÇÃO - GESTÃO DE PEDIDOS DE VENDA';
						this.itensbc.item1.ativo 	= true;
						this.itensbc.item2.ativo 	= true;
						this.ativadesativa 			= false;
						if (this.palterarvendedor === true){
							this.ativadesativavendedor = false;
						}else{
							this.ativadesativavendedor = true;
						}
						this.mtdpreparacrud(2);
						this.mtdlocalizaregistro(item.id);
					}
				}else{
					if (!util.opcaousuario('020Z.010Z.025Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {
						this.defsubs                = 0;
						this.vermelho               = true;	
						this.evledicaocreditoavulso	= 0;				
						this.ecreditoavulso 		= item;
						this.eobsalteracaocredito 	= '';
						this.vlegcredavulso         = item.vlcreditocedido
						this.vvlcredadquirido       = item.vlcreditoadquirido;
						this.vlcreditotot           =  this.vvlcredadquirido + this.vlegcredavulso 			
						$('#mdedicaocreditoavulso').modal('show');
					}
				}
            },
            mtdclonar(item){
				let vself = this;
				$('#mdmenupedido').modal('hide');

				if (parseInt(item.tipo) === 3){
					this.$toastr.i('Impossível clonar um crédito avulso!', 'Informação!');
					return;
				}

				if (parseFloat(item.totalgeral) <= 0){
					this.$toastr.w('Impossível clonar um pedido de crédito!', 'Atenção!');
					return;
				}				

				if (!util.opcaousuario('020Z.010Z.063Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {						
					this.itensbc.item2.titulo 	= 'INCLUSÃO - GESTÃO DE PEDIDOS DE VENDA';
					this.itensbc.item1.ativo 	= true;
					this.itensbc.item2.ativo 	= true;
					this.ativadesativa 			= false;
					if (this.palterarvendedor === true){
						this.ativadesativavendedor = false;
					}else{
						this.ativadesativavendedor = true;
					}
					this.clonar = true;
					this.mtdpreparacrud(1);
					this.mtdlocalizaregistro(item.id);
					setTimeout(() => {
						vself.vid = '';

					}, 200);
				}
            },			
            mtdexcluir(item){
				$('#mdmenupedido').modal('hide');
				if (!util.opcaousuario('020Z.010Z.030Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'EXCLUSÃO - GESTÃO DE PEDIDOS DE VENDA';
					this.itensbc.item1.ativo = true;
					this.itensbc.item2.ativo = true;
					this.ativadesativa = true;
					this.ativadesativavendedor = true;
					this.mtdpreparacrud(3);
					this.mtdlocalizaregistro(item.id);
				}
            },
            mtdigualarcampos(registro){
                this.vid                = registro.id;
				//this.vidfilial          = registro.idfilial;
				this.vidcliente			= registro.idcliente;
				this.vnomecliente		= registro.nomecliente;
				//this.vidvendedor		= registro.idvendedor;
				this.vtipo				= registro.tipo;
				this.vdtemissao			= registro.dtemissao;
				this.vtotalprodutos		= registro.totalprodutos;
				this.vtotalservicos		= registro.totalservicos;
				this.videntificador		= registro.identificador;
				this.vobjeto			= registro.objeto;
				this.vmarcacao			= registro.marcacao;
				this.vnrserie			= registro.nrserie;
				this.vmarca				= registro.marca;
				this.vmodelo			= registro.modelo;
				this.vresponsavel		= registro.responsavel;
				this.vfone				= registro.fone;
				this.vdtretorno			= registro.dtretorno === null ? '' : registro.dtretorno;
				this.vdefeitoapresentado= registro.defeitoapresentado;
				this.vacessorios		= registro.acessorios;
				this.voutrasinformacoes	= registro.outrasinformacoes;
				this.vobservacoes		= registro.observacoes;
				this.vtotalgeral		= registro.totalgeral;
				this.vstpedido			= registro.stpedido;
				this.vdtfatura			= registro.dtfatura;
				this.vreservar			= parseInt(registro.reservar) === 0 ? false : true;
				this.ventregaexterna	= parseInt(registro.entregaexterna) === 0 ? false : true;
				this.vorigem			= registro.origem;
				this.vpathimagens       = registro.pathimagens !== '' ? registro.pathimagens : util.GerarStringAleatoria();				
				this.lstservicos		= registro.servicos;
				this.lstImagens         = registro.imagens;			

				this.vitem				= registro.itens.length === 0 ? 0 : registro.itens[registro.itens.length - 1].item;

                var deffilial  = new Option(registro.fantasia, registro.idfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');
				
                var defvendedor  = new Option(registro.nomevendedor, registro.idvendedor, true, true);
				$('#cbvendedor').append(defvendedor).trigger('change');


				this.vidplano			= registro.idplano;
				this.vtipoplano			= registro.tipoplano;
				this.vdescplano			= registro.descplano;
				this.vidtabela			= registro.idtabela;
				this.vpercentrada		= registro.percentrada;
				this.vpermitedesconto	= registro.permitedesconto;

				if (registro.checklist.length > 0){
					for (let i = 0; i < registro.checklist.length; i++) {
						if (util.findValInArray(this.lstchecklist, 'id', registro.checklist[i].idchecklist)){
							let ii = util.getArrayIndexForKey(this.lstchecklist, 'id', registro.checklist[i].idchecklist);
							this.lstchecklist[ii].habilita = 1;
						}												
					}
				}

				setTimeout(() => {
					this.lstitens			= registro.itens;
				}, 500);

            },
            mtdregistro(){
				let vself  = this;
                let loader = vself.$loading.show();
				let lstcltmp = [];
				for (let i = 0; i < vself.lstchecklist.length; i++) {
					if (parseInt(vself.lstchecklist[i].habilita) === 1){
						lstcltmp.push(vself.lstchecklist[i]);
					}					
				}
                let registrocrud = {
                    'id'                : this.vid,
					'idfilial'          : this.vidfilial,
					'idcliente'			: this.vidcliente,
					'idvendedor'		: this.vidvendedor,
					'tipo'				: this.vtipo,
					'dtemissao'			: this.mtdformatadatagravar(this.vdtemissao),
					'idplano'			: this.vidplano,
					'totalprodutos'		: this.vtotalprodutos,
					'totalservicos'		: this.vtotalservicos,
					'identificador'		: this.videntificador,
					'objeto'			: this.vobjeto,
					'marcacao'			: this.vmarcacao,
					'nrserie'			: this.vnrserie,
					'marca'				: this.vmarca,
					'modelo'			: this.vmodelo,
					'responsavel'		: this.vresponsavel,
					'fone'				: (this.vfone !== '' && this.vfone !== null) ? this.vfone.replace(/[^0-9]/g,'') : '',
					'dtretorno'			: this.vdtretorno !== '' ? this.mtdformatadatagravar(this.vdtretorno) : '',
					'defeitoapresentado': this.vdefeitoapresentado,
					'acessorios'		: this.vacessorios,
					'outrasinformacoes'	: this.voutrasinformacoes,
					'observacoes'		: this.vobservacoes,
					'totalgeral'		: this.vtotalgeral,
					'stpedido'			: this.vstpedido,
					'dtfatura'			: this.vdtfatura,
					'reservar'			: this.vreservar === false ? 0 : 1,
					'entregaexterna'	: this.ventregaexterna === false ? 0 : 1,
					'origem'			: this.vorigem,
					'pathimagens'       : this.vpathimagens, 
					'itens'				: this.lstitens,
					'servicos'			: this.lstservicos,
					'checklist'			: lstcltmp
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'straleatoria', valor : vself.sringaleatoria},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '020Z.010Z.010Z' : parseInt(this.opcrud) === 2 ? '020Z.010Z.010Z' : '020Z.010Z.030Z'},
					{parametro: 'faturarsemsaldo',	valor : util.opcaousuario('020Z.010Z.090Z', vself.$store.state.perfilusuario) === false ? 0 : 1}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= parseInt(vself.opcrud) === 1 ? response.data.inf : vself.vid;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 2;
						vself.porigem			= 10;					
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtdhabilitaedicaodescpro(){
				this.vedicaodescpro = false;
				setTimeout(function(){
            		$('#eddescricaoprodutoedicao').focus();
        		}, 300); 				
			},
			mtddesabilitaedicaodescpro(){
				this.vedicaodescpro = true;
			},			
			mtdlimparedicaoitem(){			
				this.vedicaodescpro				= true;
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vvlunitarioedicao			= 0;
				this.vldescpromocionalitemedicao= 0;
				this.vdescacresedicao			= 0;
				this.vtipodescacresedicao		= 0;
				this.vvalordescacresedicao		= 0;
				this.vmanipulavaledicao			= 0;
				this.vvltotalimpostoitemedicao  = 0;
				this.vvltotaledicao				= 0;
				this.vfracionadoedicao			= 0;
				this.vinfadprod					= '';
				this.vdadosclasseitem			= [];
				this.vldescmostrar				= 0;

				this.vidtecnicosolicitaedicao	= null;
				$("#cbtecnicosolicitaedicao").val('').trigger('change');

				//pega o estoque padrão da filial selecionada
				this.videstoqueedicao			= this.$store.state.filialpadrao.idestoque;
                var defestoque  				= new Option(this.$store.state.filialpadrao.descestoque, this.videstoqueedicao, true, true);
				$('#cbestoqueedicao').append(defestoque).trigger('change');
				   
			},
			mtdadcionaritem(){
				if (this.vidfilial === null){
					this.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilial').focus();
					return;
				}
				if (this.vidcliente === ''){
					this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edcliente').focus();
					return;
				}
				if (this.vidplano === null){
					this.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
					$('#cbplano').focus();
					return;
				}				
				this.vopitem					= 1;
				this.mtdlimparedicaoitem();
				$('#mdedicaoitem').modal('show');
			},
			mtdalteraritem(item){
				if (!util.opcaousuario('020Z.010Z.130Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}
				var vself       = this;
				if (vself.vidfilial === null){
					vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilial').focus();
					return;
				}
				if (vself.vidcliente === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edcliente').focus();
					return;
				}
				if (vself.vidplano === null){
					vself.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
					$('#cbplano').focus();
					return;
				}								
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ''},
					{parametro: 'coddig',           valor : item.coddig},
					{parametro: 'limit',            valor : 1},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					loader.hide();						
					if (response.data.length > 0){
						let produto = response.data[0];	

						vself.vvltotal_old_edicao		= item.vltotal;//variável para estornar o valor anterior
						//vself.vtotalimpostos_old_edicao = item.vltotalimposto;

						vself.vdadosclasseitem			= vself.mtdclasseitem(produto.classes);

						vself.alteraentra  				= true;																			
						vself.vopitem					= 2;
						vself.vitemalteracao			= item.item;
						vself.vedicaodescpro			= true;
						vself.vidprodutoedicao    		= item.idproduto;
						vself.vcoddigedicao				= item.coddig;
						vself.vdescricaoprodutoedicao 	= item.descproduto;
						vself.vundprodutoedicao			= item.unditem;
						vself.vqtditemedicao			= parseFloat(item.qtditem);
						vself.vvltabelaitemedicao		= parseFloat(util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela));						
						vself.vvlunitarioedicao			= parseFloat(item.vlunitario);

						//carrega o desconto promocional
						let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);
						vself.vldescpromocionalitemedicao 	= produto.tabelas[it].vldescpromocional;						
						///////////////////////////////

						vself.vdescacresedicao			= item.descacres;
						vself.vtipodescacresedicao		= item.tipodescacres;
						vself.vvalordescacresedicao		= parseFloat(item.valordescacres);
						vself.vmanipulavaledicao		= item.manipulaval;
						vself.vvltotaledicao			= parseFloat(item.vltotal);
						vself.vvltotalimpostoitemedicao = parseFloat(item.vltotalimposto);
						vself.vfracionadoedicao			= produto.fracionado;
						vself.vinfadprod				= item.infadprod;

						if (parseInt(item.idtecnicosolicita) > 0){
							vself.vidtecnicosolicitaedicao  = item.idtecnicosolicita;
							var deftec  				    = new Option(item.nometecnicosolicita, item.idtecnicosolicita, true, true);
							$('#cbtecnicosolicitaedicao').append(deftec).trigger('change');						
						}else{
							vself.vidtecnicosolicitaedicao  = null;
							$("#cbtecnicosolicitaedicao").val('').trigger('change');
						}

						vself.videstoqueedicao			= item.idestoque;
						var defestoque  				= new Option(item.descestoque, item.idestoque, true, true);
						$('#cbestoqueedicao').append(defestoque).trigger('change');

						$('#mdedicaoitem').modal('show');				
					}else{
						vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					}
				}).catch(function (response) {
					vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					loader.hide();						
				});
			},
			mtdgravaritem(){
				let vself = this;
				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}
				if (parseFloat(this.vvlunitarioedicao) <= 0){
					this.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
					$('#edvlunitarioedicao').focus();
					return;
				}
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
				if (this.videstoqueedicao === null){
					this.$toastr.w('Estoque deve ser informado!', 'Atenção!');
					$('#cbestoqueedicao').focus();
					return;
				}

				if (parseInt(this.vdescacresedicao) === 0){
					let fatd = 0;
					if (parseInt(this.vtipodescacresedicao) === 0){
						fatd = this.vvalordescacresedicao;
					}else{
						fatd = parseFloat(this.vvalordescacresedicao) / (parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao)) * 100;
					}

					if (parseInt(this.vtipodescacresedicao) === 0){
						if (parseFloat(this.vldescpromocionalitemedicao) > 0){
							if (parseFloat(this.fatd) > parseFloat(this.vldescpromocionalitemedicao)){
								this.$toastr.i('Desconto promocional maior que o permitido para o item!', 'Informação!');
								$('#edfatordesconto').focus();
								return;
							}	
						}else{
							if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
								this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
								$('#edvaldescacresedicao').focus();					
								return;
							}

							let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

							if (parseFloat(fatd) > parseFloat(descto_comparar)){
								this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
								$('#cbtipodesctotal').focus();					
								return;
							}							
						}
					}else{
						if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
							this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
							$('#edvaldescacresedicao').focus();					
							return;
						}

						let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

						if (parseFloat(fatd) > parseFloat(descto_comparar)){
							this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
							$('#cbtipodesctotal').focus();					
							return;
						}	
					}				
				}
				$('#btnsalvaritem').prop('disabled', true);

				if (parseInt(this.vopitem) === 1){
					if (util.findValInArray(this.lstitens, 'idproduto', this.vidprodutoedicao)){
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'O ítem já está incluso no pedido. Deseja continuar e adicioná-lo novamente?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: false,
                            escapeKey: 'nao',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                sim: {
                                    text: '<u>S</u>im',
                                    keys: ['s', 'S'],
                                    btnClass: 'btn-blue',
                                    action: function () {
										$('.btn-blue').prop('disabled', true);
										vself.vitem++;
										let itemtmp = {
											idproduto		: vself.vidprodutoedicao,
											descproduto		: vself.vdescricaoprodutoedicao,
											coddig			: vself.vcoddigedicao,
											item			: vself.vitem,
											qtditem			: parseFloat(vself.vqtditemedicao),
											unditem			: vself.vundprodutoedicao,
											vlunitario		: parseFloat(vself.vvlunitarioedicao),
											descacres		: vself.vdescacresedicao,
											tipodescacres	: vself.vtipodescacresedicao,
											valordescacres	: parseFloat(vself.vvalordescacresedicao),
											manipulaval		: vself.vmanipulavaledicao,
											vltotal			: parseFloat(vself.vvltotaledicao),
											vltotalimposto  : parseFloat(vself.vvltotalimpostoitemedicao),
											idestoque		: vself.videstoqueedicao,
											descestoque		: $('#cbestoqueedicao').select2('data')[0]['text'],
											infadprod		: vself.vinfadprod,
											qtdentregar		: parseFloat(vself.vqtditemedicao),
											idtecnicosolicita   : vself.vidtecnicosolicitaedicao === null ? 0 : vself.vidtecnicosolicitaedicao,
											nometecnicosolicita : vself.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']
										};
										//vself.vtotalimpostos 	  = parseFloat(vself.vtotalimpostos) + parseFloat(vself.vvltotalimpostoitemedicao);
										vself.vtotalprodutos 	  = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vvltotaledicao);

										vself.lstitens.push(itemtmp);

										vself.vtotalgeral	= parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos);

										vself.mtdlimparedicaoitem();
										$('#edidprodutoedicao').focus();
										setTimeout(() => {
											$('#btnsalvaritem').prop('disabled', false);
										}, 500);
                                    },
                                },
                                nao: {
                                    text: '<u>N</u>ão',
                                    keys: ['n', 'N'],
                                    action: function () {
										$('#edqtditemedicao').focus();
										setTimeout(() => {
											$('#btnsalvaritem').prop('disabled', false);
										}, 500);										
										return;
                                    }
                                }
                            }
                        });						
					}else{					
						vself.vitem++;
						let itemtmp = {
							idproduto		: vself.vidprodutoedicao,
							descproduto		: vself.vdescricaoprodutoedicao,
							coddig			: vself.vcoddigedicao,
							item			: vself.vitem,
							qtditem			: parseFloat(vself.vqtditemedicao),
							unditem			: vself.vundprodutoedicao,
							vlunitario		: parseFloat(vself.vvlunitarioedicao),
							descacres		: vself.vdescacresedicao,
							tipodescacres	: vself.vtipodescacresedicao,
							valordescacres	: parseFloat(vself.vvalordescacresedicao),
							manipulaval		: vself.vmanipulavaledicao,
							vltotal			: parseFloat(vself.vvltotaledicao),
							vltotalimposto  : parseFloat(vself.vvltotalimpostoitemedicao),
							idestoque		: vself.videstoqueedicao,
							descestoque		: $('#cbestoqueedicao').select2('data')[0]['text'],
							infadprod		: vself.vinfadprod,
							qtdentregar		: parseFloat(vself.vqtditemedicao),
							idtecnicosolicita   : vself.vidtecnicosolicitaedicao === null ? 0 : vself.vidtecnicosolicitaedicao,
							nometecnicosolicita : vself.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']							
						};
						//vself.vtotalimpostos = parseFloat(vself.vtotalimpostos) + parseFloat(vself.vvltotalimpostoitemedicao);
						vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vvltotaledicao);

						vself.lstitens.push(itemtmp);
						vself.vtotalgeral	= parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos);
						vself.mtdlimparedicaoitem();
						$('#edidprodutoedicao').focus();
						setTimeout(() => {
							$('#btnsalvaritem').prop('disabled', false);
						}, 500);												
					}	
				}else{
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(this.vvltotal_old_edicao);
					//this.vtotalimpostos = parseFloat(this.vtotalimpostos) - parseFloat(this.vtotalimpostos_old_edicao);
					
					let indiceitem 						= util.getArrayIndexForKey(this.lstitens, 'item', this.vitemalteracao)
					let lsttmp 							= this.lstitens;
					this.lstitens						= [];

					lsttmp[indiceitem].descproduto		= this.vdescricaoprodutoedicao;
					lsttmp[indiceitem].qtditem			= parseFloat(this.vqtditemedicao);
					lsttmp[indiceitem].unditem			= this.vundprodutoedicao;
					lsttmp[indiceitem].vlunitario		= parseFloat(this.vvlunitarioedicao);
					lsttmp[indiceitem].descacres		= this.vdescacresedicao;
					lsttmp[indiceitem].tipodescacres	= this.vtipodescacresedicao;
					lsttmp[indiceitem].valordescacres	= parseFloat(this.vvalordescacresedicao);
					lsttmp[indiceitem].manipulaval		= this.vmanipulavaledicao;
					lsttmp[indiceitem].vltotal			= parseFloat(this.vvltotaledicao);
					lsttmp[indiceitem].vltotalimposto	= parseFloat(this.vvltotalimpostoitemedicao);	
					lsttmp[indiceitem].idestoque		= this.videstoqueedicao;
					lsttmp[indiceitem].descestoque		= $('#cbestoqueedicao').select2('data')[0]['text'];					
					lsttmp[indiceitem].infadprod		= this.vinfadprod;
					lsttmp[indiceitem].qtdentregar		= parseFloat(this.vqtditemedicao);
					lsttmp[indiceitem].idtecnicosolicita   = this.vidtecnicosolicitaedicao === null ? 0 : this.vidtecnicosolicitaedicao,
					lsttmp[indiceitem].nometecnicosolicita = this.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']												

					//this.vtotalimpostos  = parseFloat(this.vtotalimpostos) + parseFloat(this.vvltotalimpostoitemedicao);
					this.vtotalprodutos  = parseFloat(this.vtotalprodutos) + parseFloat(this.vvltotaledicao);					

					this.lstitens 						= lsttmp;
					this.vtotalgeral					=  parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);
					$('#mdedicaoitem').modal('hide');
					setTimeout(() => {
						$('#btnsalvaritem').prop('disabled', false);
					}, 500);					
				}				
			},
			mtdexcluiritem(item){
				if (!util.opcaousuario('020Z.010Z.130Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}				
				let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item);

				//this.vtotalimpostos = parseFloat(this.vtotalimpostos) - parseFloat(this.lstitens[indiceitem].vltotalimposto);

				this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(this.lstitens[indiceitem].vltotal);

				this.vtotalgeral	=  parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);

				this.lstitens.splice(indiceitem, 1);
			},
			mtdtpdescacres(val){				
				// if (parseInt(val) === 0){
				// 	if (parseInt(this.vdescacresedicao) === 0){
				// 		this.vtitdesc = 'Descto.(%):';
				// 	}else{
				// 		this.vtitdesc = 'Acresc.(%):';
				// 	}
				// }else{
				// 	if (parseInt(this.vdescacresedicao) === 0){
				// 		this.vtitdesc = 'Descto.(R$):';
				// 	}else{
				// 		this.vtitdesc = 'Acresc.(R$):';
				// 	}
				// }
				
				if (parseInt(val) === 0){
					if (parseInt(this.vdescacresedicao) === 0){
						this.vtitdesc = 'Descto.: R$ '+this.mtdformatavalordecimal(parseFloat(this.vldescmostrar), 2);
					}else{
						this.vtitdesc = 'Acresc.(%):';
					}
				}else{
					if (parseInt(this.vdescacresedicao) === 0){
						this.vtitdesc = 'Descto.: '+this.mtdformatavalordecimal(parseFloat(this.vldescmostrar), 2)+'%';
					}else{
						this.vtitdesc = 'Acresc.(R$):';
					}
				}					
			},
			mtdadicionarservico(){
				if (this.vidservicoedicao === null){
					this.$toastr.w('Serviço deve ser informado!', 'Atenção!');
					$('#cbservico').focus();
					return;
				}
				if (this.vidtecnicoedicao === null){
					this.$toastr.w('Técnico deve ser informado!', 'Atenção!');
					$('#cbtecnico').focus();
					return;
				}
				if (!Number.isInteger(parseFloat(this.vqtdservicoedicao))){
					this.$toastr.w('Quantidade não permitida!', 'Atenção!');
					$('#edqtdservedicao').focus();
					return;
				}else{
					if (this.vqtdservicoedicao == 0){
						this.$toastr.w('Informe uma quantidade válida!', 'Atenção!');
						$('#edqtdservedicao').focus();
						return;
					}
				}
				if (this.vvlservicoedicao <= 0){
					this.$toastr.w('Informe o valor unitário do serviço!!', 'Atenção!');
					$('#edvlservicoedicao').focus();
					return false;
				}


				let fatd = 0;
				if (parseInt(this.vtipodescontoservicoedicao) === 0){
					fatd = this.vvalordescontoservicoedicao;
				}else{
					fatd = parseFloat(this.vvalordescontoservicoedicao) / (parseFloat(this.vqtdservicoedicao) * parseFloat(this.vvlservicoedicao)) * 100;
				}
				if (parseFloat(fatd) > parseFloat(this.$store.state.usuario.descontoservicos)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoservicos+'%!', 'Informação!');
					$('#edvalordescontoservicoedicao').focus();					
					return;
				}	

				if (util.findValInArray(this.lstservicos, 'idservico', this.vidservicoedicao)){	
					this.$toastr.w('Serviço já lançado na venda!', 'Atenção!');
					$('#cbservico').focus();
					return;					
				}
				let servico = {
					idservico		: this.vidservicoedicao,
					descservico		: $('#cbservico').select2('data')[0]['text'],
					qtdservico		: this.vqtdservicoedicao,
					vlservico		: parseFloat(this.vvlservicoedicao),
					tipodesconto	: this.vtipodescontoservicoedicao,
					valordesconto	: parseFloat(this.vvalordescontoservicoedicao),
					vltotal			: parseFloat(this.vvltotalservicoedicao),
					idtecnico		: this.vidtecnicoedicao,
					nometecnico		: $('#cbtecnico').select2('data')[0]['text']
				};
				this.lstservicos.push(servico);

				this.vtotalservicos = parseFloat(this.vtotalservicos) + parseFloat(this.vvltotalservicoedicao);//total dos serviços

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);

				this.vidservicoedicao				= null;
				this.vqtdservicoedicao				= 1;
				this.vvlservicoedicao				= 0;
				this.vtipodescontoservicoedicao		= 0;
				this.vvalordescontoservicoedicao	= 0;
				this.vvltotalservicoedicao			= 0;
				this.vidtecnicoedicao				= null;

				$("#cbservico").val('').trigger('change');
				$("#cbtecnico").val('').trigger('change');				

				$('#cbservico').focus();

			},
			mtdexcluirservico(servico){
				if (!util.opcaousuario('020Z.010Z.140Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}								
				let indiceservico 	= util.getArrayIndexForKey(this.lstservicos, 'idservico', servico.idservico);

				this.vtotalservicos = parseFloat(this.vtotalservicos) - parseFloat(this.lstservicos[indiceservico].vltotal);//total dos serviços

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);

				this.lstservicos.splice(indiceservico, 1);
			},
				mtdselecionarplano(){
					let vself = this;
					if (this.vidfilial === null){
					vself.$toastr.w('Filial deve ser informada!', 'Informação!');
					$('#cbfilial').focus();
					return;
				}				
				if (this.vidcliente === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Informação!');
					$('#edcliente').focus();
					return;
					}
					$('#mdselecionarplano').modal('show');
				},
				mtdalteraplano(idplano){
					if (idplano === null || idplano === ''){
						this.vidplano 			= null;
						this.vtipoplano 		= 0;
						this.vdescplano 		= '';
						this.vidtabela 			= null;
						this.vpercentrada 		= 0;
						this.vpermitedesconto 	= 0;
						return;
					}
					let indice = util.getArrayIndexForKey(this.lstplanos, 'id', parseInt(idplano));
					if (indice > -1){
						this.mtddefineplano(this.lstplanos[indice]);
					}
				},
				mtddefineplano(plano){
					this.vidplano 	= plano.id;
					this.vtipoplano = plano.tipo;
				this.vdescplano	= plano.descricao;
				this.vidtabela	= plano.idtabela;
				this.vpercentrada = parseFloat(plano.percentrada);
				this.vpermitedesconto = plano.permitedesconto;
				if (this.lstitens.length > 0){
					this.mtdrecalcularprecos();				
				}else{
					$('#mdselecionarplano').modal('hide');
				}
			},
			mtdgerartitulos(lstbase, valor){
				this.lsttitulosfaturar = [];

				let vlparcela = valor / lstbase.length;

				for (var i = 0; i < lstbase.length; i++) {
					let titulo = {
						codtit 				: this.pedidofaturar.id + '/' + this.mtdformatarzeros(i + 1, 2) + '-'+lstbase.length,
						dtventit			: util.somaDias(this.mtdformatadatagravar(this.vdtfatura), parseInt(lstbase[i]['prazo'])),
						vltit				: vlparcela,
						idtipocobranca		: lstbase[i]['idtipocob'],
						tipocobranca		: lstbase[i]['tipocobranca'],// 0 - Normal 1 - Cheque
						descricaocob		: lstbase[i]['descricaocob'],
						numerocheque		: '',
						idbanco				: null,
						descbanco			: '',
						agencia				: '',
						conta				: '',
						praca				: '',
						emitente			: '',
						cnpjcpf				: '',						
						idsituacaocheque	: null,
						descsituacaocheque	: ''
					}
					this.lsttitulosfaturar.push(titulo);
				}
				this.vtotaltitulos = valor;
			},
			mtdfaturarpedido(idpedido){
				$('#mdmenupedido').modal('hide');
				if (!util.opcaousuario('020Z.010Z.050Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{				
					var vself       = this;
					let loader      = this.$loading.show();
					let parametros  = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'infcredito',   valor : '1'},
						{parametro: 'filtro',       valor : ' and p.id='+idpedido},
						{parametro: 'detplano',     valor : 1},					
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						vself.pedidofaturar 	= response.data.pedidos[0];

						if (util.opcaousuario('020Z.010Z.036Z', vself.$store.state.perfilusuario)){
							if (parseInt(response.data.pedidos[0].conferido) === 0){
								vself.$toastr.i('Seu perfil só permite FATURAR o pedido, se o mesmo estiver com a conferência finalizada!', 'Atenção!');
								vself.mtdcancelaredicao();
								return;
							}								
						}
						if (parseInt(response.data.pedidos[0].liberarpdv) === 1){
							vself.$toastr.i('Para FATURAR o pedido, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}	

						$("#cbformapagamento").val(null).trigger('change');
						vself.vdtfatura			= util.DataAtual();					

						vself.vvlforma			= 0;
						vself.lstformasfaturar 	= [];
						vself.lsttitulosfaturar = [];
						if (parseInt(vself.pedidofaturar.stpedido) !== 0){
							vself.$toastr.i('Para faturar o pedido, a situação do mesmo deve estar em aberto!', 'Informação!');
							vself.pedidofaturar = [];
							return;
						}
						//inclui a forma de pagamento cadastrada no plano
						let forma = {
							idforma 		: vself.pedidofaturar.idforma,
							descforma		: vself.pedidofaturar.descforma,
							vlforma			: vself.pedidofaturar.totalgeral,
							tipo			: vself.pedidofaturar.tipoforma,
							idperfilfluxo   : 0,
							descperfilfluxo : ''
						};
						vself.lstformasfaturar.push(forma);
						/////////////////////////////////////////////////

						//se o plano for a prazo, gera as parcelas
						if (parseInt(vself.pedidofaturar.detplano.tipo) === 1){
							vself.mtdgerartitulos(vself.pedidofaturar.detplano.parcelas, vself.pedidofaturar.totalgeral);				
						}
						
						vself.mtdvisualizarcashback();

						vself.mtdsomarformas();
						$('#mdfaturarpedido').modal('show');										
					}).catch(function (response) {
						loader.hide();
					});
				}		
			},
			mtdvisualizarcashback(){
				let vself = this;
				vself.vltotalcashback 			= 0;
				vself.vlcashbackdisponivelvenda = 0;				
				let loader      = vself.$loading.show();
				let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.pedidofaturar.idcliente;
				let parametros  = [
					{parametro: 'op',           	valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',       	valor : filtro},
					{parametro: 'limit',        	valor : 1},
					{parametro: 'offset',       	valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if (response.data.pedidos.length > 0){
						vself.vltotalcashback 			= parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado)
						vself.vlcashbackdisponivelvenda = util.arredondaValores( parseFloat(vself.pedidofaturar.fatorcreditoutilizar) * parseFloat(vself.pedidofaturar.totalgeral) / 100, 2, 'round');
						if (vself.vlcashbackdisponivelvenda > vself.vltotalcashback){
							vself.vlcashbackdisponivelvenda = vself.vltotalcashback;
						}
					}
				}).catch(function (response) {
					console.log(response);
					vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
					$('#cbformapagamento').focus();
					loader.hide();
				});	
			},
			mtdsomarformas(){
				let sf = 0;
				for (let forma of this.lstformasfaturar) {
					sf = sf + forma.vlforma;
				}
				this.vtotalformas = sf;
				if (this.vtotalformas < this.pedidofaturar.totalgeral){
					this.vvlforma 	= this.pedidofaturar.totalgeral - this.vtotalformas;
					this.vdiferenca = 0;
				}else{
					this.vdiferenca = this.vtotalformas - this.pedidofaturar.totalgeral;
				}
			},
			mtdtemespecie(){
				let existe = false;
				for (let forma of this.lstformasfaturar) {
					if (parseInt(forma.especie) === 1) {
						existe = true;
						break;
					}
				}
				return existe;
			},			
			mtdincluirforma(){
				let vself = this;
				if (this.vidformapagamento === null){
					this.$toastr.w('Forma de pagamento deve ser informada!', 'Informação!');
					$('#cbformapagamento').focus();
					return;					
				}
				if (parseFloat(this.vvlforma) <= 0){
					this.$toastr.w('Valor da forma de pagamento inválido!', 'Informação!');
					$('#edvlforma').focus();
					return;					
				}
				if (parseInt(this.pedidofaturar.tipoplano) === 0 && parseInt(this.vtipoforma) === 1){
					this.$toastr.w('Forma de pagamento A PRAZO não é permitida para um plano de pagamento A VISTA!', 'Informação!');
					$('#cbformapagamento').focus();
					return;					
				}	

				if (parseInt(this.vabatecredito) === 1 && this.vnrvendaforma === ''){
					vself.$toastr.w('Informe o número da venda para o resgate!', 'Informação!');
					$('#ednrvendaforma').focus();
					return;					
				}

				if (parseInt(this.vabatecredito) === 1){
					let vllimitecreditoabater = util.arredondaValores( parseFloat(this.pedidofaturar.fatorcreditoutilizar) * parseFloat(this.pedidofaturar.totalgeral) / 100, 2, 'round');				
					if (parseInt(parseFloat(this.vvlforma) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
						vself.$toastr.w('O valor permitido para uso do crédito/cashback não pode ultrapassar '+util.formatavalordecimais(vllimitecreditoabater, 2)+' ('+this.pedidofaturar.fatorcreditoutilizar+'%). Verifique e tente novamente!', 'Informação!');
						return;						
					}
				}

				if (vself.mtdtemespecie() && parseInt(vself.vespecieforma) === 1){
					vself.$toastr.w('Já existe uma forma em espécie lançada na venda!', 'Informação!');
					return;
				}				
				if (vself.vnrvendaforma === ''){//caso não seja resgate			
					let forma = {
						idforma 	: this.vidformapagamento,
						descforma	: $('#cbformapagamento').select2('data')[0]['text'],
						vlforma		: this.vvlforma,
						tipo		: this.vtipoforma,
						especie		: vself.vespecieforma,
						nrvenda		: vself.vnrvendaforma,						
						idperfilfluxo    : this.vidperfilfluxoforma,
						descperfilfluxo  : this.vdescperfilfluxoforma											
					};
					if (!util.findValInArray(this.lstformasfaturar, 'idforma', this.vidformapagamento)){
						this.lstformasfaturar.push(forma);
						
						if (parseInt(forma.tipo) === 1 && this.pedidofaturar.detplano.parcelas.length > 0){
							this.lsttitulosfaturar = [];
							this.mtdgerartitulos(this.pedidofaturar.detplano.parcelas, forma.vlforma);
						}

						$("#cbformapagamento").val(null).trigger('change');
						this.vvlforma			= 0;
					}else{
						this.$toastr.w('Forma de pagamento já lançada!', 'Informação!');
					}
					this.mtdsomarformas();
					$('#cbformapagamento').focus();
				}else{//resgate
					let loader      = vself.$loading.show();
					let filtro      = ' and p.stpedido=1 and p.id='+vself.vnrvendaforma;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if (response.data.pedidos.length > 0){
							if (parseInt(response.data.pedidos[0].creditoindividual) === 1){//caso o crédito for individual
								if (parseInt(response.data.pedidos[0].idcliente) !== parseInt(vself.pedidofaturar.idcliente)){//verifica se o cliente é o titular do crédito. caso não for não libera
									vself.$toastr.i('O crédito em questão só pode ser utilizado pelo cliente titular!', 'Informação!');
									return;
								}
							}

							let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
							if (vself.vvlforma > vlcreditodisp){
								vself.$toastr.i('Valor do crédito desta venda não é suficiente ou não está disponível para resgate!', 'Informação!');
								$('#cbformapagamento').select2('open');
								return;
							}else{
								let forma = {
									idforma 	: vself.vidformapagamento,
									descforma	: $('#cbformapagamento').select2('data')[0]['text'],
									vlforma		: vself.vvlforma,
									tipo		: vself.vtipoforma,
									especie		: vself.vespecieforma,
									nrvenda		: vself.vnrvendaforma,
									idperfilfluxo    : vself.vidperfilfluxoforma,
									descperfilfluxo  : vself.vdescperfilfluxoforma															
								};				
								if (!util.findValInArray(vself.lstformasfaturar, 'idforma', vself.vidformapagamento)){
									vself.lstformasfaturar.push(forma);
									
									if (parseInt(forma.tipo) === 1 && vself.lancamentousu.plano.prazosplanos.length > 0){
										vself.lsttitulosfaturar = [];
										vself.mtdgerartitulos(vself.lancamentousu.plano.prazosplanos, forma.vlforma);
									}

									$("#cbformapagamento").val(null).trigger('change');
									vself.vvlforma			= 0;
								}else{
									vself.$toastr.w('Forma de pagamento já lançada!', 'Informação!');
								}
								vself.mtdsomarformas();
								$('#cbformapagamento').focus();
							}
						}else{
							vself.$toastr.w('Venda não encontrada/cancelada no sistema. Verifique corretamente se a venda permite que o crédito seja resgatado e tente novamente!', 'Informação!');
							$('#ednrvendaforma').focus();
						}
					}).catch(function (response) {
						console.log(response);
						vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
						$('#cbformapagamento').focus();
						loader.hide();
					});					
				}
			},	
			mtddeletarforma(index){
				if (parseInt(this.lstformasfaturar[index].tipo) === 1){
					this.lsttitulosfaturar = [];
				}
				this.lstformasfaturar.splice(index, 1); 
				this.mtdsomarformas();
			},
			mtdalterartitulo(titulo){
				if (!util.opcaousuario('020Z.010Z.110Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}

				this.tacodtit 				= titulo.codtit;
				this.tadtventit				= titulo.dtventit;
				this.tavltit				= titulo.vltit;
				this.taidtipocobranca		= titulo.idtipocobranca;
				this.tatipocobranca			= titulo.tipocobranca;
				this.tadescricaocob			= titulo.descricaocob;
				this.tanumerocheque			= titulo.numerocheque;
				this.taidbanco				= titulo.idbanco;
				this.tadescbanco			= titulo.descbanco;
				this.taagencia				= titulo.agencia;
				this.taconta				= titulo.conta;
				this.tapraca				= titulo.praca;
				this.taemitente				= titulo.emitente;
				this.tacnpjcpf				= titulo.cnpjcpf;						
				this.taidsituacaocheque		= titulo.idsituacaocheque;
				this.tadescsituacaocheque	= titulo.descsituacaocheque;				


				var deftipocobranca  = new Option(this.tadescricaocob, this.taidtipocobranca, true, true);
				$('#cbtipocobranca').append(deftipocobranca).trigger('change');

				if (this.taidbanco !== null){
					var defbanco  = new Option(this.tadescbanco, this.taidbanco, true, true);
					$('#cbbanco').append(defbanco).trigger('change');
				}else{
					$("#cbbanco").val(null).trigger('change');
				}
				
				if (this.taidsituacaocheque !== null){
					var defsituacaoch  = new Option(this.tadescsituacaocheque, this.taidsituacaocheque, true, true);
					$('#cbsituacaocheque').append(defsituacaoch).trigger('change');
				}else{
					$("#cbsituacaocheque").val(null).trigger('change');
				}

				$('#mdalterartitulo').modal('show');
			},
			mtconfirmaralteracaotitulo(){
				if (this.tadtventit === ''){
					this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
					$('#eddtventit').focus();
					return;
				}
				if (parseFloat(this.tavltit) <= 0){
					this.$toastr.w('Valor do título inválido!', 'Atenção!');
					$('#edvltit').focus();
					return;
				}
				if (this.taidtipocobranca === null){
					this.$toastr.w('Tipo de cobrança deve ser informada!', 'Atenção!');
					$('#cbtipocobranca').focus();
					return;
				}				
				if (parseInt(this.tatipocobranca) === 1){
					if (this.tanumerocheque === ''){
						this.$toastr.w('Número do cheque deve ser informado!', 'Atenção!');
						$('#ednumerocheque').focus();
						return;
					}
					if (this.taidbanco === null){
						this.$toastr.w('Banco deve ser informado!', 'Atenção!');
						$('#cbbanco').focus();
						return;
					}
					if (this.taagencia === ''){
						this.$toastr.w('Agência deve ser informada!', 'Atenção!');
						$('#edagencia').focus();
						return;
					}
					if (this.taconta === ''){
						this.$toastr.w('Conta deve ser informada!', 'Atenção!');
						$('#edconta').focus();
						return;
					}
					if (this.tapraca === ''){
						this.$toastr.w('Praça deve ser informada!', 'Atenção!');
						$('#edpraca').focus();
						return;
					}
					if (this.taemitente === ''){
						this.$toastr.w('Emitente deve ser informado!', 'Atenção!');
						$('#edemitente').focus();
						return;
					}
					if (this.tacnpjcpf === ''){
						this.$toastr.w('CNPJ/CPF deve ser informado!', 'Atenção!');
						$('#edcnpjcpf').focus();
						return;
					}
					if (this.taidsituacaocheque === null){
						this.$toastr.w('Situação do cheque deve ser informada!', 'Atenção!');
						$('#cbsituacaocheque').focus();
						return;
					}					
				}
				let indice = util.getArrayIndexForKey(this.lsttitulosfaturar, 'codtit', this.tacodtit);
				this.vtotaltitulos = this.vtotaltitulos - this.lsttitulosfaturar[indice].vltit;


				this.lsttitulosfaturar[indice].dtventit 			= this.tadtventit;
				this.lsttitulosfaturar[indice].dtventit				= this.tadtventit;
				this.lsttitulosfaturar[indice].vltit				= this.tavltit;
				this.lsttitulosfaturar[indice].idtipocobranca		= this.taidtipocobranca;
				this.lsttitulosfaturar[indice].tipocobranca			= this.tatipocobranca;
				this.lsttitulosfaturar[indice].descricaocob			= $('#cbtipocobranca').select2('data')[0]['text'];

				this.lsttitulosfaturar[indice].numerocheque			= parseInt(this.tatipocobranca) === 1 ? this.tanumerocheque 	: '';
				this.lsttitulosfaturar[indice].idbanco				= parseInt(this.tatipocobranca) === 1 ? this.taidbanco 			: null;
				this.lsttitulosfaturar[indice].descbanco			= parseInt(this.tatipocobranca) === 1 ? $('#cbbanco').select2('data')[0]['text'] : '';
				this.lsttitulosfaturar[indice].agencia				= parseInt(this.tatipocobranca) === 1 ? this.taagencia 			: '';
				this.lsttitulosfaturar[indice].conta				= parseInt(this.tatipocobranca) === 1 ? this.taconta 			: '';
				this.lsttitulosfaturar[indice].praca				= parseInt(this.tatipocobranca) === 1 ? this.tapraca 			: '';
				this.lsttitulosfaturar[indice].emitente				= parseInt(this.tatipocobranca) === 1 ? this.taemitente 		: '';
				this.lsttitulosfaturar[indice].cnpjcpf				= parseInt(this.tatipocobranca) === 1 ? this.tacnpjcpf 			: '';						
				this.lsttitulosfaturar[indice].idsituacaocheque		= parseInt(this.tatipocobranca) === 1 ? this.taidsituacaocheque : null;
				this.lsttitulosfaturar[indice].descsituacaocheque	= parseInt(this.tatipocobranca) === 1 ? $('#cbsituacaocheque').select2('data')[0]['text'] : '';				


				this.vtotaltitulos = this.vtotaltitulos + this.tavltit;

				$('#mdalterartitulo').modal('hide');
			},
			mtdpendenciasparcela(){
				let ret = false;
				for (let titulo of this.lsttitulosfaturar) {
					if (parseInt(titulo.tipocobranca) === 1){
						if (titulo.numerocheque === ''){
							ret = true;
							break;
						}
						if (titulo.idbanco === null){
							ret = true;
							break;
						}
						if (titulo.agencia === ''){
							ret = true;
							break;
						}
						if (titulo.conta === ''){
							ret = true;
							break;
						}
						if (titulo.praca === ''){
							ret = true;
							break;
						}
						if (titulo.emitente === ''){
							ret = true;
							break;
						}
						if (titulo.cnpjcpf === ''){
							ret = true;
							break;
						}
						if (titulo.idsituacaocheque === null){
							ret = true;
							break;
						}																		
					}
				}
				return ret;
			},
			mtdverificasomaparcelas(){
				let vlaprazo = 0;
				for (let forma of this.lstformasfaturar) {
					if (parseInt(forma.tipo) === 1){
						vlaprazo = forma.vlforma;
						break;
					}
				}
				if (parseFloat(this.vtotaltitulos.toFixed(2)) !== parseFloat(vlaprazo.toFixed(2))){
					return false;
				}else{
					return true;
				}
			},
			mtdconfirmarfatura(){
				let vself = this;
				if (this.lstformasfaturar.length === 0){
					this.$toastr.w('Informe as formas de pagamento!', 'Atenção!');
					return;
				}				
				if (parseFloat(this.vtotalformas) !== parseFloat(this.pedidofaturar.totalgeral)){
					this.$toastr.w('A soma das formas de pagamento não confere com o valor à ser faturado. Verifique e tente novamente!', 'Atenção!');
					return;
				}				
				if (parseInt(this.pedidofaturar.detplano.tipo) === 1){
					let vlaprazo  = 0;
					let vlentrada = 0;
					for (let forma of this.lstformasfaturar) {
						if (parseInt(forma.tipo) === 1){
							vlaprazo  = vlaprazo + parseFloat(forma.vlforma);
						}else{
							vlentrada = vlentrada + parseFloat(forma.vlforma);
						}
					}

					if (parseFloat(this.pedidofaturar.percentrada) > 0){
						let vlentradaplano = parseFloat(this.pedidofaturar.totalgeral) * parseFloat(this.pedidofaturar.percentrada) / 100;
						if (parseFloat(vlentrada).toFixed(2) < parseFloat(vlentradaplano).toFixed(2)){	
							this.$toastr.w('Valor da entrada é inferior ao permitdo pelo plano! Valor mínimo deve ser: R$ '+this.mtdformatavalordecimal(vlentradaplano, 2)+'.', 'Atenção!');
							return;
						}
					}

					if (parseInt(this.pedidofaturar.liberarfat) === 0){
						if (parseFloat(vlaprazo.toFixed(2)) > parseFloat(this.pedidofaturar.vlcreditodisponivel.toFixed(2))){	
							this.$toastr.w('Limite de crédito disponível está inferior ao valor da venda a prazo. Favor Entrar em contato com o setor financeiro!', 'Atenção!');
							return;
						}
					}

					if (this.lsttitulosfaturar.length === 0){
						this.$toastr.w('Para um plano à prazo, as parcelas devem ser informadas!', 'Atenção!');
						return;
					}					
					if (this.mtdpendenciasparcela()){//se estiver faltando algum campo do cheque ser preenchido
						this.$toastr.w('Algum(ns) título(s) definido(s) como cheque não apresenta(m) todas as informações preenchidas. Verifique e tente novamente!', 'Atenção!');
						return;					
					}
					if (!this.mtdverificasomaparcelas()){//verifica se a soma dos títulos é diferente da forma a prazo
						this.$toastr.w('A soma dos títulos não confere com o valor da forma à prazo. Verifique os valores das parcelas!', 'Atenção!');
						return;					
					}				
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma FATURAMENTO do pedido?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								setTimeout(function(){
									vself.mtdefetivafaturamento();
								}, 300); 								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});					
			},
			mtdefetivafaturamento(){
				let vself  	= this;
				let loader 	= vself.$loading.show();
				let hora   	= util.DataAtual(true, true);
				hora 		= hora.substring(11, 19);
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           		valor : 'faturamento'},
					{parametro: 'idpedido',     		valor : vself.pedidofaturar.id},
					{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
					{parametro: 'dtfatura',     		valor : vself.mtdformatadatagravar(vself.vdtfatura)+' '+hora},
					{parametro: 'formas',     			valor : JSON.stringify(vself.lstformasfaturar)},
					{parametro: 'titulos',     			valor : JSON.stringify(vself.lsttitulosfaturar)},
					{parametro: 'codop',        		valor : '020Z.010Z.050Z'},
					{parametro: 'faturarsemsaldo',      valor : util.opcaousuario('020Z.010Z.090Z', this.$store.state.perfilusuario) === false ? 0 : 1}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						$('#mdfaturarpedido').modal('hide');
						vself.$toastr.s('Faturamento realizado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
						vself.pidpedido     	= vself.pedidofaturar.id;
						vself.pqtd_paginas  	= 1;
						vself.mtdcancelaredicao();
						vself.mtdcarregapedidos(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},			
			mtdrotinapdv(idpedido){
				$('#mdmenupedido').modal('hide');
				if (parseFloat(this.pedidomenu.totalgeral) <= 0){
					this.$toastr.w('Opção indisponível para um pedido de crédito!', 'Atenção!');
					return;
				}				
				if (!util.opcaousuario('020Z.010Z.040Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					let vself  = this;
					let loader = vself.$loading.show();
					let parametros      = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'rotinapdv'},
						{parametro: 'idpedido',     valor : idpedido},
						{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        valor : '020Z.010Z.040Z'},
						{parametro: 'opconf',       valor : util.opcaousuario('020Z.010Z.036Z', this.$store.state.perfilusuario) ? 1 : 0},

					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if ($.isNumeric(response.data)){
							vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
							vself.pfiltropor		= 0;
							vself.psituacao     	= 3;
							vself.pentregaexterna 	= 2;
							vself.pidpedido     	= idpedido;
							vself.pqtd_paginas  	= 1;
							vself.mtdcancelaredicao();
							vself.mtdcarregapedidos(1);
						}else{
							let tpret = response.data.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.substring(4), 'Atenção!');
									break;
								case 'E': default:
									vself.$toastr.e(response.data.substring(4), 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						loader.hide();
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});
				}				
			},
			mtdcancelarpedido(idpedido){
				$('#mdmenupedido').modal('hide');				
				if (!util.opcaousuario('020Z.010Z.060Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{				
					var vself       = this;
					let loader      = this.$loading.show();
					let parametros  = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'filtro',       valor : ' and p.id='+idpedido},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						vself.pedidocancelar 	  = response.data.pedidos[0];

						if (parseInt(vself.pedidocancelar.stpedido) !== 1){
							vself.$toastr.i('Para FECHAR o pedido, a situação do mesmo deve estar como FATURADO!', 'Informação!');
							vself.pedidocancelar  = [];
							return;
						}

						if (parseInt(vself.pedidocancelar.idpedidooff) > 0){
							$.confirm({
								title: 'Confirmação!',
								content: 'Este pedido é de origem de um PDV Offline. '+
											'O cancelamento deve ser feito no PDV que originou a venda. '+
											'Caso contrário podem acontecer diferenças no caixa. Deseja mesmo continuar?',
								icon: 'fa fa-question-circle',
								escapeKey: true,
								backgroundDismiss: false,
								escapeKey: 'nao',
								type: 'dark',
								typeAnimated: true,
								buttons: {
									sim: {
										text: '<u>S</u>im',
										keys: ['s', 'S'],
										btnClass: 'btn-blue',
										action: function () {							
											vself.cmotivocancelamento = '';
											vself.cdtcancelamento	  = util.DataAtual();
											$('#mdcancelarpedido').modal('show');												
										},
									},
									nao: {
										text: '<u>N</u>ão',
										keys: ['n', 'N'],
										action: function () {
										}
									}
								}
							});			
						}else{
							vself.cmotivocancelamento = '';
							vself.cdtcancelamento	  = util.DataAtual();
							$('#mdcancelarpedido').modal('show');																				
						}										
					}).catch(function (response) {
						loader.hide();
					});
				}				
			},
			mtdconfirmarcancelamento(){
				let vself = this;
				if (this.cmotivocancelamento === ''){
					this.$toastr.w('Informe o motivo do cancelamento!', 'Atenção!');
					$('#txtmotivocancelamento').focus();
					return;
				}				
				if (this.cdtcancelamento === ''){
					this.$toastr.w('Informe a data do cancelamento!', 'Atenção!');
					$('#eddtcancelamento').focus();
					return;
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma CANCELAMENTO?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								setTimeout(function(){
									vself.mtdefetivacancelamento();
								}, 300); 								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});								
			},
			mtdefetivacancelamento(){
				let vself  = this;
				let loader = vself.$loading.show();
				let hora   = util.DataAtual(true, true);
				hora = hora.substring(11, 19);
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           		valor : 'cancelamento'},
					{parametro: 'idpedido',     		valor : vself.pedidocancelar.id},
					{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
					{parametro: 'dtcancelamento',     	valor : vself.mtdformatadatagravar(vself.cdtcancelamento)+' '+hora},
					{parametro: 'motivocancelamento',   valor : vself.cmotivocancelamento},
					{parametro: 'codop',        		valor : '020Z.010Z.060Z'}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						$('#mdcancelarpedido').modal('hide');
						vself.$toastr.s('Cancelamento realizado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
						vself.pidpedido     	= vself.pedidocancelar.id;
						vself.pqtd_paginas  	= 1;
						vself.mtdcancelaredicao();
						vself.mtdcarregapedidos(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},
			mtdrecalcularprecos(){
				let vself 		= this;
				let lstitenstmp = [];
				for (let item of vself.lstitens) {
					let itemtmp = {
						idproduto		: item.idproduto,
						item			: item.item
					};
					lstitenstmp.push(itemtmp);
				}
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',           valor : 'precosplano'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idfilial',     valor : vself.vidfilial},
					{parametro: 'idtabela',     valor : vself.vidtabela},
					{parametro: 'itens',    	valor : JSON.stringify(lstitenstmp)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					$('#mdselecionarplano').modal('hide');					
					vself.vtotalgeral	=  vself.vtotalgeral - vself.vtotalprodutos;
					vself.vtotalprodutos = 0;

					let lstitenscopia = [];
					lstitenscopia     = JSON.parse(JSON.stringify(vself.lstitens));					
					let lstitensret   = response.data;
					for (let item of lstitensret) {						
						let indi = util.getArrayIndexForKey(lstitenscopia, 'item', item.item);					
						
						let valdescacres = 0;

						if (parseInt(lstitenscopia[indi].manipulaval) === 0){							
							lstitenscopia[indi].vlunitario 		= parseFloat(item.vlunitario);
							lstitenscopia[indi].descacres		= 0;

							if (parseFloat(item.vldescpromocional) > 0){								
								lstitenscopia[indi].tipodescacres	= 0;
								lstitenscopia[indi].valordescacres	= parseFloat(item.vldescpromocional);
								lstitenscopia[indi].manipulaval		= 0;

								valdescacres 		= parseFloat(lstitenscopia[indi].qtditem) * item.vlunitario * lstitenscopia[indi].valordescacres / 100;
															
							}else{
								lstitenscopia[indi].tipodescacres	= 0;
								lstitenscopia[indi].valordescacres	= 0;
								lstitenscopia[indi].manipulaval		= 0;							
							}

							let ret = util.itemcomimposto(item.dadosclasseitem, parseFloat(item.vlunitario), parseFloat(lstitenscopia[indi].qtditem), 0, parseFloat(valdescacres));								

							lstitenscopia[indi].vltotalimposto  = ret.totalimpostoitem;
							lstitenscopia[indi].vltotal	   		= ret.vltotalitem;	

						}
						vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(lstitenscopia[indi].vltotal);
					}
					vself.lstitens	    = [];
					vself.lstitens	    = lstitenscopia;

					vself.vtotalgeral	=  parseFloat(vself.vtotalgeral) + parseFloat(vself.vtotalprodutos);					

					loader.hide();
				}).catch(function (response) {
					$('#mdselecionarplano').modal('hide');
					vself.$toastr.e('Erro ao tentar carregar os preços do plano de pagamento. Descrição do erro: '+response.message, 'Erro!');
					loader.hide();
				});
			},
			mtdaplicardesconto(){
				if (this.lstitens.length === 0){
					this.$toastr.i('Não há itens para lançamento do desconto!', 'Informação!');
				}else{
					if (parseInt(this.vpermitedesconto) === 0){
						this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
						return;
					}
					for (let i = 0; i < this.lstitens.length; i++) {
						if (parseFloat(this.lstitens[i].vltotalimposto) > 0){
							this.$toastr.i('Alguns itens possuem imposto atrelado. Desconto deve ser aplicado individualmente!', 'Informação!');
							return;
						}
					}
					this.vtipodesctotal		 = 0;
					this.vfatordescontototal = 0;
					this.vtotalsemdesconto   = 0;
					this.vresdesconto		 = 0;
					for (let item of this.lstitens) {
						this.vtotalsemdesconto = parseFloat(this.vtotalsemdesconto) + (item.vlunitario * item.qtditem);
					}
					this.vtotalcomdesconto	   = parseFloat(this.vtotalsemdesconto);
					$('#mdaplicardesconto').modal('show');
				}
			},
			mtdconfirmaaplicacaodesconto(){				
				let fatoraplicar 		= 0;
				
				if (parseInt(this.vtipodesctotal)){
					fatoraplicar = parseFloat(this.vresdesconto);					
				}else{
					fatoraplicar = parseFloat(this.vfatordescontototal);
				}
				
				let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

				if (parseFloat(fatoraplicar) > parseFloat(descto_comparar)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
					$('#cbtipodesctotal').focus();					
					return;
				}

				if (parseFloat(fatoraplicar) < 0){
					this.$toastr.w('Desconto inválido!', 'Informação!');
					$('#edfatordescontototal').focus();
					return;
				}

				if (fatoraplicar > 0){
					for (let item of this.lstitens) {
						if (((parseFloat(item.vlunitario) * parseFloat(item.qtditem)) * parseFloat(fatoraplicar) / 100) < 0.01){
							this.$toastr.i('Desconto não pode ser divido pela quantidade total de itens do pedido. '+
											'A divisão do desconto fica abaixo de 0,01 centavo. Tente o desconto individual', 'Informação!');
							return;
						}
					}
				}
				$('#btnconfirmadesconto').prop('disabled', true);
				this.vtotalgeral		= parseFloat(this.vtotalgeral) - parseFloat(this.vtotalprodutos);				
				this.vtotalprodutos		= 0;
				let descacumulado 		= 0;
				for (var i = 0; i < this.lstitens.length; i++) {
					let vldesconto 			= (parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) * parseFloat(fatoraplicar) / 100;
					
					if (vldesconto < 0.01){
						descacumulado = parseFloat(vldesconto);
					}else{
						descacumulado = 0;
					}

					vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');
					if (vldesconto >= 0.01){
						this.lstitens[i].descacres		= 0;
						this.lstitens[i].tipodescacres	= 1;
						this.lstitens[i].valordescacres	= parseFloat(vldesconto) + parseFloat(descacumulado);
						descacumulado = 0;
						this.lstitens[i].vltotal		= util.arredondaValores((parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) - parseFloat(vldesconto), 2, 'round');
					}else{
						this.lstitens[i].valordescacres	= 0;
						this.lstitens[i].vltotal		= util.arredondaValores(parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem), 2, 'round');
					}
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);
				}

				this.vtotalprodutos 	= util.arredondaValores(parseFloat(this.vtotalprodutos), 2, 'round');

				this.vtotalgeral		= parseFloat(this.vtotalgeral) + parseFloat(this.vtotalprodutos);	
				
				let vlajuste = 0;
				let ajustar  = 0;
				if (parseFloat(this.vtotalcomdesconto) > parseFloat(this.vtotalprodutos)){
					vlajuste = parseFloat(this.vtotalcomdesconto) - parseFloat(this.vtotalprodutos);
					ajustar  = 1;//ajuste para menos
				}else{
					vlajuste = parseFloat(this.vtotalprodutos) - parseFloat(this.vtotalcomdesconto);
					ajustar  = 0;//ajuste para mais
				}
				if (vlajuste > 0 && vlajuste < 0.01){
					vlajuste = 0.01;
				}
				if (vlajuste > 0){
					for (var x = 0; x < this.lstitens.length; x++) {
						if (parseFloat(this.lstitens[x].vltotal) > vlajuste){
							//console.log(this.lstitens[x].valordescacres);
							if (ajustar === 0){//ajuste para mais
								this.lstitens[x].valordescacres	= util.arredondaValores(parseFloat(this.lstitens[x].valordescacres) + parseFloat(vlajuste), 2, 'round');
							}else{//ajuste
								this.lstitens[x].valordescacres	= util.arredondaValores(parseFloat(this.lstitens[x].valordescacres) - parseFloat(vlajuste), 2, 'round');
							}							
							if (this.lstitens[x].valordescacres < 0){
								this.lstitens[x].valordescacres = 0;
							}
							this.lstitens[x].vltotal		= (parseFloat(this.lstitens[x].vlunitario) * parseFloat(this.lstitens[x].qtditem)) - parseFloat(this.lstitens[x].valordescacres);							
							break;
						}
					}
					if (parseInt(ajustar) === 0){
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    - parseFloat(vlajuste);
					}else{
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    + parseFloat(vlajuste);						
					}					
				}		
				$('#mdaplicardesconto').modal('hide');
				setTimeout(() => {
					$('#btnconfirmadesconto').prop('disabled', false);
				}, 500);
			},
			mtddefinirfilialemissaonf(pedido, modelo){
				$('#mdmenupedido').modal('hide');
				
				if (parseInt(pedido.tipo) === 3){
					this.$toastr.i('Emissão de NF somente para pedidos!', 'Informação!');
					return;
				}
				if (parseFloat(pedido.totalgeral) <= 0){
					this.$toastr.w('Emissão de NF somente para pedidos!', 'Atenção!');
					return;
				}

				this.vpedidonf   = pedido;
				this.vidfilialnf = pedido.idfilial;
				this.vnomefilianf= pedido.fantasia;	
				this.vmodelonf	 = modelo;			
				$('#mddefinefilialnf').modal('show');
			},
			mtdgerarenviarnf(apenasregistro){				
				let vself 	 = this;		

				if (vself.vidfilialnf === null){
					vself.$toastr.w('Informe a filial para emissão da NF!', 'Atenção!');
					$('#cbfilialnf').select2('open');
					return;
				}
				
				this.habbtnf = true;
				$('#mddefinefilialnf').modal('hide');

				vself.vpedidonf.idfilialnf = vself.vidfilialnf;//define a filial para emissão da nf
				vself.vpedidonf.origemnf   = 0;
				if (!util.opcaousuario('020Z.010Z.065Z', vself.$store.state.perfilusuario)){
					vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					let loader = vself.$loading.show();
					let parametros      = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : apenasregistro ? 'gerarnf' : 'gerarenviarnf'},
						{parametro: 'pedido',     	valor : JSON.stringify(vself.vpedidonf)},
						{parametro: 'modelo',     	valor : vself.vmodelonf},
						{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        valor : '020Z.010Z.065Z'}
					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if ($.isNumeric(response.data)){
							vself.vpedidonf.idnotafiscal = response.data;
							vself.vpedidonf.situacaonota = 2;
							vself.$toastr.s('Nota gerada com sucesso!', 'Informação!');
							if (!apenasregistro){
								vself.mtdimprimirdanfe(vself.vpedidonf);
							}
							vself.pfiltropor		= 0;
							vself.psituacao     	= 3;
							vself.pentregaexterna 	= 2;
							vself.pidpedido     	= vself.vpedidonf.id;
							vself.pqtd_paginas  	= 1;
							vself.mtdcancelaredicao();
							vself.mtdcarregapedidos(1);								
						}else{
							let tpret = response.data.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.substring(4), 'Atenção!');
									break;
								case 'E': default:
									vself.$toastr.e(response.data.substring(4), 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						loader.hide();
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});
				}				
			},			
			mtdalterarqtdlevar(item){
				let vself 			= this;

				if (parseInt(vself.opcrud) < 3){
					vself.litemlevar 	= item;

					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : vself.litemlevar.coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto 		= response.data[0];	
							vself.lfracionado	= produto.fracionado;

							vself.lqtdlevar  	= parseFloat(item.qtditem) - parseFloat(item.qtdentregar);
							$('#mdalteracaoqtdlevar').modal('show');
						}else{
							vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
						}
					}).catch(function (response) {
						vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
						loader.hide();						
					});
				}	
			},
			mtdconfirmaraltercaoqtdlevar(){
				if (parseFloat(this.lqtdlevar) < 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtdlevar').focus();
					return;
				}
                if (parseInt(this.lfracionado) === 0){
                    if (!Number.isInteger(this.lqtdlevar)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtdlevar').focus();
                        return;
                    }
				}				
				if (parseFloat(this.lqtdlevar) > parseFloat(this.litemlevar.qtditem)){
					this.$toastr.w('Quantidade não pode ser superior a quantidade do item!', 'Atenção!');
					$('#edqtdlevar').focus();
					return;
				}								
				let indiceitem 						= util.getArrayIndexForKey(this.lstitens, 'item', this.litemlevar.item)
				let lsttmp 							= this.lstitens;
				this.lstitens						= [];

				lsttmp[indiceitem].qtdentregar      = parseFloat(this.litemlevar.qtditem) - parseFloat(this.lqtdlevar);

				this.lstitens 						= lsttmp;	
				
				$('#mdalteracaoqtdlevar').modal('hide');
			},
			mtdentregaexterna(pedido){
				var vself       = this;
				if (!util.opcaousuario('020Z.010Z.165Z', vself.$store.state.perfilusuario)){
					vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {                
					let loader      = vself.$loading.show();
					let filtro      = ' and p.id='+pedido.id;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						
						if (parseInt(response.data.pedidos[0].stpedido) !== 1){
							vself.$toastr.w('Opção disponível somente para pedidos faturados!', 'Informação!');
							return;
						}
						if (parseInt(response.data.pedidos[0].entregaexterna) !== 1){
							vself.$toastr.w('Opção disponível apenas para pedidos marcados como entrega externa!', 'Informação!');
							return;
						}
						if (parseInt(response.data.pedidos[0].entregaexternafinalizada) !== 0){
							vself.$toastr.w('Entrega externa do pedido já finalizada!', 'Informação!');
							return;
						}							
						vself.pedidoentrega			= response.data.pedidos[0];
						vself.itensbc.item2.titulo 	= 'LOGÍSTICA EXTERNA DO PEDIDO';
						vself.itensbc.item1.ativo 	= true;
						vself.itensbc.item2.ativo 	= true;
						vself.ativadesativa 			= false;
						vself.ativadesativavendedor 	= false;
						$('#pnlista').hide();
						$('#pnentregaexterna').fadeIn(700);

					}).catch(function (response) {
						loader.hide();
					});
				}				
			},
			mtddefinirqtdentregue(item){
				let vself 			= this;

				vself.eitementregar	= item;

				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ''},
					{parametro: 'coddig',           valor : vself.eitementregar.coddig},
					{parametro: 'limit',            valor : 1},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					loader.hide();						
					if (response.data.length > 0){
						let produto 		= response.data[0];	
						vself.efracionado	= produto.fracionado;

						vself.eqtdentregue	= parseFloat(item.qtdentregar);
						$('#mddefinirqtdentregue').modal('show');
					}else{
						vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
					}
				}).catch(function (response) {
					vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
					loader.hide();						
				});
			},
			mtdconfirmaraltercaoqtdentregue(){
				if (parseFloat(this.eqtdentregue) < 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtdlevarentrega').focus();
					return;
				}
                if (parseInt(this.efracionado) === 0){
                    if (!Number.isInteger(this.eqtdentregue)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtdlevarentrega').focus();
                        return;
                    }
				}				
				if (parseFloat(this.eqtdentregue) > parseFloat(this.eitementregar.qtdentregar)){
					this.$toastr.w('Quantidade não pode ser superior a quantidade a ser entregue!', 'Atenção!');
					$('#edqtdlevarentrega').focus();
					return;
				}								
				let indiceitem 						= util.getArrayIndexForKey(this.pedidoentrega.itens, 'item', this.eitementregar.item)
				let lsttmp 							= this.pedidoentrega.itens;
				this.lstitens						= [];

				lsttmp[indiceitem].qtdentregue      = parseFloat(this.eqtdentregue);

				this.pedidoentrega.itens 			= lsttmp;	
				
				$('#mddefinirqtdentregue').modal('hide');
			},
			mtdentregartodositens(){
				for (let i = 0; i < this.pedidoentrega.itens.length; i++) {
					this.pedidoentrega.itens[i].qtdentregue = this.pedidoentrega.itens[i].qtdentregar;					
				}
			},
			mtditenspendentesentrega(){
				let $ret  = false;
				for (let i = 0; i < this.pedidoentrega.itens.length; i++) {
					if (parseFloat(this.pedidoentrega.itens[i].qtdentregue) < parseFloat(this.pedidoentrega.itens[i].qtdentregar)){
						$ret = true;
						return $ret;						
					}
				}
			},
			mtdsalvarentrega(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Salvar alterações na entrega externa?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								let loader = vself.$loading.show();
								let itensentrega = [];
								for (let i = 0; i < vself.pedidoentrega.itens.length; i++) {
									let itemtmp = {
										item		: vself.pedidoentrega.itens[i].item,
										idproduto	: vself.pedidoentrega.itens[i].idproduto,
										qtdentregue	: vself.pedidoentrega.itens[i].qtdentregue
									};																		
									itensentrega.push(itemtmp);
								}								
								let parametros      = [
									{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           		valor : 'salvarentrega'},
									{parametro: 'idpedido',     		valor : vself.pedidoentrega.id},
									{parametro: 'itens',				valor : JSON.stringify(itensentrega)},
									{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
									{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
									{parametro: 'codop',        		valor : '020Z.010Z.165Z'}
								];
								let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if ($.isNumeric(response.data)){
										vself.$toastr.s('Alterações salvas com sucesso!', 'Informação!');
										vself.pfiltropor		= 0;
										vself.psituacao     	= 3;
										vself.pentregaexterna 	= 2;
										vself.pidpedido     	= vself.pedidoentrega.id;
										vself.pqtd_paginas  	= 1;
										vself.mtdcancelaredicao();
										vself.mtdcarregapedidos(1);
									}else{
										let tpret = response.data.substring(0,1);
										switch (tpret) {
											case 'I':
												vself.$toastr.w(response.data.substring(4), 'Atenção!');
												break;
											case 'E': default:
												vself.$toastr.e(response.data.substring(4), 'Erro!');
												break;
										}
									}
								}).catch(function (response) {
									loader.hide();
									vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
								});
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});								
			},
			mtdfinalizarentregaexterna(){
				let vself = this;
				if (vself.mtditenspendentesentrega()){
					vself.$toastr.w('Impossível finalizar entrega com itens pendentes!', 'Informação!');
					return;
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma finalização da entrega externa?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								let loader = vself.$loading.show();
								let parametros      = [
									{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           		valor : 'finalizarentrega'},
									{parametro: 'idpedido',     		valor : vself.pedidoentrega.id},
									{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
									{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
									{parametro: 'codop',        		valor : '020Z.010Z.165Z'}
								];
								let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if ($.isNumeric(response.data)){
										vself.$toastr.s('Entrega finalizada com sucesso!', 'Informação!');
										vself.pfiltropor		= 0;
										vself.psituacao     	= 3;
										vself.pentregaexterna 	= 2;
										vself.pidpedido     	= vself.pedidoentrega.id;
										vself.pqtd_paginas  	= 1;
										vself.mtdcancelaredicao();
										vself.mtdcarregapedidos(1);
									}else{
										let tpret = response.data.substring(0,1);
										switch (tpret) {
											case 'I':
												vself.$toastr.w(response.data.substring(4), 'Atenção!');
												break;
											case 'E': default:
												vself.$toastr.e(response.data.substring(4), 'Erro!');
												break;
										}
									}
								}).catch(function (response) {
									loader.hide();
									vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
								});
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});								
			},
			mtdimprimirentrega(idpedido, tp, eopitensimpressao){
				if (!util.opcaousuario('020Z.010Z.165Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else { 								
					window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirentregaexternapedido.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+
								'&idpedido='+idpedido+'&tpimp='+tp+
								'&opitens='+eopitensimpressao+'&idu='+
								this.$store.state.usuario.id, '_blank');				
				}
			},
            mtdgerarimagens(imagens){
                this.images = [];
                for (let i = 0; i < imagens.length; i++) {
                    this.images.push(this.$store.state.configpaths.pathimagens + imagens[i].patharquivo);                    
                }
                this.$viewerApi({                   
                    images: this.images,
                });
            },
            mtdvisualizarimagens(pedido){
				if (parseInt(pedido.tipo) === 3){
					this.$toastr.i('Imagem não disponível!', 'Informação!');
					return;
				}				
				if (parseFloat(pedido.totalgeral) <= 0){
					this.$toastr.w('Imagem não disponível!', 'Atenção!');
					return;
				}				
                if (pedido.imagens.length > 0){
					this.mtdgerarimagens(pedido.imagens);                                                 
                }else{
                    this.$toastr.i('Não há imagens disponíveis para visualização!', 'Informação!');
                }				
            },
            mtdaplicaselecaochecklist: function(valoratribuir){
                for (var i = 0; i < this.lstchecklist.length; i++) {
                    this.lstchecklist[i].habilita = valoratribuir;
                }
            },
            mtdmarcartodaschecklist(){
                if (util.findValInArray(this.lstchecklist, 'habilita', 0)){
                    this.mtdaplicaselecaochecklist(1);
                }else{
                    this.mtdaplicaselecaochecklist(0);
                }
            },
            mtdhabilitachecklist(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lstchecklist[index].habilita) === 0) {
                        this.lstchecklist[index].habilita = 1;
                    } else {
                        this.lstchecklist[index].habilita = 0;
                    }
                }
            },
            mtdalterarperfilfluxo(forma, indice){
                this.aindiceperfilfluxo  = indice;
                this.aidperfilfluxo      = forma.idperfilfluxo;
                this.adescperfilfluxo    = forma.descperfilfluxo;
                if (parseInt(this.aidperfilfluxo) !== 0){
                    var deffluxo  = new Option(this.adescperfilfluxo, this.aidperfilfluxo, true, true);
                    $('#cbperfilfluxofinal').append(deffluxo).trigger('change');
                }else{
                    $('#cbperfilfluxofinal').val(null).trigger('change');
                }

                $('#mdlalterarperfilfluxofinal').modal('show');
            },
            mtdconfirmarperfilfluxo(){
                this.lstformasfaturar[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
                this.lstformasfaturar[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];
                $('#mdlalterarperfilfluxofinal').modal('hide');
            },
            mtdconferencia(item){
				if (parseInt(item.tipo) === 3){
					this.$toastr.i('Conferência não permitida à um crédito avulso!', 'Informação!');
					return;
				}
				if (parseFloat(item.totalgeral) <= 0){
					this.$toastr.w('Conferência não permitida para um pedido de crédito!', 'Atenção!');
					return;
				}
                if (!util.opcaousuario('020Z.010Z.032Z', this.$store.state.perfilusuario)){
                   this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CONFERÊNCIA DE PEDIDOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.vicodpro 		= null;
                    this.videscpro 		= '';
                    this.vqtdfalta 		= '0';
                    this.vfinalizado 	= false;
                    this.vachouPro 		= false;
                    this.vmsgPro 		= '';
                    $('#pnlista').hide();
                    $('#pncadastro').hide();
                    $('#pnconferencia').fadeIn(700);                    
                    this.mtdlocalizaritensconf(item);
                }
            },
			mtdlocalizaritensconf(item){
                var vself           = this;
                let loader          = this.$loading.show();

                vself.cfidpedido 	= item.id;			

                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagemconf'},
                    {parametro: 'idpedido', 	valor  : item.id}
                ];
                let retorno              = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    vself.lstitensconf		= response.data.itens;
                    vself.lstcodigosconf    = response.data.codigos;

                    if(vself.lstitensconf.length > 0){
                        vself.ativadesativa    = true;
                        vself.ativadesativacod = false;
                        loader.hide()

                        vself.$nextTick(function () {
                            $("#edvicodpro").focus();
                        })
                    }else{
                        vself.$toastr.w('Nenhum registro encontrado!', 'Warning!');
                    }
                }).catch(function (response) {
                    vself.lstitensconf     = [];
                    vself.lstcodigos       = [];
                    loader.hide();
                    vself.ativadesativa    = false;
                    vself.ativadesativacod = true;
                })                				
			},
            mtdativacodpro(){
                setTimeout(() => {
                    this.ativadesativacod = false;                    
                    this.$nextTick(function () {
                        $("#edvicodpro").focus()
                    });                    
                }, 300);                
            },
            submitProd(){
                this.ativadesativacod   = true;
                let cdpro_busca         = null;
                cdpro_busca             = this.vicodpro;
                if (cdpro_busca === null || cdpro_busca === undefined || cdpro_busca === '') {
                    this.limpaCamposPro(this.mtdativacodpro);
                    return;
                }else {
                    this.igualaDadosProduto(cdpro_busca)
                }				
            },
            limpaCamposPro(callback) {
                this.ativadesativacod = false;
                this.videscpro        = '';
                this.vqtdfalta        = 0;
      
                callback();
            },
            igualaDadosProduto(codPro){

                //this.limpaCamposPro()
                this.videscpro        = '';
                this.vqtdfalta        = 0;

                if (codPro != null) {
                    let indxCod        = util.getArrayIndexForKey(this.lstcodigosconf, 'codigo', codPro)
                    let codPesq        = codPro

                    if(indxCod > -1){
                        codPesq        = this.lstcodigosconf[indxCod].idproduto
                    }
                    
                    if (util.findValInArray(this.lstitensconf, 'idproduto', codPesq)) {

                        this.vmsgPro   = ''

                        let indxPro    = util.getArrayIndexForKey(this.lstitensconf, 'idproduto', codPesq)
                        this.videscpro = this.lstitensconf[indxPro].descricao
                        this.vqtdfalta = this.lstitensconf[indxPro].qtdfalta

                        if(this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) {
                            if(((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta < 0)) || 
                                ((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta <= this.lstitensconf[indxPro].qtditem))) {

                                //Zerar o qtdfalta   
                                this.lstitensconf[indxPro].qtdfalta = 0
                            }

                            this.lstitensconf[indxPro].situacao   = 1
                            this.mtItemConcluidoConf(codPesq)                            
                        }else{
                            this.lstitensconf[indxPro].qtdconf    = ++this.lstitensconf[indxPro].qtdconf;
                            this.lstitensconf[indxPro].qtdfalta   = --this.vqtdfalta;

                            if(((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta < 0)) || 
                                ((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta <= this.lstitensconf[indxPro].qtditem))) {

                                //Zerar o qtdfalta   
                                this.lstitensconf[indxPro].qtdfalta = 0
                                this.lstitensconf[indxPro].situacao = 1

                                this.mtItemConcluidoConf(codPesq)
                            }else{
                                this.play({ id: 'faltando' })
                                this.vachouPro = true
                                this.vmsgPro = 'PRODUTO ( ' + this.vicodpro + ' ) CONFERIDO | FALTA ' + this.vqtdfalta                
                            }

                            this.vicodpro = '';
                            setTimeout(() => {
                                this.limpaCamposPro(this.mtdativacodpro);
                            }, 500);                                      
                        }        
                    }else{
                        this.$toastr.w('Produto não encontrado na lista!', 'Warning!');
                        this.play({ id: 'alerta' });
                        this.vachouPro = false;
                        this.vmsgPro   = 'PRODUTO ( ' + this.vicodpro + ' ) NÃO ENCONTRADO NA LISTA';
                        this.vicodpro  = null;
                        setTimeout(() => {
                            this.limpaCamposPro(this.mtdativacodpro);
                        }, 500);                                  
                    }          
                }
            },
            mtItemConcluidoConf(CodProd){
                this.$toastr.w('Quantidade do produto ' + CodProd + ' atingida!', 'Warning!');
                this.play({ id: 'concluido' });
                this.vachouPro = false;
                this.vicodpro  = null;
                this.videscpro = '';
                this.vqtdfalta = '0';
                this.limpaCamposPro(this.mtdativacodpro);
            },
            mtdcancelarconf(){
                let vself = this
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Tem certeza que deseja cancelar a conferência?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                                vself.ativadesativa 		= false;
                                vself.ativadesativacod 		= true;
                                vself.lstitensconf	 		= [];
                                vself.lstcodigosconf 		= [];
                                vself.itensbc.item1.ativo 	= false;
                                vself.itensbc.item2.ativo 	= false;
                                vself.vfinalizado         	= false;
                                vself.vachouPro           	= false;
                                vself.vmsgPro             	= '';

                                $('#pnconferencia').hide();
                                $('#pncadastro').hide();
                                $('#pnlista').fadeIn(700);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#edvicodpro').focus()
                            }
                        }
                    }
                });        
            },	
			mtdgravarconf(){
                let vself          = this;
                let falta_conferir = true;

                for (var i = 0; i < vself.lstitensconf.length; i++) {									
                    if(vself.lstitensconf[i]['qtdfalta'] > 0){
                        falta_conferir = false
                        break
                    }				
                }

                if(!falta_conferir){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Tem certeza que deseja gravar com pedência de itens conferidos?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                            //Grava com pendencia
                            vself.mtatribuiConfItens();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            	$('#edvicodpro').focus()
                            }
                        }
                        }
                    });
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma finalização da conferência?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
								//Finaliza conferência
								vself.mtatribuiConfItens();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            	$('#edvicodpro').focus();
                            }
                        }
                        }
                    });
                }				
			},
            mtatribuiConfItens(){
                let vself        = this
                let loader       = vself.$loading.show()
                let registroconf = {
                    'idpedido'  	: vself.cfidpedido,
                    'itensconf'     : vself.lstitensconf
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gravarconferencia'},
                    {parametro: 'registro',     valor : JSON.stringify(registroconf)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.010Z.028Z'},//verificar                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!')
                        vself.lstitensconf     = []
                        vself.lstcodigosconf   = []
                        //vself.limpaCamposPro()
                        vself.ativadesativa    = false
                        vself.ativadesativacod = true
                        vself.vfinalizado      = false
                        vself.vachouPro        = false
                        vself.vmsgPro          = ''
						//carrega a listagem - montar os campos
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= vself.cfidpedido;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 2;					
						vself.porigem			= 10;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });
            },
			mtdrotinarecibopedido(pedido){
				let vself = this;
				if (parseInt(pedido.tipo) === 3){
					this.$toastr.i('Recibo somente para pedidos faturados!', 'Informação!');
					return;
				}
				if (parseFloat(pedido.totalgeral) <= 0){
					this.$toastr.w('Recibo somente para pedidos faturados!', 'Atenção!');
					return;
				}								
				if (!util.opcaousuario('020Z.010Z.170Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					vself.pedidorecibo			= JSON.parse(JSON.stringify(pedido));
					vself.prformapagamento		= pedido.prformapagamento === '' ? pedido.descplano : pedido.prformapagamento;
					vself.prtrasportadora		= pedido.prtrasportadora;
					vself.prnnf					= parseInt(pedido.prnnf) === 0 ? (parseInt(pedido.idnotafiscal) > 0 ? pedido.idnotafiscal : '') : pedido.prnnf;
					vself.prindicacao			= pedido.prindicacao;
					vself.pratividade			= pedido.pratividade;
					vself.probservacoes			= pedido.probservacoes;				
					$('#mdrecibopedido').modal('show');
				}
			},
			mtdconfirmarecibopedido(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma emissão do recibo do pedido?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {        
							vself.mtdsalvarecibopedido();
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
							//$('#edvicodpro').focus()
						}
					}
					}
				});				
			},
			mtdsalvarecibopedido(){
                let vself        = this
                let loader       = vself.$loading.show()
                let registro = {
                    'idpedido'  		: vself.pedidorecibo.id,
                    'prformapagamento'	: vself.prformapagamento,
					'prtrasportadora'	: vself.prtrasportadora,
					'prnnf'				: vself.prnnf === '' ? 0 : vself.prnnf,
					'prindicacao'		: vself.prindicacao,
					'pratividade'		: vself.pratividade,
					'probservacoes'		: vself.probservacoes
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gravarecibopedido'},
                    {parametro: 'registro',     valor : JSON.stringify(registro)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.010Z.170Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
						vself.mtdimprimerecibopedido(vself.pedidorecibo.id);
						vself.pedidorecibo			= [];
						vself.prformapagamento		= '';
						vself.prtrasportadora		= '';
						vself.prnnf					= '';
						vself.prindicacao			= '';
						vself.pratividade			= '';
						vself.probservacoes			= '';
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });
			},
			mtdimprimerecibopedido(idpedido){
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimerecibopedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&idu='+this.$store.state.usuario.id, '_blank');					
			},
			mtdetiquetasvolumes(){
				if (parseInt(this.pedidomenu.tipo) === 3){
					this.$toastr.i('Emissão de etiquetas somente para pedidos!', 'Informação!');
					return;
				}
				if (parseFloat(this.pedidomenu.totalgeral) <= 0){
					this.$toastr.w('Emissão de etiquetas somente para pedidos!', 'Atenção!');
					return;
				}								
				$("#mdetiquetasvolumepedido").modal('show');
			},
			mtddetalhespedido(idpedido){
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},
            mtdimpressao(gerarexcel){
                let vself   = this;
                let filtro  = vself.mtdfiltropesquisa();
				let idforma = vself.pidforma !== null ? vself.pidforma : 0;
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&op=imprimirlistapedidos'+
                            '&filtro='+filtro+
                            '&situacao='+vself.psituacao+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
							'&idforma='+idforma+
                            '&usuario='+vself.$store.state.usuario.nome+
							'&gerarexcel='+gerarexcel, '_blank');					                
            },
			mtdanalisecortes(){
				if (!util.opcaousuario('020Z.010Z.034Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					$('#mdanalisecortes').modal('show');
				}
			},
			mtdlistarcortes(idproduto){
                let vself        = this;				
				let filtro		 = 'and p.stpedido=0 and p.dtemissao between "' + util.InverterData(vself.cdtini) + '" and "' + util.InverterData(vself.cdtfim) + '"';
				if (parseInt(vself.ctipo) < 3){
					filtro = filtro + ' and p.tipo='+vself.ctipo;
				}
                let loader       = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listarcortes'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'diferenca',	valor : vself.cdiferenca},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					vself.lstitenscorte = response.data.itens;
					vself.cqtditenscorte= response.data.itenscortar;
					vself.ctotalcortes	= response.data.totalcorte;
					if (idproduto > 0){
						for (let i = 0; i < vself.lstitenscorte.length; i++) {
							if (parseInt(vself.lstitenscorte[i].idproduto) === parseInt(idproduto)){
								vself.lstitenscorte[i].expandir = 1;
								return;
							}
						}
					}
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar os registos. Descrição do erro: '+response.message, 'Erro!')
                });				
			},
			mtdexpandirpedidos(indice){
				if (parseInt(this.lstitenscorte[indice].expandir) === 1){
					this.lstitenscorte[indice].expandir = 0;
				}else{
					this.lstitenscorte[indice].expandir = 1;
				}
			},
			mtdimprimirlistagemcortes(){
                let vself   = this;
				let filtro		 = 'and p.stpedido=0 and p.dtemissao between "' + util.InverterData(vself.cdtini) + '" and "' + util.InverterData(vself.cdtfim) + '"';
				if (parseInt(vself.ctipo) < 3){
					filtro = filtro + ' and p.tipo='+vself.ctipo;
				}
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&op=imprimirlistagemcortes'+
                            '&filtro='+filtro+
                            '&diferenca='+vself.cdiferenca+
                            '&dtini='+vself.cdtini+
                            '&dtfim='+vself.cdtfim+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');				
			},
			mtdrotinacorteitem(iitem, ipedido){
				this.itemcortar 	= JSON.parse(JSON.stringify(this.lstitenscorte[iitem]));
				this.pedidocortar   = JSON.parse(JSON.stringify(this.lstitenscorte[iitem].pedidos[ipedido]));
				this.qtditemcortar  = this.lstitenscorte[iitem].pedidos[ipedido].qtditem;
				$('#mdcorteitem').modal('show');
			},
			mtdconfirmarcorteitem(){
				let vself = this;
				if (parseFloat(vself.qtditemcortar) <= 0){
					vself.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemcortar').focus();
					return;
				}
                if (parseInt(vself.itemcortar.fracionado) === 0){
                    if (!Number.isInteger(vself.qtditemcortar)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemcortar').focus();
                        return;
                    }
				}				
				if (parseFloat(vself.qtditemcortar) > parseFloat(vself.pedidocortar.qtditem)){
					vself.$toastr.w('Quantidade de corte não pode ser maior que a quantidade do item!', 'Atenção!');
					$('#edqtditemcortar').focus();
					return;
				}				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma corte do item?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {        
							vself.mtdgravarcortaritem();
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
							$('#edqtditemcortar').focus();
						}
					}
					}
				});								
			},
			mtdgravarcortaritem(){
				let vself = this;
                let loader       = vself.$loading.show()
                let parametros   = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'cortaritem'},
					{parametro: 'qtdcorte',     valor : vself.qtditemcortar},
					{parametro: 'idpedido',     valor : vself.pedidocortar.idpedido},
					{parametro: 'idproduto',    valor : vself.itemcortar.idproduto},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.010Z.034Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Corte realizado com sucesso!', 'Informação!')
						vself.mtdlistarcortes(vself.itemcortar.idproduto);
						$('#mdcorteitem').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });				
			},
			mtditenscortados(){		
				this.lcdtini 		= util.DataAtual(true);
				this.lcdtfim 		= util.DataAtual(true);
				this.lcidvendedor 	= null;
				$("#cblcvendedor").val(null).trigger('change');										
				$('#mditenscortados').modal('show');
			},
			mtdimprimiritenscortados(){
                let vself   = this;
				let filtro		 = 'and i.dthrcorte between "' + util.InverterData(vself.lcdtini) + ' : 00:00:00" and "' + util.InverterData(vself.lcdtfim) + ' : 23:59:59"';

				if (vself.lcidvendedor !== null){
					filtro		 = filtro + ' and i.idvendedor='+vself.lcidvendedor;
				}
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&op=imprimiritenscortados'+
                            '&filtro='+filtro+
                            '&dtini='+vself.lcdtini+
                            '&dtfim='+vself.lcdtfim+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');				
				$('#mditenscortados').modal('hide');							
			},
			mtdliberarpedido(idpedido){
				$('#mdmenupedido').modal('hide');
				let vself = this;
				if (!util.opcaousuario('020Z.010Z.045Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{					
					$.confirm({
						title: 'Confirmação!',
						content: 'Confirma LIBERAÇÃO do pedido para o FATURAMENTO?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									$('.btn-blue').prop('disabled', true);

									let loader = vself.$loading.show();
									let parametros      = [
										{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
										{parametro: 'op',           valor : 'liberarfaturamento'},
										{parametro: 'idpedido',     valor : idpedido},
										{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
										{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
										{parametro: 'codop',        valor : '020Z.010Z.045Z'}
									];
									let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
									retorno.then(function (response) {
										loader.hide();
										if ($.isNumeric(response.data)){
											vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
											vself.pfiltropor		= 0;
											vself.psituacao     	= 3;
											vself.pentregaexterna 	= 2;
											vself.pidpedido     	= idpedido;
											vself.pqtd_paginas  	= 1;
											vself.mtdcancelaredicao();
											vself.mtdcarregapedidos(1);
										}else{
											let tpret = response.data.substring(0,1);
											switch (tpret) {
												case 'I':
													vself.$toastr.w(response.data.substring(4), 'Atenção!');
													break;
												case 'E': default:
													vself.$toastr.e(response.data.substring(4), 'Erro!');
													break;
											}
										}
									}).catch(function (response) {
										loader.hide();
										vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
									});
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
									$('#btgravar').focus();
								}
							}
						}
					});		
				}		
			},
			mtdinformacoescliente(idcliente, nomecliente, vlcredito){
				if (idcliente !== '' && idcliente !== null){
					this.idclienteinf 	= idcliente;
					this.nomeclienteinf = nomecliente;
					this.vlcreditoinf 	= vlcredito;
					$('#mdinformacoescliente').modal('show');
				}else{
					this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
				}
			},
			mtdcreditoavulso(){
				if (!util.opcaousuario('020Z.010Z.180Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					$('#mdcreditoavulso').modal('show');
				}
			},
			mtdconfirmarcreditoavulso(){
				let vself = this;
				if (vself.vidfilialca === null){
					vself.$toastr.w('Informe a filial!', 'Atenção!');
					$("#cbfilialca").select2("open");
					return;
				}
				if (vself.vidclienteca === null){
					vself.$toastr.w('Informe o cliente!', 'Atenção!');
					$("#cbclienteca").select2("open");
					return;
				}				
				if (vself.vvalorcreditoavulso <= 0){
					vself.$toastr.w('Valor do crédito deve ser informado!', 'Atenção!');
					$('#edvlcreditoavulso').focus();
					return;
				}				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma inclusão do crédito avulso?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdgravarcreditoavulso();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});				
			},
			mtdgravarcreditoavulso(){
				let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'creditoavulso'},
                    {parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
					{parametro: 'idfilialca',     	valor : vself.vidfilialca},
					{parametro: 'idclienteca',    	valor : vself.vidclienteca},
					{parametro: 'dtemissaoca',    	valor : vself.mtdformatadatagravar(util.DataAtual())},
					{parametro: 'observacoesca',  	valor : vself.vobservacoesca},
					{parametro: 'vlcreditoavulso',	valor : vself.vvalorcreditoavulso},
                    {parametro: 'codop',        	valor : '020Z.010Z.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					$('#mdcreditoavulso').modal('hide');
                    if ($.isNumeric(response.data.inf)){						
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ptipo				= 4;
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= response.data.inf;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 2;					
						vself.porigem			= 10;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
								vself.ptipo				= 4;
								vself.pfiltropor		= 0;
								vself.psituacao     	= 3;
								vself.pentregaexterna 	= 2;
								vself.pidpedido     	= response.data.pedido.id;
								vself.pqtd_paginas  	= 1;
								vself.pcredito			= 2;					
								vself.porigem			= 10;
								vself.mtdcarregapedidos(1);								
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtddevolucao(pedido){
				if (!util.opcaousuario('020Z.010Z.190Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					if (parseFloat(pedido.vlcredito) > 0){
						this.$toastr.w('Devolução de crédito não permitida!', 'Atenção!');
						return;
					}	
					if (parseInt(pedido.stpedido) !== 1){
						this.$toastr.w('Devolução permitida apenas para pedidos faturados!', 'Atenção!');
						return;
					}								
					this.pedidodevolucao		= [];
					this.dtemissaodevolucao		= util.DataAtual(true);
					this.totaldevolucao			= 0;
					this.observacoesdevolucao   = '';
					let ped = JSON.parse(JSON.stringify(pedido));
					for (let i = 0; i < ped.length; i++) {
						ped[i].qtddevolucao = 0;					
					}
					this.pedidodevolucao = JSON.parse(JSON.stringify(ped));
					$('#mddevolucao').modal('show');
				}
			},
			mtddevolvertodos(){
				let ped = JSON.parse(JSON.stringify(this.pedidodevolucao));
				for (let i = 0; i < ped.itens.length; i++) {
					ped.itens[i].qtddevolucao = ped.itens[i].qtditem;
				}
				this.pedidodevolucao = JSON.parse(JSON.stringify(ped));
				this.mtdcalculatotaldevolucao();
			},
			mtdcalculatotaldevolucao(){
				this.totaldevolucao			= 0;
				for (let i = 0; i < this.pedidodevolucao.itens.length; i++) {
					this.totaldevolucao = this.totaldevolucao + (
						parseFloat(this.pedidodevolucao.itens[i].qtddevolucao) * (parseFloat(this.pedidodevolucao.itens[i].vltotal) / parseFloat(this.pedidodevolucao.itens[i].qtditem))
					);					
				}
			},
			mtdconfirmardevolucao(){
				let vself = this;
				let existedev = false;	
				for (let i = 0; i < vself.pedidodevolucao.itens.length; i++) {
					if (vself.pedidodevolucao.itens[i].qtddevolucao > 0){
						existedev = true;
					}
					if (vself.pedidodevolucao.itens[i].qtddevolucao < 0){
						vself.$toastr.w('Item '+vself.pedidodevolucao.itens[i].item+' está com a quantidade de devolução negativa!', 'Atenção!');
						return;
					}

					if (vself.pedidodevolucao.itens[i].qtddevolucao > vself.pedidodevolucao.itens[i].qtditem){
						vself.$toastr.w('Item '+vself.pedidodevolucao.itens[i].item+' está com a quantidade de devolução maior que a quantidade vendida. Verifique e tente novamente!', 'Atenção!');
						return;
					}

					if (parseInt(vself.pedidodevolucao.itens[i].fracionado) === 0){
						if (!Number.isInteger(vself.pedidodevolucao.itens[i].qtddevolucao)){
							vself.$toastr.w('Quantidade do item: '+vself.pedidodevolucao.itens[i].item+' não pode ser FRACIONADA!', 'Atenção!');
							return;
						}
					}					
				}
				if (!existedev){
					vself.$toastr.w('Não foram encontrados itens para devolução!', 'Atenção!');
					return;
				}										
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma devolução dos itens do pedido?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdgravardevolucao();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});
			},
			mtdgravardevolucao(){
				let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'devolucao'},
                    {parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
					{parametro: 'pedido',  			valor : JSON.stringify(vself.pedidodevolucao)},
					{parametro: 'dtdevolucao',    	valor : vself.mtdformatadatagravar(vself.dtemissaodevolucao)},
					{parametro: 'observacoes',  	valor : vself.observacoesdevolucao},					
					{parametro: 'totaldevolucao',	valor : vself.totaldevolucao},
                    {parametro: 'codop',        	valor : '020Z.010Z.190Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();					
                    if ($.isNumeric(response.data.inf)){						
						$('#mddevolucao').modal('hide');
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ptipo				= 4;
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= response.data.inf;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 2;					
						vself.porigem			= 10;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtdconfirmaredicaocreditoavulso(){
				let vself = this;
				if (parseFloat(vself.evledicaocreditoavulso) <= 0){
					vself.$toastr.w('Valor do crédito inválido!', 'Atenção!');
					$('#ededicaovlcreditoavulso').focus();
					return;
				}	
				if ((parseFloat(vself.vlegcredavulso) < parseFloat(vself.evledicaocreditoavulso))&&(parseInt(vself.defsubs)===0)){
					vself.$toastr.w('Valor do crédito inválido!', 'Atenção!');
					$('#ededicaovlcreditoavulso').focus();
					return;
				}				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma alteração do crédito?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdsalvaralteracaocredito();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});
			},
			mtdsalvaralteracaocredito(){
				let vself  = this;
                let loader = vself.$loading.show();
			
                let parametros      = [
                    {parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'alterarcredito'},
                    {parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
					{parametro: 'idpedido',    		valor : vself.ecreditoavulso.id},
					{parametro: 'dtalteracao',    	valor : vself.mtdformatadatagravar(util.DataAtual())},
					{parametro: 'obsalteracao',  	valor : vself.eobsalteracaocredito},
					{parametro: 'vledicaocreditoavulso', valor : vself.evledicaocreditoavulso},
					{parametro: 'somarsubs',        valor : vself.defsubs},
                    {parametro: 'codop',        	valor : '020Z.010Z.025Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					$('#mdedicaocreditoavulso').modal('hide');
                    if ($.isNumeric(response.data.inf)){						
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ptipo				= 4;
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= vself.ecreditoavulso.id;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 2;					
						vself.porigem			= 10;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			resetacalc(event){
				console.log('caiu')
				this.evledicaocreditoavulso = 0
				 
			}
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
					$('[data-toggle="popover"]').popover();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('020Z.010Z', vself.$store.state.perfilusuario)) {
						vself.pathimgview         = vself.$store.state.configpaths.pathimagens;
						vself.crotinacortes		  = util.opcaousuario('020Z.010Z.034Z', vself.$store.state.perfilusuario);
						$('#pnlista').fadeIn(700);
						$('#edidpedidopesq').focus();
						vself.mtdatzvariaveisperfil();
						vself.mtdselect2_def();
						vself.mtdexecutapesquisa();
						
							vself.pvisualizartotalizadores 	= util.opcaousuario('020Z.010Z.150Z', vself.$store.state.perfilusuario);
							vself.pvisualizarcustos 		= util.opcaousuario('020Z.010Z.155Z', vself.$store.state.perfilusuario);
							vself.pvisualizargraficos 		= util.opcaousuario('020Z.010Z.160Z', vself.$store.state.perfilusuario);
							vself.alterafilialnf			= util.opcaousuario('020Z.010Z.068Z', vself.$store.state.perfilusuario);
							setTimeout(function(){
								util.transformartabssanfona(vself);
							}, 120);
	                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

				
				if(parseInt(vself.psituacao)===0){
					vself.$refs.reflstpedidos.checkbox_rows = true
				}else{
					vself.$refs.reflstpedidos.checkbox_rows = false
				}
            }
        },
        computed:{
            validou(){
				return this.vidfilial === null || this.vidvendedor === null || this.vidcliente === '' || this.vidplano === null ||
				(this.lstitens.length === 0 && this.lstservicos.length === 0) || this.vdtemissao === null;
            },
            idclienteretorno(){
                return this.$store.state.clienteretornoconsulta.idcliente;
			},
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
		    listaprodutosretorno(){
                return this.$store.state.listaprodutosretornoconsulta.lstprod;
            },				
			manipulaval(){
				if (!this.alteraentra) {
					this.vtipodescacresedicao 	= 0;
					this.vvalordescacresedicao 	= 0;
					this.vtipodescacresedicao 	= 0;
					this.vdescacresedicao 	= 0;
				}
				switch (parseInt(this.vmanipulavaledicao)) {
					case 0:
						if (!this.alteraentra) {
							this.vvlunitarioedicao = this.vvltabelaitemedicao;
						}
						return true;
						break;
					case 1:
						return false;
						break;
				}
				this.alteraentra = false;
			},
			calculatotalitem() {
				let valdescacres 			= 0;
				let totaledicaosemimposto 	= 0;
				this.vldescmostrar			= 0;

				switch (parseInt(this.vtipodescacresedicao)) {
					case 0://Percentual
						valdescacres 		= this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						this.vldescmostrar 	= valdescacres;
						break;
					case 1://Valor
						valdescacres 		= this.vvalordescacresedicao;
						this.vldescmostrar 	= (valdescacres / (this.vqtditemedicao * this.vvlunitarioedicao) * 100).toFixed(2);
						break;
				}
				
				let ret = util.itemcomimposto(this.vdadosclasseitem, this.vvlunitarioedicao, this.vqtditemedicao, this.vdescacresedicao, valdescacres);								

				this.vvltotalimpostoitemedicao = ret.totalimpostoitem;
				this.vvltotaledicao 		   = ret.vltotalitem;
				
				this.mtdtpdescacres(this.vtipodescacresedicao);
			},
			calculatotalserv() {
				var valdescacres = 0;
				switch (parseInt(this.vtipodescontoservicoedicao)) {
					case 0://Percentual
						valdescacres = this.vqtdservicoedicao * this.vvlservicoedicao * this.vvalordescontoservicoedicao / 100;
						break;
					case 1://Valor
						valdescacres = this.vvalordescontoservicoedicao;
						break;
				}
				this.vvltotalservicoedicao = (this.vqtdservicoedicao * this.vvlservicoedicao) - valdescacres;
			},
			calculadescontototalitens(){
				if (parseInt(this.vtipodesctotal) === 0){
					this.vtotalcomdesconto = this.vtotalsemdesconto - (this.vtotalsemdesconto * this.vfatordescontototal / 100);
					this.vresdesconto	   = this.vfatordescontototal * this.vtotalsemdesconto / 100;						
				}else{
					this.vtotalcomdesconto = this.vtotalsemdesconto - this.vfatordescontototal;			
					this.vresdesconto	   = this.vfatordescontototal / this.vtotalsemdesconto * 100;			
				}
			},
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			},
            temItens(){
                return this.lstitensconf.length === 0
            } 						
        },
        watch:{
			vermelho(){
				if(!this.vermelho){
					this.vstyle = 'text-align:right; font-weight: bold; background: honeydew; color: green;'
				}else{
					this.vstyle = 'text-align:right; font-weight: bold; background: honeydew; color: rgb(128, 23, 0);'
				}
			},
			defsubs(){
				if(parseInt(this.defsubs)===1){	
					this.vermelho = false
				}else{
					this.vermelho = true
				}
			},
			psituacao(){
				if(parseInt(this.psituacao)===0){
					this.$refs.reflstpedidos.checkbox_rows = true
				}else{
					this.$refs.reflstpedidos.checkbox_rows = false
				}
			},
            pagina_atual(val){
                this.mtdcarregapedidos(val);
			},
            idclienteretorno(val){
                if (val !== null || val !== ''){
					this.vidcliente = val;
					this.mtdlocalizarcliente(this.vidcliente);					
                }
			},			
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
			listaprodutosretorno(val){
				this.processaprodutos(val);
			},			
			vdescacresedicao(){
				this.mtdtpdescacres(this.vtipodescacresedicao);
			},
			vtipodescacresedicao(val) {
				this.mtdtpdescacres(val);
        	},
			vtipodescontoservicoedicao(val){
				if (val == 0){
					this.vtitdescserv = 'Descto.(%):';
				}else{
					this.vtitdescserv = 'Descto.(R$):';
				}			
			},
			vtipodesctotal(){
				this.vfatordescontototal 	= 0;
				this.vresdesconto			= 0;
				this.vtotalcomdesconto 		= this.vtotalsemdesconto;
			},
			ventregaexterna(val){
				this.columnsi[8].visibility = val;
				for (let i = 0; i < this.lstitens.length; i++) {
					this.lstitens[i].qtdentregar = this.lstitens[i].qtditem;					
				}
			},
			pvisualizarcustos(val){
				this.columns[17].visibility = val;//índice da coluna do custo
			},
			pentregaexterna(){
				this.psituacaoentrega    = 2;
			},
			vachouPro(){
                this.vfaltaitens = true

                for (var i = 0; i < this.lstitensconf.length; i++) {									
                    if(this.lstitensconf[i]['qtdfalta'] > 0){
                        this.vfaltaitens = false
                        break
                    }
                }
                if(this.vfaltaitens){
                    this.vfinalizado = true
                    this.ativadesativacod = true
                    this.videscpro = ''
                    this.$nextTick(function () {
                        $("#btngravar").focus()
                    })              
                }
			} 
        },
        setup() {
            // //Obs, o audio possui 3 sons diferentes, o sprite abaixo, pega cada posição
            const { play } = useSound(conferenciaSfx, {
                sprite: {
                    concluido: [0, 350],    
                    faltando: [374, 540],
                    alerta: [998, 350]
                },
            })

            return {
                play,
            }
        }
    }
</script>
<style>
    #mdcorteitem{
        z-index: 20011!important;
    }
	.nav-link-ped{
		height: 45px!important;
	}
	.def-col-opcoes_ped{
		width: 70px !important;
	}
	.def-col-nrpedido{
		width: 150px;
	}
    .def-col-item{
        min-width: 55px !important;
	}	
    .def-col-coddig{
        min-width: 50px !important;
	}
	.def-col-unditem{
		min-width: 80px !important;
	}
	.def-col-formas{
		width: 115px;
	}	
	.def-col-cliente{
		width: 250px;
	}
	.dropdown-toggle::after { 
		display: none !important; 
	}
		.card-plano-pedido{
			margin-top: 6px;
			border: 1px solid #d8e2ea;
			border-radius: 10px;
			box-shadow: 0 6px 14px rgba(41, 67, 87, 0.08);
		}
		.card-plano-pedido .card-body{
			padding: 10px;
		}
		.draco-kpi-card{
			display: flex;
			flex-direction: column;
			gap: 3px;
			padding: 10px 12px;
			border-radius: 10px;
			border: 1px solid rgba(47, 108, 145, 0.18);
			background: linear-gradient(120deg, #f6fafc 0%, #edf5f9 100%);
			box-shadow: 0 4px 12px rgba(28, 48, 64, 0.08);
		}
		.draco-kpi-single{
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
		}
		.draco-kpi-label{
			font-size: 12px;
			color: #2f4a5d;
			font-weight: 700;
			letter-spacing: .01em;
		}
		.draco-kpi-value{
			font-size: 20px;
			font-weight: 800;
			color: #1e5f85;
		}
		.draco-kpi-money{
			font-size: 16px;
			font-weight: 800;
			color: #234f69;
		}
		.draco-kpi-success{
			border-color: rgba(44, 125, 94, 0.3);
			background: linear-gradient(120deg, #f2fbf7 0%, #e9f7ef 100%);
		}
		.draco-kpi-danger{
			border-color: rgba(201, 59, 59, 0.28);
			background: linear-gradient(120deg, #fff7f7 0%, #fdeeee 100%);
		}
		.draco-kpi-cyan{
			border-color: rgba(23, 126, 147, 0.3);
			background: linear-gradient(120deg, #f2fbfd 0%, #e8f7fa 100%);
		}
		.draco-kpi-lime{
			border-color: rgba(95, 143, 50, 0.34);
			background: linear-gradient(120deg, #f6fbe9 0%, #eef7dd 100%);
		}
		.draco-kpi-rose{
			border-color: rgba(176, 59, 95, 0.3);
			background: linear-gradient(120deg, #fff3f7 0%, #fde8f0 100%);
		}
		.draco-inline-total{
			display: flex;
			align-items: center;
			gap: 8px;
			margin-top: 8px;
			padding: 8px 10px;
			border: 1px solid rgba(31, 94, 123, 0.22);
			border-radius: 10px;
			background: #f8fbfd;
		}
		.draco-inline-total-label{
			color: #4f6272;
			font-weight: 700;
			font-size: 12px;
		}
		.draco-inline-total-meta{
			padding: 2px 8px;
			border-radius: 999px;
			background: #ddebf3;
			color: #225b7a;
			font-weight: 700;
			font-size: 11px;
		}
		.draco-inline-total-value{
			margin-left: auto;
			font-weight: 800;
			color: #1d5d7c;
		}
	#edtotalitenssemdesconto{
		background: #727cf5;
		font-weight: bold;
		text-align: right;
		font-size: 20px;
		color: white;
		border-color: #727cf5;
	}
	#edtotalitenscomdesconto{
		background: #0acf97;
		font-weight: bold;
		text-align: right;
		font-size: 20px;
		color: white;
		border-color: #0acf97;
	}
		#icone-entregar{
			color: #1f6a8f;
			position: relative;
			font-size: 15px;
			top: 1px;
			left: 8px;
			padding: 4px 5px;
			border-radius: 999px;
			background: rgba(31, 106, 143, 0.12);
			transition: 0.2s ease-in-out;
		}
		#lblentregar{
			cursor: pointer;
			font-weight: 700;
			color: #2b495f;
		}
		#lblentregar:hover #icone-entregar{
			background: rgba(31, 106, 143, 0.2);
			color: #154a66;
		}
		.icone-entrega-lista{
			color: #2f7aa0;
			margin-left: 5px;
			font-size: 13px;
			padding: 3px 4px;
			border-radius: 8px;
			background: rgba(47, 122, 160, 0.15);
		}
	.icone-entregafinalizada{
		position: relative;
		color: #f82b54!important;
		left: -8px;
		top: -2px;
		font-size: 10px;		
	}
	.btn-editaitementrega{
		width: 30px!important;
		font-size: 10px!important;
		padding: 2px !important;
	}
	.bdg-credito-disponivel{
		cursor: pointer;
		background-color: #28a745!important;
		margin-left : 3px;		
	}
	.bdg-credito-utilizado{
		cursor: pointer;
		background-color: #6c757d!important;
		margin-left : 3px;
	}
	.bdg-credito-saldo{
		cursor: pointer;
		background-color: #17a2b8!important;
		margin-left : 3px;
	}
	.item-lst-cred{
		padding: 5px!important;
	}	
    #btmarcartodaschecklist{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodaschecklist:hover{
        color: #666666;
        transition: .35s;
    }	
	.def-col-marca{
		min-width: 80px !important
    }
	.def-col-und{
		min-width: 80px !important
    }
    .def-col-qtd{
        min-width: 90px !important
    }
    .def-col-qtdconf{
        min-width: 90px !important
    }
    .def-col-qtdfalta{
        min-width: 90px !important
    }
    .bdg-alerta {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #c91212 !important;
        width: 100px;
    }
    .bdg-success {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #d7a519 !important;
        width: 100px;
    }
    .bdg-finalizado {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #28a745 !important;      
        width: 100px;
    }
    .slot_detalhes{
        width: 50px;
    }	
    .icon-detalhes{
        cursor: pointer;
        font-size: 22px;
        color: #d7a519;
    }
	.btncortaritem{
		width: 25px;
		height: 25px;
		padding: 0px!important;
		font-size: 12px;
	}	
	.icone-origem{
		color: #2f3c48;
		font-size: 20px;
		margin-left: 3px;
		margin-right: 3px;
	}	
</style>
